export const Portuguese = {
  lang: 'pt',
  wizard: {
    createAccount: 'Cria tua conta gratuita',
    noCreditCard: 'Sem cartão de crédito, cancele quando quiser',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    role: 'Posição',
    dialCode: 'País',
    fullNumber: 'País e telefone',
    password: 'Senha',
    saveButton: 'Mandar',
    captchaError: 'Captcha não foi validado',
    inputError: 'Preencha o campo',
    emailExistsError: 'O e-mail está em uso',
    emailCheckUnavailable:
      'Não conseguimos verificar este e-mail. Tente novamente em instantes.',
    passwordError: 'Deve ter pelo menos 6 caracteres',
    emailError: 'Digite um e-mail válido',
    emailInfo: 'Com este e-mail, você pode entrar na plataforma de aplicativos e web',
    privacyMessage: 'Ao clicar, você aceita que concorda com o ',
    privacy: 'Política de privacidade',
    preparingForm: 'Estamos criando sua conta e preparando o formulário',
    preparingForm2: 'Isso pode demorar alguns segundos',
    preparingForm3: 'Estamos preparando o formulário',
    userHasAccount: 'Você já tem uma conta?',
    login: 'Acessar',
    onboardingVideo:
      'Assista a este breve vídeo e descubra como o DataScope pode transformar seus processos e tornar seu trabalho mais fácil',
    onboardingVideoTitle: 'O que DataScope pode fazer por você?',
    onboardingVideoSkip: 'Continuar',
    onboardingResetModal: {
      title: 'Ainda não terminou de configurar sua conta',
      message:
        'Ainda não terminou de configurar sua conta. Você quer continuar onde parou ou começar de novo?',
      cancelButtonText: 'Começar de novo',
      confirmButtonText: 'Continuar',
      error: 'Erro ao restabelecer a informação da conta',
    },
    onboardingLogoutModal: {
      title: 'Tem certeza que deseja sair do processo de configuração?',
      message:
        'Se você sair, poderá retomar o processo de configuração mais tarde ao fazer login novamente.',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sair',
    },
    back: 'Voltar',
    intro: 'Olá! Vamos começar com o básico',
    introDescription:
      'Ajude-nos a conhecer você melhor para que possamos personalizar sua experiência e oferecer exatamente o que você precisa.',
    companyName: 'Nome da sua empresa',
    industry: 'Sua indústria',
    phoneNumber: 'Seu telefone',
    next: 'Próximo',
    firstNameError: 'Nome é obrigatório',
    lastNameError: 'Sobrenome é obrigatório',
    companyNameError: 'Nome da empresa é obrigatório',
    industryError: 'Indústria é obrigatório',
    phoneNumberError: 'Número de telefone deve ter pelo menos 8 dígitos',
    noResults: 'Nenhum resultado',
    searchCountry: 'Buscar país...',
    selectOption: 'Selecione uma opção',
    namePlaceholder: 'Escreva seu nome',
    companyPlaceholder: 'Escreva o nome da sua empresa',
    search: 'Buscar',
    formErrors: 'Por favor complete todos os campos obrigatórios',
    industries: {
      agriculture: 'Agricultura',
      food: 'Alimentos',
      automotive: 'Automóveis',
      construction: 'Construção',
      consulting: 'Consultoria',
      energy: 'Energia',
      facility: 'Facility Services',
      forestry: 'Forestal',
      engineering: 'Engenharia',
      cleaning: 'Limpeza e Manutenção',
      logistics: 'Logística',
      machinery: 'Maquinaria',
      manufacturing: 'Manufatura',
      mining: 'Mineração',
      retail: 'Varejo',
      public: 'Setor Público',
      environment: 'Serviços Ambientais',
      health: 'Serviços de Saúde',
      communication: 'Telecomunicações',
      transport: 'Transporte e Carga',
      wine: 'Vinhos',
    },
    roles: {
      management: 'Gerencia',
      consulting: 'Assistência ou Consultoria',
      owner: 'Proprietário/a',
      leadership: 'Liderança',
      student: 'Estudante',
      independent: 'Independente',
      analyst: 'Analista',
      other: 'Outro',
    },
    roleRequired: 'Por favor selecione um cargo',
    roleQuestion: 'Agora nos conte, qual é o seu cargo na organização?',
    roleQuestionDescription: 'Isso nos ajudará a fornecer uma melhor experiência',
    areas: {
      security: 'Segurança e higiene',
      quality: 'Qualidade',
      operations: 'Operações/Serviços (OT/OS)',
      audit: 'Auditoria',
      general: 'Uso geral',
    },
    areaRequired: 'Por favor selecione uma área',
    areaQuestion: 'Em qual área você gostaria de se concentrar hoje?',
    areaQuestionDescription: 'Selecione a área que mais lhe interessa',
    selectOptions: 'Selecione as opções que você gostaria de gerenciar',
    selectRequired: 'Por favor selecione pelo menos uma opção',
    interests: {
      security: {
        question: 'O que você gostaria de gerenciar em segurança e higiene?',
        options: {
          register_talks: 'Registro de palestras',
          fatality_risks: 'Riscos de fatalidade',
          risks_matrices: 'Matrizes de riscos',
          safety_work_analysis: 'Análise seguro do trabalho',
          accidents: 'Acidentes e incidentes',
          inspection_checklist: 'Checklist de inspeções',
          training_records: 'Registros de treinamento',
        },
      },
      quality: {
        question: 'O que você gostaria de gerenciar em qualidade?',
        options: {
          standard_procedures: 'Procedimentos Operacionais Padrão (POP)',
          preoperational_verifications: 'Verificações preoperacionais',
          quality_control: 'Controle de qualidade',
          audit_plans: 'Planos de auditoria',
          non_conformity_records: 'Registros de não conformidades',
          legal_records: 'Registros legais',
        },
      },
      operations: {
        question: 'O que você gostaria de gerenciar em operações?',
        options: {
          maintenance_programs: 'Programas de manutenção',
          calibrations: 'Calibrações',
          installations: 'Instalações',
          failure_records: 'Registros de falhas',
          daily_reports: 'Relatórios diários',
          certifications: 'Certificações',
          warranties: 'Garantias',
          consumption_records: 'Registros de consumo',
          progress_records: 'Registros de progresso',
        },
      },
      audit: {
        question: 'O que você gostaria de gerenciar em auditoria?',
        options: {
          quality_audits: 'Auditorias de qualidade',
          safety_audits: 'Auditorias de segurança e higiene',
          equipment_audits: 'Auditorias de equipamentos',
          norms_compliance: 'Cumprimento de normas',
          register_audits: 'Registros de auditorias',
          performance_evaluations: 'Avaliações de desempenho',
        },
      },
      general: {
        question: 'O que você gostaria de gerenciar em uso geral?',
        options: {
          polls: 'Enquetes',
          inventory: 'Controle de inventário',
          attendance: 'Controle de assistência',
        },
      },
    },
    moreThan: 'Mais de',
    selectOneOption: 'Por favor selecione uma opção',
    personnelCount: 'Quantas pessoas trabalham neste processo atualmente?',
    personnelCountDescription: 'Selecione o número de pessoas que utilizarão a plataforma',
    complete: 'Finalizar',
  },
  wizardFinish: {
    buildYourFirstForm: 'Crie seu primeiro formulário',
    yourPick: 'Sua escolha',
    formTemplates: 'Modelos de formulários',
    createForm: 'Criar formulário desde zero',
    importForm: 'Importar Google Form',
    welcome: 'Bem-vindo!',
    welcomeDescription1: 'De agora em diante, você poderá ',
    welcomeDescription2:
      'acessar a plataforma web e móvel utilizando as credenciais recém inseridas.',
    welcomeDescription3:
      'Lembre-se que para começar a coletar dados, você só precisa baixar o aplicativo da Google Play ou da App Store em seu telefone ou tablet.',
  },
  onboardingTemplates: {
    title: 'Recomendamos estes formulários com base no seu uso',
    subtitle: 'Selecione um para começar a trabalhar imediatamente',
    answerNow: 'Responder agora',
    exploreOthers: 'Explorar outros templates',
    aiFormBuilderCta: 'Crie seu formulário com IA em segundos.',
    aiFormBuilderLink: 'Abrir criador com IA',
    aiFormBuilderTitle: 'Crie seu formulário com IA em segundos',
    aiFormBuilderSubtitle:
      'Descreva o formulário que você precisa e nosso agente vai criá-lo em segundos.',
    aiFormBuilderButton: 'Criar com IA',
    recentlyViewedLabel: 'Visto recentemente',
    aiFormBuilderRecommendationsTitle: 'Recomendações de templates que você pode criar e usar',
    aiFormBuilderNoMatchText: 'Não encontrou o que procurava?',
    aiFormBuilderNoMatchButton: 'Crie um formulário com IA',
  },
  plannings: {
    integrations: {
      title: 'Integração Planejamento',
      gsheetsIntegrationLabel: 'Ir ao Google Sheets',
      gsheetsNewLinkUrl: 'https://sheets.new/',
      infoTextPart1:
        'Para garantir uma integração adequada, privada e segura, compartilhe seu documento com permissões de',
      infoTextPart2: 'editor',
      infoTextPart3: 'somente para',
      inputLabel: 'Novo link',
      inputPlaceholder: 'Insira o link do documento para integrar',
      optional: '(Opcional)',
      save: 'Salvar',
      cancel: 'Cancelar',
      copyUrl: 'URL copiada!',
      copyEmail: 'E-mail copiado!',
      created: 'Integração configurada com sucesso!',
      saved: 'Alterações salvas com sucesso!',
      deleted: 'Integração removida com sucesso',
      savingError: 'Erro ao configurar a integração',
      removeTitle: 'Remover a integração com Google Sheets?',
      removeBody:
        'A planilha deixará de receber atualizações do planejamento do DataScope. O documento no Google Drive não é excluído.',
      removeConfirm: 'Remover integração',
      removeCancel: 'Cancelar',
    },
    title: 'Planejamentos',
    subtitle: 'Gerencie planejamentos de tarefas recorrentes com responsáveis e progresso.',
    new: 'Novo planejamento',
    create: 'Criar',
    planningTypes: 'Modelos',
    import: 'Importar',
    export: 'Exportar',
    search: 'Buscar por nome do planejamento',
    clearFilters: 'Limpar filtros',
    actions: 'Ações',
    of: 'de',
    loading: 'Carregando planejamentos…',
    pricing: {
      inUse: 'em uso',
      quotaTooltip:
        'Contam os planejamentos ativos, atrasados e pausados. Rascunhos e arquivados não consomem cota.',
      legend:
        'Seu plano inclui {limit} planejamentos em uso ao mesmo tempo (ativos, atrasados ou pausados). Rascunhos e arquivados não consomem cota.',
      nearLimitWarning:
        'Resta 1 planejamento disponível no seu plano. Os concluídos ou arquivados liberam cota.',
      limitModal: {
        title: 'Limite de planejamentos atingido',
        description:
          'Seu plano Professional inclui até {limit} planejamentos em uso ao mesmo tempo (ativos, atrasados ou pausados). Rascunhos e arquivados não consomem cota.',
        feature1: 'Planejamentos ilimitados com o plano Enterprise',
        feature2: 'Cobre toda a sua operação sem liberar cota a cada vez',
        feature3: 'Sua equipe continua operando sem interrupções',
        upgradeButton: 'Desbloquear planejamentos ilimitados',
        continueButton: 'Continuar no meu plano atual',
        upgradeIntercomMessage: 'Olá, quero ampliar meu plano para ter planejamentos ilimitados.',
      },
      landing: {
        title: 'Planeje e acompanhe sua operação',
        question: 'Para que usar Planejamentos?',
        intro: 'Com esta funcionalidade é possível:',
        bullet1:
          'Agrupar tarefas sob um plano de segurança, manutenção, auditoria ou qualidade, com responsáveis e período definidos.',
        bullet2:
          'Ver o avanço de cada plano em tempo real, sem perseguir ninguém nem montar planilhas.',
        bullet3: 'Detectar planejamentos atrasados a tempo, antes que virem um problema.',
        knowPlans: 'Conhecer os planos',
        contactSales: 'Falar com vendas',
        availability: 'Disponível nos planos Professional e Enterprise.',
        contactSalesIntercomMessage:
          'Olá, quero saber mais sobre Planejamentos e os planos que o incluem.',
        demoTitle: 'Assim funciona na sua operação',
        demoMobileTitle: 'Sua equipe executa pelo app móvel',
        demoMobileBody:
          'As tarefas de cada plano chegam ao app da equipe em campo. Cada resposta atualiza o avanço do plano automaticamente.',
        demoWebTitle: 'Você acompanha o avanço pela web',
        demoWebBody:
          'A visão de planejamentos mostra o progresso, os responsáveis e o status de cada plano em tempo real. Os atrasados são marcados sozinhos.',
        previous: 'Anterior',
        next: 'Próximo',
        webImageAlt: 'Visão de planejamentos na web',
        mobileTasksAlt: 'Tarefas do plano no app móvel',
        mobileDoneAlt: 'Plano concluído no app móvel',
      },
    },
    createMenu: {
      planning: 'Criar planejamento',
      planningType: 'Criar modelo',
    },
    stateTabs: {
      all: 'Todas',
      active: 'Ativas',
      completed: 'Concluídas',
      archived: 'Arquivadas',
      late: 'Atrasadas',
      draft: 'Rascunhos',
      paused: 'Pausadas',
    },
    filterChips: {
      date: 'Data',
      datePopover: 'Selecione o intervalo de datas',
      location: 'Local',
      locationPopover: 'Filtrar por local',
      supervisor: 'Supervisor',
      supervisorPopover: 'Filtrar por supervisor',
      planningType: 'Tipo',
      planningTypePopover: 'Filtrar por tipo',
      planningTypeSearch: 'Buscar tipo',
      asset: 'Ativo',
      assetPopover: 'Filtrar por ativo',
      assetSearch: 'Buscar ativo',
      empty: 'Sem resultados',
      allTab: 'Todos',
      groupTab: 'Grupos',
    },
    columns: {
      code: 'ID',
      name: 'Planejamento',
      asset: 'Ativo',
      period: 'Período',
      progress: 'Progresso',
      state: 'Status',
      supervisor: 'Supervisor',
      planningType: 'Modelo',
    },
    assetsView: {
      viewLabel: 'Vista:',
      toggleGeneral: 'Geral',
      toggleAssets: 'Ativos',
      activePlanningOne: '1 planejamento ativo',
      activePlanningOther: '{count} planejamentos ativos',
      next: 'Próximo:',
      nextPlanning: 'Próximo planejamento:',
      nextPlanningToday: 'Hoje',
      nextPlanningInDaysOne: 'Em 1 dia',
      nextPlanningInDaysOther: 'Em {days} dias',
      unassignedPlanning: 'Planejamento sem ativo',
      temporalCycleType: 'Temporal',
      columns: {
        type: 'Tipo',
        id: 'ID',
        projectedDate: 'Data projetada',
        executionDate: 'Data de execução',
        completion: 'Conclusão',
        state: 'Status',
      },
      cycleStates: {
        completed: 'Concluído',
        pending: 'Agendado',
        in_progress: 'Em andamento',
        draft: 'Rascunho',
        active: 'Ativo',
        paused: 'Pausado',
        late: 'Atrasado',
        archived: 'Arquivado',
      },
    },
    timeline: {
      toggleTable: 'Tabela',
      toggleTimeline: 'Cronograma',
      today: 'Hoje',
      emptyState: {
        title: 'Você não tem planejamentos disponíveis',
        hint: 'Crie um ou ajuste os filtros',
      },
      loadError: {
        title: 'Não foi possível carregar o cronograma',
        hint: 'Ocorreu um erro. Por favor, tente novamente.',
      },
      tooltip: {
        stateScheduled: 'Status: Programado',
        stateInProgress: 'Status: Em andamento',
        stateCompleted: 'Status: Concluído',
        stateCompletedLate: 'Status: Concluído com atraso',
        stateOverdue: 'Status: Atrasado',
        statePaused: 'Status: Pausado',
        statePausedMeterInactive: 'Sem atividade do medidor',
        statePausedAssetDeactivated: 'Ativo desativado',
        pendingTasksOne: '1 tarefa pendente',
        pendingTasksOther: '{count} tarefas pendentes',
        windowLabel: 'Janela',
        realizedLabel: 'Realizado',
      },
      enterprise: {
        badge: 'Recurso Enterprise',
        title: 'Visualize todo o seu planejamento mensal em uma única tela',
        description:
          'Deixe as planilhas paralelas para trás e mantenha todo o seu planejamento de manutenção organizado em uma única visão.',
        bullet1: 'Veja todas as manutenções do mês em uma única visão.',
        bullet2: 'Detecte atrasos e manutenções sobrepostas antes que afetem a operação.',
        bullet3: 'Compartilhe o plano com sua equipe em PDF.',
        cta: 'Atualizar plano',
      },
      export: {
        pdf: 'PDF',
        excel: 'Excel',
        generating: 'Gerando cronograma PDF...',
        ready: 'Seu arquivo está pronto. O download começará em alguns segundos.',
        failed: 'Não foi possível gerar o arquivo. Tente novamente.',
        noResultsToExport: 'Não há resultados para exportar',
      },
      drawer: {
        openPlanning: 'Abrir planejamento',
        close: 'Fechar',
      },
      rowsHeaderGeneral: 'Planejamentos',
      rowsHeaderActivos: 'Ativos',
      legend: {
        temporal: 'Temporal',
      },
      print: {
        title: 'Cronograma de planejamentos',
        assetTypesLabel: 'Tipo de ativo',
        locationsLabel: 'Local',
        joinTwo: '{first} e {second}',
        andMore: '{first} e mais {count}',
        pageFooterLabel: 'Página',
      },
    },
    editedIndicator: 'Modificada',
    rowActions: {
      detail: 'Ver detalhe',
      edit: 'Editar',
      continueEditing: 'Continuar editando',
      pause: 'Pausar',
      resume: 'Retomar',
      archive: 'Arquivar',
      unarchive: 'Desarquivar',
      delete: 'Excluir',
    },
    editPublished: {
      title: 'Editar planejamento',
      back: 'Voltar a Planejamentos',
      backLink: 'Voltar',
      nameLabel: 'Nome',
      save: 'Salvar alterações',
      cancel: 'Cancelar',
      next: 'Próximo',
      stepBack: 'Voltar',
      confirmTitle: 'Editar planejamento',
      appliesNow: 'O nome e os supervisores são atualizados imediatamente.',
      appliesNextCycle: 'A frequência e o template aplicam a partir do próximo ciclo.',
      step1AlertTemporal:
        'Ao salvar, o nome e os supervisores são atualizados imediatamente. A frequência e a data de término serão aplicadas a partir do próximo ciclo.',
      step1AlertTemporalNoFreq:
        'Ao salvar, o nome e os supervisores são atualizados imediatamente. A frequência e a data de término não podem ser alteradas para este tipo de planejamento.',
      step1AlertMeter:
        'Ao salvar, o nome e os supervisores são atualizados imediatamente. O motor de predição será recalculado automaticamente com a nova configuração.',
      step2Alert:
        'As alterações nas tarefas serão aplicadas a partir do próximo ciclo. Se precisar adicionar ou remover responsáveis do ciclo atual, faça isso no detalhe do planejamento.',
      step2AlertShared:
        'Os responsáveis são editados uma única vez na lista e a alteração se aplica a todas as tarefas: adicionar uma pessoa aplica a partir de agora; removê-la vale a partir do próximo ciclo e não apaga o que já foi feito.',
      tasksSectionTitle: 'Tarefas do planejamento',
      lockedTypeTooltip: 'O tipo de planejamento não pode ser alterado depois de publicado.',
      lockedStartDateTooltip:
        'A data de início não pode ser alterada depois que o planejamento é publicado.',
      lockedAssetTooltip: 'O ativo não pode ser alterado depois que o planejamento é publicado.',
      lockedEntryPointTooltip:
        'A última manutenção declarada é definida na criação e não muda após a publicação.',
      confirmSupervisorsImmediate:
        'As alterações nos supervisores serão refletidas imediatamente, inclusive no ciclo em andamento.',
      confirmScheduleNextCycle:
        'As alterações na frequência e na data de término serão refletidas a partir do próximo ciclo do planejamento.',
      confirmMeterImmediate: 'As alterações no nome e nos supervisores serão aplicadas imediatamente.',
      confirmMeterEngineNextRecalc:
        'As alterações na configuração do motor de predição serão consideradas a partir do próximo recálculo do planejamento.',
      confirmMeterImmediateAndEngine:
        'As alterações nos supervisores serão aplicadas imediatamente. As alterações na configuração do motor de predição serão consideradas para calcular os próximos planejamentos a partir do próximo recálculo.',
      responsibles: {
        title: 'Responsáveis das tarefas',
        subtitle: 'Definidos uma vez e aplicados a todas as tarefas deste planejamento.',
        empty: 'Sem responsáveis. O planejamento para de gerar tarefas até adicionar alguém.',
        add: 'Adicionar responsável',
        addLink: 'Adicionar responsáveis',
        groupSuffix: 'grupo',
        groupsNote:
          'Escolhe-se um grupo. A tarefa é atribuída ao grupo (uma resposta por grupo); não se mistura com usuários individuais.',
        removeTitle: 'Remover responsável',
        removeExplanation: 'Para de receber tarefas a partir do próximo ciclo. O já feito é mantido.',
        cancelOpenTasks: 'Cancelar também as tarefas pendentes do ciclo atual',
        remove: 'Remover',
        confirmNameSupervisorsImmediate:
          'As alterações no nome e nos supervisores serão aplicadas imediatamente.',
        confirmFrequencyNextCycle:
          'As alterações na frequência serão refletidas a partir do próximo ciclo.',
        addedNote:
          '{names} adicionado. Aplica a partir de agora a todas as tarefas deste planejamento, no ciclo em andamento e nos próximos.',
        removedNote:
          '{names} deixará de receber tarefas deste planejamento a partir do próximo ciclo. As tarefas já concluídas não serão afetadas.',
        cancelPendingLabel: 'Cancelar também as tarefas pendentes deste ciclo',
        cancelPendingHint: 'As tarefas serão marcadas como Canceladas e permanecerão no histórico.',
      },
    },
    toasts: {
      archived: '"{name}" arquivado',
      unarchived: '"{name}" está vigente novamente',
      deleted: 'Planejamento excluído',
      savedChanges: 'Alterações salvas',
      error: 'Não foi possível concluir a ação.',
    },
    states: {
      all: 'Todos',
      draft: 'Rascunho',
      active: 'Ativa',
      paused: 'Pausada',
      late: 'Atrasada',
      archived: 'Arquivada',
    },
    counts: {
      total: 'Total de planejamentos',
      active: 'Ativos',
      paused: 'Pausados',
      late: 'Atrasados',
      archived: 'Arquivados',
      draft: 'Rascunhos',
    },
    frequencies: {
      daily: 'Diária',
      weekly: 'Semanal',
      biweekly: 'Quinzenal',
      monthly: 'Mensal',
      quarterly: 'Trimestral',
      semiannual: 'Semestral',
    },
    cycleWord: {
      daily: 'Dia',
      weekly: 'Semana',
      biweekly: 'Ciclo',
      monthly: 'Mês',
      quarterly: 'Trimestre',
      semiannual: 'Semestre',
    },
    pagination: {
      results: 'Resultados',
      previous: 'Anterior',
      next: 'Próximo',
    },
    empty: {
      title: 'Nenhum planejamento ainda',
      hint: 'Crie seu primeiro planejamento ou ajuste os filtros.',
    },
    filters: {
      state: 'Status',
      asset: 'Ativo',
      planningType: 'Modelo',
      supervisor: 'Supervisor',
      dateFrom: 'De',
      dateTo: 'Até',
      anyType: 'Qualquer modelo',
      anyAsset: 'Qualquer ativo',
    },
    error: {
      loadList: 'Não foi possível carregar os planejamentos',
      createPlanning: 'Não foi possível criar o planejamento',
      createTaskAssign: 'Não foi possível criar a tarefa',
      publish: 'Não foi possível publicar o planejamento',
    },
    wizard: {
      title: 'Criar planejamento',
      cancel: 'Cancelar',
      back: 'Voltar',
      next: 'Próximo',
      saveDraft: 'Salvar rascunho',
      publish: 'Criar',
      details: {
        planningType: 'Modelo',
        planningTypeStandalone: 'Planejamento padrão (Sem personalizar)',
        name: 'Nome do planejamento',
        namePlaceholder: 'Escreva o nome',
        startDate: 'Data de início',
        startDatePlaceholder: 'Selecione a data',
        frequency: 'Frequência do planejamento',
        ends: 'Finalização:',
        endsNever: 'Nunca',
        endsDate: 'Data:',
        endsDatePlaceholder: 'DD/MM/AAAA',
        endsMaxReps: 'Após:',
        endsMaxRepsUnit: 'repetições',
        supervisor: 'Supervisor',
        supervisorPlaceholder: 'Selecione os supervisores',
        asset: 'Ativo',
        assetRequired: 'Este tipo requer um ativo',
        location: 'Local',
        locationPlaceholder: 'Selecione uma localização',
      },
      meter: {
        strategyPreviewTitle: 'Pré-visualização da estratégia',
        cumulativeLabel: 'Usar programação acumulativa',
        asset: 'Ativo',
        assetPlaceholder: 'Selecione um ativo',
        planningConfigTitle: 'Configuração do planejamento',
        predictionConfigTitle: 'Configuração do motor de predição',
        predictionSubtitle:
          'Os responsáveis serão notificados ao iniciar a janela de execução de cada planejamento',
        assetMeterHelper: 'Você só verá os ativos que têm um medidor associado',
        noAssetsForMeter: 'Não existem ativos com {meter} configurado.',
        configureAssets: 'Configurar ativos',
        locationLabel: 'Local',
        locationFromAsset: 'Preenchido pelo ativo',
        predictionTitle: 'Motor de predição',
        modeAutomatic: 'Cálculo automático',
        modeAutomaticDesc: 'Usa o histórico de leituras do medidor para projetar as datas',
        modeAutomaticDisabledDesc:
          'Este ativo não tem leituras suficientes do horímetro para calcular a média automaticamente.',
        modeManual: 'Inserir média manualmente',
        modeManualDesc: 'Você define a média de uso diária',
        calculationWindowLabel: 'Intervalo de cálculo',
        calculationWindowSuffix: 'meses atrás',
        perDay: '{unit}/dia',
        manualDailyAverageLabel: 'Média de uso',
        currentValueLabel: 'Medição atual',
        rateLine:
          'Taxa: {rate} {unit}/dia, com base em {reading_count} leituras nos últimos {effective_window_months} meses',
        projectionTitle: 'Projeção dos próximos planejamentos',
        projectedDateLabel: 'Data projetada',
        entryTitle: 'Última manutenção executada',
        entrySubtitle:
          'Opcional. Declare de onde vem o ativo para que o ciclo comece daí e não considere tudo o anterior como feito.',
        entryClear: 'Remover',
        entryMilestoneLabel: 'Marco executado',
        entryMilestonePlaceholder: 'Selecione um marco',
        entryMilestoneHint: 'Escolha o ativo primeiro para ver os marcos disponíveis.',
        entryReadingLabel: 'Leitura na execução',
        entryLockedSubtitle: 'Declarado na criação e congelado após a publicação.',
        entryRejectedByServer: 'O servidor rejeitou esta declaração. Escolha o marco novamente.',
        entryRejectedByServerReading: 'O servidor rejeitou esta declaração. Verifique a leitura.',
        entryReadingOutOfRange: 'Deve estar entre {min} e {max} para este marco.',
        entryAboveCurrentNote:
          'A leitura declarada é maior que a leitura atual do medidor ({current}). É aceito: normalmente significa que a leitura registrada está atrasada.',
        entryDueCount: 'O ativo entra com {count} manutenções por executar: {list}.',
        entryDueCountOne: 'O ativo entra com 1 manutenção por executar: {list}.',
        entryNoneDue: 'O ativo entra em dia: o medidor não passou nenhuma manutenção por executar.',
        entryNotDeclaredHint:
          'Sem declarar a última manutenção, assume-se que tudo antes de {value} já foi executado.',
        recalcNote:
          'As datas e janelas são recalculadas automaticamente conforme a atividade recente do medidor.',
        clampWarning:
          'O intervalo solicitado excede o histórico disponível do ativo. Será calculado com as leituras registradas entre {start} e {end}.',
        emptyState: 'Dados insuficientes; insira uma média manual',
        windowTooNarrow:
          'Não há suficientes leituras no intervalo selecionado. Amplie a janela de cálculo.',
        manualPending:
          'Estas projeções serão ajustadas automaticamente quando houver dados reais suficientes do medidor.',
        errorState: 'Não foi possível calcular a projeção.',
        retry: 'Tentar novamente',
        levelEvery: 'A cada {interval} {unit}',
        ownCount: '{count} tarefas deste nível',
        inheritedCount: '{count} herdadas',
        inheritedSuffix: ' (Herdada)',
        inheritedFrom: '(Herdada de {code})',
        editForLevel: 'Editar a tarefa apenas para {code}',
        createTask: 'Criar tarefa',
        taskCreated: 'Tarefa criada',
        estimatedDate: 'Data estimada da tarefa',
        estimatedStart: 'Início estimado',
        estimatedEnd: 'Fim estimado',
        basedOnTitle: 'Baseado em:',
        basedOnAverage: 'Uso médio do medidor',
        basedOnHistory: 'Histórico do ativo',
        basedOnStrategy: 'Estratégia mega ciclo de planejamentos',
        estimatedDatePending: 'Sem data estimada disponível',
        readOnlyTitle: 'Data estimada',
        readOnlySubtitle:
          'As datas são calculadas a partir da projeção do medidor e não podem ser editadas.',
        levelsEmpty: 'Selecione uma estratégia para ver os níveis',
        emptyLevel: 'Este nível não tem formulários associados',
      },
      tasks: {
        introStandalone:
          'Para criar este planejamento, você deve atribuir formulários e criar tarefas com eles',
        introPreset: 'Para criar este planejamento, atribua os seguintes formulários como tarefas',
        addForm: 'Adicionar formulário',
        createTask: 'Criar tarefa',
        taskCreated: 'Tarefa criada',
        editTask: 'Editar tarefa',
        editTaskOf: 'Editar tarefa de:',
        nextCycle: 'Próximo ciclo:',
        dateSeparator: 'a',
        dateSeparatorSameDay: 'às',
        notifySuccess: 'Notificação enviada',
        loadingPlanning: 'Criando planejamento…',
        removeForm: 'Remover formulário',
        emptyTypeTitle: 'Este modelo ainda não tem formulários associados',
        emptyTypeLink: 'Atribuir formulários ao tipo',
        sharedResponsiblesRequired: 'Adicione responsáveis primeiro. As tarefas herdam essa lista.',
        sharedResponsiblesSaving: 'Salvando responsáveis…',
      },
      taskDialog: {
        title: 'Criar tarefa',
        mobileUser: 'Responsável',
        location: 'Local',
        cycleDay: 'Dia do ciclo',
        durationHours: 'Duração (horas)',
        description: 'Descrição',
        scheduledSendDaysBefore: 'Agendar envio (dias antes)',
        submit: 'Salvar tarefa',
        cancel: 'Cancelar',
      },
      validation: {
        required: 'Obrigatório',
        invalid: 'Valor inválido',
        endDateRequired: 'A data de término é obrigatória.',
        publishMismatch: 'Faltam ou sobram tarefas para o set fechado de formulários.',
        publishMissingForms: 'Adicione ao menos um formulário antes de publicar.',
        publishGeneric: 'Não foi possível publicar o planejamento.',
        formSyncError: 'Não foi possível salvar as alterações nos formulários. Tente novamente.',
        publishNoAccess: 'Seu plano não inclui Planejamentos. Conheça os planos que o incluem.',
      },
    },
    detail: {
      back: 'Voltar a Planejamentos',
      actionsMenu: 'Mais ações',
      history: {
        title: 'Histórico de alterações',
        close: 'Fechar',
        empty: 'Sem alterações registradas.',
        addedResponsible: 'Adicionou',
        removedResponsible: 'Removeu',
        updatedResponsibles: 'Atualizou responsáveis',
        effect: {
          immediate: 'Aplica imediatamente',
          next_cycle: 'Aplica a partir do próximo ciclo',
          next_recalc: 'Aplica no próximo recálculo',
        },
        fields: {
          name: 'Nome',
          frequency: 'Frequência',
          ends: 'Finalização',
          end_date: 'Data de término',
          max_reps: 'Repetições',
          supervisors: 'Supervisores',
          cumulative: 'Programação acumulativa',
          manual_daily_average: 'Média diária manual',
          calculation_window_months: 'Janela de cálculo',
          prediction_mode: 'Modo de previsão',
        },
        endsValues: {
          never: 'Nunca',
          end_date: 'Em uma data',
          max_reps: 'Após N repetições',
        },
      },
      meter: {
        nextPlanning: 'Próximo planejamento',
        available: 'disponível',
        overdue: 'atrasada',
        remaining: 'Faltam',
        daysRemaining: '~{days} dias',
        cumulative: 'Programação acumulativa',
        closed: 'Programação fixa',
        currentReading: 'Leitura atual',
        currentReadingDynamic: '{meter} atual',
        lastCompletedLabel: 'Último ciclo concluído',
        lastCompletedAt: 'Executado em {value}',
        lastReading: 'Última leitura: {when}',
        projectedDate: 'Data projetada',
        lastRecalc: 'Último recálculo: {when}',
        usageRate: 'Taxa de uso',
        ratePerDay: '{value}/dia',
        rateWindow: 'média dos últimos {months} meses',
        rateManual: 'taxa manual',
        noRate: 'Sem taxa disponível',
        responsibles: 'Responsáveis',
        asset: 'Ativo',
        strategyTitle: 'Estratégia {name} - {total}',
        tasksCount: '{count} tarefas',
        tasksCountOne: '1 tarefa',
        projectionTitle: 'Projeção de planejamento',
        columns: {
          id: 'ID',
          type: 'Tipo',
          reading: 'Leitura',
          date: 'Data',
          projectedDate: 'Data projetada',
          tasks: 'Tarefas',
          participants: 'Participantes',
          state: 'Estado',
          milestone: 'Período',
        },
        tasksInherited: '{count} tarefas + {inherited} herdadas',
        tasksOnly: '{count} tarefas',
        inheritedFrom: 'Herdada de {code}',
        status: {
          pending: 'Pendente',
          in_progress: 'Em andamento',
          completed: 'Concluída',
        },
        noEstimate: 'Sem data estimada',
        notAvailable: 'Não disponível',
        pausedChip: 'Pausado',
        assetDeactivated: 'Desativado',
        assetInactive: 'Sem atividade há {days} dias',
        pausedBannerAssetDeactivated:
          'A projeção do planejamento está pausada até que o ativo seja reativado',
        pausedBannerMeterInactive:
          'A projeção do planejamento está pausada até que o ativo volte a registrar atividade.',
        pausedBannerManual: 'A projeção do planejamento está pausada.',
        projectedDateTooltip: 'Última data projetada antes de pausar o planejamento',
        emptyMilestones: 'Sem projeção disponível',
        unassignedTask: 'Não atribuído',
        inheritedSuffix: ' (Herdada)',
        configTitle: 'Configuração da projeção',
        windowLabel: 'Janela de cálculo',
        windowHelp: 'Leituras históricas usadas para calcular a taxa de uso',
        windowValue: '{months} meses',
        rateLabel: 'Taxa de uso',
        rateHelp: 'Média diária de uso do equipamento',
        lastUpdate: 'Última atualização: {when}',
        recalcAuto: '(recálculo automático)',
        readingsTitle: 'Leituras recentes do medidor',
        readingsColumns: {
          date: 'Data',
          origin: 'Origem',
          value: 'Valor',
        },
        viewAll: 'Ver histórico completo',
        emptyReadings: 'Sem leituras registradas',
        today: 'Hoje',
        yesterday: 'Ontem',
      },
      cycleNav: 'Ciclo',
      sectionInfo: 'Informações do planejamento',
      sectionTasks: 'Tarefas do plano',
      updatedAgo: 'Atualizado há {when}',
      newTask: 'Nova tarefa',
      searchTasks: 'Buscar por nome do formulário',
      emptyTasks: 'Sem tarefas disponíveis',
      tasksCompleted: '{completed}/{total} tarefas concluídas',
      planCompleted: 'Parabéns! Sua equipe concluiu todas as tarefas com sucesso',
      cycleLabel: {
        daily: 'Dia',
        weekly: 'Semana',
        biweekly: 'Quinzena',
        monthly: 'Mês',
        quarterly: 'Trimestre',
        semiannual: 'Semestre',
      },
      cycleList: {
        searchPlaceholder: 'Buscar por data ou período',
        goToCurrent: 'Ver período atual',
        empty: 'Sem ciclos para mostrar',
        noResults: 'Sem resultados',
      },
      columns: {
        id: 'ID',
        form: 'Formulário',
        user: 'Usuário',
        userAndGroups: 'Usuários e grupos',
        startDate: 'Data de início',
        state: 'Estado',
        responses: 'Respostas',
        actions: 'Ações',
        duration: 'Duração: {value}',
      },
      responses: '{count}/{total} responderam',
      userFilter: {
        title: 'Usuários',
        popover: 'Filtrar por usuário',
        empty: 'Sem usuários',
      },
      tabs: {
        all: 'Todas',
        pending: 'Atribuídas',
        accepted: 'Aceitas',
        completed: 'Concluídas',
        incomplete: 'Incompletas',
        rejected: 'Rejeitadas',
        cancelled: 'Canceladas',
      },
      taskStatus: {
        sent: 'Atribuída',
        pending: 'Atribuída',
        in_progress: 'Aceita',
        accepted: 'Aceita',
        completed: 'Concluída',
        rejected: 'Rejeitada',
        incomplete: 'Incompleta',
        cancelled: 'Cancelada',
        scheduled: 'Agendada',
        deleted: 'Excluída',
      },
      rowActions: {
        menuLabel: 'Ações da tarefa',
        detail: 'Editar',
        viewAnswer: 'Ver resposta',
        reassign: 'Reatribuir tarefa',
        notify: 'Notificar',
        cancel: 'Cancelar',
        delete: 'Excluir',
      },
      cancel: {
        title: 'Cancelar tarefa',
        subtitle: 'Esta ação é irreversível. Informe o motivo do cancelamento.',
        reason: 'Motivo',
        reasonPlaceholder: 'Escreva o motivo aqui…',
        confirm: 'Cancelar tarefa',
        keep: 'Voltar',
        errorAlreadyCompleted: 'Você não pode cancelar uma tarefa já concluída.',
        errorAlreadyCancelled: 'Esta tarefa já foi cancelada.',
        errorMissingReason: 'O motivo é obrigatório.',
        errorGeneric: 'Não foi possível cancelar a tarefa.',
      },
      reassign: {
        title: 'Reatribuir tarefa',
        subtitle: 'Escolha um novo responsável.',
        confirm: 'Reatribuir',
        groupLabel: 'Grupo',
        errorGeneric: 'Não foi possível reatribuir a tarefa.',
        selectResponsible: 'Selecione o responsável',
        selectPlaceholder: 'Selecione um responsável',
        search: 'Buscar',
        bannerText:
          'Esta alteração se aplica apenas a este ciclo da tarefa. Os próximos ciclos continuarão atribuídos a',
        rowTooltipLead: 'Responsável modificado para este ciclo.',
        rowTooltipOriginal: 'Original: {name}',
      },
      pause: {
        title: 'Pausar planejamento',
        body: 'As tarefas do ciclo atual continuarão visíveis. Nenhum novo ciclo será criado até retomar.',
        confirm: 'Pausar',
      },
      resume: {
        title: 'Retomar planejamento',
        body: 'O planejamento volta a ficar ativo. A data final será estendida pelos dias pausados.',
        confirm: 'Retomar',
      },
      archive: {
        title: 'Arquivar planejamento',
        body: 'O planejamento vai para Arquivados e suas tarefas pendentes ficam congeladas. Você pode desarquivá-lo quando quiser.',
        confirm: 'Arquivar',
      },
      delete: {
        title: 'Excluir planejamento',
        body: 'Você vai remover "{name}" da sua visão. Esta ação é irreversível: seus dados são mantidos no sistema, mas você não poderá recuperá-lo daqui.',
        confirm: 'Excluir',
      },
      lifecycleErrors: {
        not_in_draft: 'Este planejamento já foi publicado.',
        missing_forms: 'Adicione ao menos um formulário antes de publicar.',
        forms_mismatch: 'O ciclo 0 não cobre exatamente os formulários requeridos.',
        already_paused: 'Este planejamento já está pausado.',
        not_paused: 'Apenas planejamentos pausados podem ser retomados.',
        already_archived: 'Este planejamento já foi arquivado.',
        not_archived: 'Apenas planejamentos arquivados podem ser desarquivados.',
        rule_completed:
          'Não é possível desarquivar: a agenda do planejamento já foi concluída. Estenda a agenda antes de desarquivar.',
        generic: 'Não foi possível concluir a ação.',
      },
    },
    importDrawer: {
      title: 'Importar planejamentos',
      close: 'Fechar',
      step1: {
        title: 'Passo 1: Baixe o arquivo',
        description:
          'Baixe o arquivo de exemplo. Conterá uma planilha para configurar planejamentos e outra planilha para configurar as tarefas. Preencha os campos marcados com * para importar corretamente.',
        download: 'Baixar modelo',
      },
      step2: {
        title: 'Passo 2: Edite o arquivo',
        description: 'Preencha a Aba 1 (Planejamentos) e a Aba 2 (Tarefas) seguindo o formato.',
      },
      step3: {
        title: 'Passo 3: Envie o arquivo',
        dropZone: 'Arraste e solte seu arquivo aqui ou selecione do seu computador.',
        browse: 'Selecionar arquivo',
        upload: 'Enviar',
      },
      result: {
        title: 'Resultado do import',
        plannings_created: 'Planejamentos criados',
        plannings_published: 'Planejamentos publicados',
        tasks_created: 'Tarefas criadas',
        failed: 'Falharam',
        skipped: 'Ignorados',
        back: 'Tentar novamente',
        errors: 'Erros',
        details: 'Ignorados e avisos',
        sheet: 'Aba',
        row: 'Linha',
        message: 'Mensagem',
        statuses: {
          pending: 'Pendente',
          processing: 'Processando',
          completed: 'Concluído',
          failed: 'Falhou',
        },
        entryStatuses: {
          skipped: 'Ignorada',
          warning: 'Aviso',
        },
        sheets: {
          plannings: 'Planejamentos',
          tasks: 'Tarefas',
        },
        errors_global: {
          file_unreadable:
            'Não foi possível ler o arquivo. Certifique-se de que seja um Excel válido (.xlsx) gerado a partir do modelo.',
          missing_tasks_sheet:
            'A planilha "Tarefas" está faltando no arquivo. Baixe o modelo e use-o como base.',
          s3_download_failed: 'O arquivo não pôde ser recuperado. Por favor, envie-o novamente.',
          unknown_error:
            'Ocorreu um erro inesperado durante a importação. Se persistir, entre em contato com o suporte.',
        },
        draftsCreatedWarningOne:
          '{count} planejamento foi criado como rascunho antes da falha da importação. Você pode revisá-lo e publicá-lo manualmente a partir da lista, ou excluí-lo.',
        draftsCreatedWarningOther:
          '{count} planejamentos foram criados como rascunho antes da falha da importação. Você pode revisá-los e publicá-los manualmente a partir da lista, ou excluí-los.',
      },
      errors: {
        upload: 'Não foi possível enviar o arquivo.',
        emptyFile: 'Selecione um arquivo primeiro.',
      },
    },
    types: {
      title: 'Modelos',
      back: 'Voltar para planejamentos',
      createType: 'Criar modelo',
      editAction: 'Editar',
      deleteAction: 'Excluir',
      deleteConfirm: 'Excluir este modelo?',
      defaultBadge: 'Padrão',
      genericName: 'Planejamento genérico (Sem personalização)',
      form: {
        createTitle: 'Criar modelo',
        editTitle: 'Editar modelo',
        subtitle: 'Defina as informações pré-definidas ao criar o planejamento',
        formsTitle: 'Formulários',
        formsSubtitle: 'Defina o que deve ser executado neste planejamento',
        addForms: 'Adicionar formulários',
        iconLabel: 'Ícone',
        iconsLabel: 'Ícones',
        colorsLabel: 'Cores',
        name: 'Nome',
        namePlaceholder: 'Digite o nome',
        prefix: 'Prefixo do ID',
        prefixHelper:
          'Defina um prefixo para identificar facilmente os planejamentos deste tipo. Será adicionado ao início do ID (ex: PLAN-1)',
        prefixExample: 'Planejamentos deste tipo serão numerados como {prefix}-1',
        supervisor: 'Supervisor',
        supervisorPlaceholder: 'Selecione os supervisores',
        frequency: 'Frequência do planejamento',
        allowFrequencyOverride: 'Permitir alterar frequência ao criar planejamento',
        allowFrequencyOverrideHelp:
          'Quando ativado, o usuário pode alterar a frequência ao criar um planejamento deste tipo.',
        assetRequired: 'Requer um ativo para criar planejamento',
        assetRequiredHelp:
          'Quando ativado, é obrigatório selecionar um ativo ao criar um planejamento deste tipo.',
        allowEdit: 'Permitir editar o planejamento após criado',
        allowEditHelp:
          'Permite atualizar a configuração dos planejamentos criados a partir deste tipo. As mudanças só se aplicam às próximas execuções e não afetam os ciclos em andamento.',
        sharedResponsibles: 'Os mesmos responsáveis para todas as tarefas',
        sharedResponsiblesHelp:
          'As tarefas dos planejamentos deste tipo compartilham uma única lista de responsáveis: define-se uma vez ao criar o planejamento e editá-la aplica a todas as tarefas. Adicionar uma pessoa aplica desde já; removê-la vale a partir do próximo ciclo e não apaga o que já foi feito.',
        cancel: 'Cancelar',
        create: 'Criar',
        save: 'Salvar',
        meter: {
          cycleCardTitle: 'Configuração do ciclo',
          cycleCardSubtitle: 'Defina como cada ciclo do planejamento é disparado',
          cycleTemporalTitle: 'Temporal',
          cycleTemporalDesc: 'O ciclo é programado por calendário ou a cada X dias',
          cycleMeterTitle: 'Medidor (Requer ativo)',
          cycleMeterDesc: 'O ciclo é programado quando o medidor atinge um valor definido',
          meterLabel: 'Medidor',
          meterPlaceholder: 'Selecione um medidor',
          meterHelper:
            'Você só poderá associar ativos com este medidor configurado ao criar o planejamento',
          strategyLabel: 'Estratégia de planejamento',
          strategyPlaceholder: 'Selecione uma estratégia',
          previewTitle: 'Pré-visualização da estratégia',
          inactivityPause: {
            title: 'Ativar pausa automática por inatividade',
            subtitle:
              'Pausa o planejamento quando o medidor não registra novas leituras e o retoma automaticamente quando voltarem a ser registradas.',
            checkboxLabel: 'Pausar automaticamente por inatividade do equipamento',
            tooltip:
              'Se não forem registradas novas leituras durante o período configurado, o planejamento será pausado automaticamente. O supervisor receberá uma notificação por e-mail e o planejamento será retomado quando as leituras voltarem.',
            daysPrefix: 'Após',
            daysSuffix: 'dias sem leituras',
          },
          strategyEditor: {
            createStrategy: '+ Criar estratégia',
            title: 'Criar estratégia de planejamento',
            nameLabel: 'Nome da estratégia',
            namePlaceholder: 'Ex: Estratégia 200/600 horas',
            levelsTitle: 'Níveis de planejamento',
            codeLabel: 'Nome',
            codePlaceholder: 'Ex: Inspeção',
            intervalLabel: 'Limite',
            intervalPlaceholder: 'Ex: 200',
            addLevel: 'Adicionar nível',
            removeLevel: 'Remover nível',
            deleteStrategy: 'Excluir estratégia',
            save: 'Criar',
            cancel: 'Fechar',
            createSuccess: 'Estratégia criada',
            createError: 'Não foi possível criar a estratégia. Tente novamente.',
            deleteError: 'Não foi possível excluir a estratégia. Ela pode estar em uso por um tipo de planejamento.',
            validation: {
              nameRequired: 'Insira um nome para a estratégia.',
              atLeastOne: 'Adicione pelo menos um nível.',
              codeRequired: 'Cada nível precisa de um nome.',
              positive: 'O limite deve ser maior que 0.',
              ascending: 'Os limites devem ser estritamente crescentes.',
              unique: 'Os limites não podem se repetir.',
            },
          },
          previewEmpty: 'Selecione uma estratégia para ver o megaciclo',
          executionWindowTitle: 'Janela de execução',
          executionWindowSubtitle:
            'Defina quando as tarefas do planejamento serão atribuídas e por quanto tempo estarão disponíveis.',
          windowStartLabel: 'Início do planejamento:',
          windowStartOptions: {
            one_day_before: '1 dia antes',
            three_days_before: '3 dias antes',
            one_week_before: '1 semana antes',
            fifteen_days_before: '15 dias antes',
            on_projected_date: 'Na data projetada',
          },
          durationValueLabel: 'Duração disponível',
          durationUnits: { days: 'Dias', weeks: 'Semanas' },
          executionSummary:
            'As tarefas serão atribuídas {startLabel} da data projetada e estarão disponíveis por {value} {unit}.',
          executionSummaryOnDate:
            'As tarefas serão atribuídas na data projetada e estarão disponíveis por {value} {unit}.',
          accumulateLabel: 'Acumular tarefas entre níveis',
          accumulateTooltip:
            'Cada nível inclui automaticamente as tarefas dos níveis anteriores. (Um nível 3 incluirá as tarefas dos níveis 1 e 2)',
          levelEvery: 'A cada {interval} {unit}',
          ownCount: 'Tarefas deste nível: {count}',
          inheritedCount: 'Tarefas herdadas: {count}',
          inheritedSuffix: ' (Herdada)',
          addFormToLevel: 'Adicionar formulário',
          levelsEmpty: 'Selecione uma estratégia para configurar os níveis',
          removeInheritedTitle: 'Remover formulário herdado',
          removeInheritedBody:
            'Remover um formulário herdado é uma alteração no modelo e afetará os planejamentos futuros. Deseja continuar?',
          removeInheritedCancel: 'Cancelar',
          removeInheritedConfirm: 'Remover',
        },
      },
      errors: {
        prefixTaken: 'Este prefixo já está em uso por outro modelo.',
        deleteHasPlannings: 'Você não pode excluir um tipo que possui planejamentos vivos.',
        deleteLastType: 'Você não pode excluir o último modelo.',
        generic: 'Não foi possível salvar o tipo.',
      },
    },
  },
  task_assigner: {
    planning_task_tooltip: 'Parte de: {planning}',
    pricing: {
      landing: {
        availability: 'Disponível no Professional e Enterprise',
        title: 'Atribua tarefas à sua equipe e acompanhe o andamento',
        intro:
          'Coordene o trabalho da sua equipe, monitore o andamento e mantenha o controle de cada tarefa a partir do DataScope.',
        bullet1: 'Atribua tarefas a pessoas ou grupos.',
        bullet2: 'Acompanhe o andamento e os vencimentos pelo DataScope.',
        bullet3: 'Exporte resultados e mantenha a rastreabilidade do cumprimento.',
        knowPlans: 'Conhecer os planos',
        contactSales: 'Falar com vendas',
        contactSalesIntercomMessage:
          'Olá, quero saber mais sobre Tarefas atribuídas e os planos que a incluem.',
        demoTitle: 'O que você pode fazer com Tarefas atribuídas?',
        demoWebTitle: 'Atribua tarefas e monitore seu status',
        demoWebBody:
          'Crie tarefas para pessoas ou grupos e acompanhe o andamento em um só lugar. Veja tarefas pendentes, atrasadas e concluídas com métricas atualizadas em tempo real.',
        demoAppTitle: 'Cada pessoa recebe suas tarefas no app',
        demoAppBody:
          'As tarefas chegam diretamente ao app de cada responsável. Podem ser concluídas em campo, com ou sem conexão, e cada resposta fica registrada para acompanhamento.',
        previous: 'Anterior',
        next: 'Próximo',
        illustrationAlt: 'Ilustração de Tarefas atribuídas',
        webImageAlt: 'Visão de atribuição de tarefas na web',
        appImageAlt: 'Tarefas atribuídas no app móvel',
      },
    },
    planningSection: {
      title: 'Data e hora',
      subtitle:
        'Defina em que momento do ciclo a tarefa será executada e quanto tempo ficará disponível',
      cycleDayField: 'Dia e hora de execução no ciclo',
      hourField: 'Hora de execução do dia',
      timeField: 'Hora de início',
      ofDays: 'De {total} dias',
      ofHours: 'De {total} horas',
      durationField: 'Duração disponível',
      day: 'dia',
      hour: 'hora',
      units: { hours: 'Horas', days: 'Dias' },
      infoBanner:
        'A tarefa estará disponível no {cycleWord} {cycleDay} do ciclo e ficará aberta por {duration} {unit}',
      currentCycle: 'Ciclo {cycle}: Disponível de {from} a {to}',
      nextCycle: 'Ciclo {cycle}: Será reprogramada de {from} a {to}',
      allowLate: 'Permitir responder após a data limite',
      scheduleTitle: 'Programar envio da tarefa',
      scheduleSubtitle: 'Defina quantos dias antes do início a tarefa será enviada ao responsável',
      scheduleOptions: {
        start: 'No início da tarefa',
        oneDay: '1 dia antes',
        threeDays: '3 dias antes',
        oneWeek: '1 semana antes',
      },
    },
    only_once: 'Somente uma vez',
    working_days: 'Somente dias úteis',
    daily: 'Diariamente',
    weekly: 'Semanalmente',
    monthly: 'Mensalmente',
    yearly: 'Anualmente',
    custom: 'Personalizado',
    task_frequency: 'Frequência de tarefas',
    task_frequency_info:
      'A opção de frequência de tarefas está disponível apenas quando se atribui uma única data',
    assigned: 'Atribuído',
    completed: 'Completado',
    pending: 'Aceito',
    incomplete: 'Incompleto',
    states: {
      completed: 'Completado',
      inProgress: 'Aceito',
      pending: 'Pendente',
      incomplete: 'Incompleto',
      rejected: 'Rejeitado',
      scheduled: 'Programada',
      sent: 'Atribuído',
      cancelled: 'Cancelada',
      deleted: 'Excluída',
      projected: 'Projetado',
    },
    cards: {
      totalTasks: 'Total tarefas',
      completed: 'Completados',
      pending: 'Aceito',
      incomplete: 'Incompletos',
      rejected: 'Rejeitados',
      scheduled: 'Programadas',
      sent: 'Atribuídos',
    },
    your_assigned_tasks: 'Suas tarefas atribuídas',
    filtersTitle: 'Filtros',
    filters: {
      clearFilters: 'Limpar filtros',
      dateRange: {
        title: 'Data',
        popoverTitle: 'Filtrar por data de execução',
      },
      location: {
        title: 'Local',
        popoverTitle: 'Filtrar por local',
        noLocations: 'Nenhum local encontrado',
      },
      form: {
        title: 'Formulário',
        popoverTitle: 'Filtrar por formulários',
        inactive: 'Inativo',
        deleted: 'Eliminado',
        forms: 'Formulários',
        folders: 'Pastas',
        noForms: 'Nenhum formulário encontrado',
      },
      status: {
        title: 'Estado',
        popoverTitle: 'Filtrar por estado',
      },
      user: {
        title: 'Usuários',
        popoverTitle: 'Filtrar por usuários',
        noUsers: 'Nenhum usuário encontrado',
        noGroups: 'Nenhum grupo encontrado',
        deactivated: 'Desativado',
        allTab: 'Usuários',
        groupTab: 'Grupos',
      },
      taskId: {
        title: 'ID tarefa',
        popoverTitle: 'Filtrar por ID tarefa',
        label: 'ID tarefa',
        placeholder: 'Digite o ID',
      },
      origin: {
        title: 'Origem',
        popoverTitle: 'Filtrar por origem',
        individual: 'Individual',
        planning: 'Planejamento',
        group: 'Grupal',
      },
    },
    searchBarPlaceholder: 'Buscar por nome do formulário...',
    new_task: 'Nova Tarefa',
    edit_task: 'Editar Tarefa',
    edit_group_task: 'Editar tarefa grupal',
    createForm: {
      title: 'Criar nova tarefa',
      usersField: {
        label: 'Usuários',
        editLabel: 'Usuário',
        groupLabel: 'Grupo',
        addCta: '+ Adicionar usuários',
        addCtaMore: '+ Adicionar usuários',
        editAddCta: '+ Adicionar usuário',
        sharedModeNotice:
          'Os responsáveis são definidos no nível do planejamento e aplicam a todas as tarefas.',
        editResponsiblesLink: 'Editar responsáveis',
      },
      usersDrawer: {
        title: 'Adicionar usuários',
        searchPlaceholder: 'Buscar usuário ou grupo de usuários',
        allUsersLabel: 'Usuários',
        allGroupsLabel: 'Grupos de usuários',
        noUsersFound: 'Nenhum usuário encontrado',
        noGroupsFound: 'Nenhum grupo encontrado',
        groupMemberSingular: 'membro',
        groupMembersPlural: 'membros',
        alreadyAssignedTooltip: 'Já está atribuído a este formulário',
        close: 'Fechar',
        selectTypeDescription:
          'Escolha como deseja atribuir esta tarefa. Você pode atribuí-la a usuários ou grupos de usuários.',
        usersCardTitle: 'Usuários',
        usersCardDescription: 'Selecione um ou mais usuários para atribuir a tarefa',
        groupsCardTitle: 'Grupos de usuários',
        groupsCardDescription: 'Selecione um ou mais grupos para atribuir a tarefa',
        selectedSingular: 'selecionado',
        selectedPlural: 'selecionados',
        usersBlockedTooltip: 'Para atribuir usuários, remova os grupos selecionados.',
        groupsBlockedTooltip: 'Para atribuir grupos, remova os usuários selecionados.',
        usersLockedTooltip: 'Esta planificação atribui por grupo e não pode ser alterada para usuários.',
        groupsLockedTooltip: 'Esta planificação atribui por usuários e não pode ser alterada para grupo.',
        changeSelection: 'Alterar seleção',
      },
      formsField: {
        label: 'Formulários',
        editLabel: 'Formulário',
        addCta: '+ Selecionar formulários',
        addCtaMore: '+ Selecionar formulários',
        editAddCta: '+ Selecionar formulário',
      },
      formsDrawer: {
        title: 'Formulários',
        infoBanner:
          'Se você selecionar vários formulários, criará várias tarefas com os selecionados',
        searchPlaceholder: 'Buscar formulário, pasta...',
        tabs: {
          forms: 'Formulários',
          folders: 'Pastas',
        },
        noForms: 'Nenhum formulário encontrado',
        deleted: 'Excluído',
        inactive: 'Inativo',
        close: 'Fechar',
      },
      otherFields: {
        locationLabel: 'Local',
        locationPlaceholder: 'Selecione um local',
        assetLabel: 'Ativo',
        descriptionLabel: 'Descrição',
        descriptionPlaceholder: 'Escreva uma descrição da tarefa',
      },
      subtasksField: {
        label: 'Tarefas a realizar',
        placeholder: 'Escreva uma tarefa',
        addCta: '+ Adicionar tarefa',
        enterHelper: 'Pressione Enter para adicionar outra tarefa',
        removeAriaLabel: 'Remover tarefa',
      },
      infoContainer: {
        title: 'Informações da tarefa',
        subtitle: 'Defina os detalhes gerais da tarefa, responsáveis e onde será realizada.',
      },
      scheduleContainer: {
        title: 'Data e hora',
        subtitle: 'Defina quando a tarefa será realizada e por quanto tempo estará disponível.',
        dateFieldLabel: 'Data e hora',
        gapFieldLabel: 'Duração da tarefa em horas',
        gapPlaceholder: 'Ex. 24',
        lateResponseLabel: 'Permitir resposta após a data limite',
        duration: {
          prefix: 'Duração: ',
          year: 'ano',
          years: 'anos',
          month: 'mês',
          months: 'meses',
          week: 'semana',
          weeks: 'semanas',
          day: 'dia',
          days: 'dias',
          hour: 'hora',
          hours: 'horas',
          minute: 'minuto',
          minutes: 'minutos',
          and: 'e',
        },
      },
      participationContainer: {
        title: 'Participação',
        subtitle:
          'Indique se a tarefa deve ser respondida obrigatoriamente ou se os usuários podem decidir realizá-la.',
        mandatoryTitle: 'Obrigatória',
        mandatoryDescription: 'Todos os usuários devem responder a tarefa',
        voluntaryTitle: 'Voluntária',
        voluntaryDescription: 'Todos os usuários podem aceitar/rejeitar a tarefa',
        forOneTitle: 'Apenas uma resposta por grupo',
        forOneDescription: 'A primeira pessoa que aceitar a tarefa a concluirá para todo o grupo',
      },
      remindersContainer: {
        title: 'Lembretes',
        subtitle:
          'As notificações serão enviadas automaticamente conforme a data de vencimento da tarefa.',
        question: 'Com quanto tempo de antecedência você gostaria de receber um lembrete?',
        channelsLabel: 'Canal de notificação',
        disabledChipTooltip:
          'Esta opção não pode ser selecionada dada a atual configuração de data e hora da tarefa',
        timePresets: {
          min15: '15 min',
          min30: '30 min',
          hour1: '1 hora',
          day1: '1 dia',
          day3: '3 dias',
          week1: '1 semana',
        },
        channels: {
          notification: 'Notificação no app',
          email: 'E-mail',
        },
      },
    },
    tasks: 'Tarefas',
    massive_search: 'Pesquise por usuário, formulário ou local ...',
    user: 'Usuário',
    form: 'Formulário',
    place: 'Local',
    date: 'Data',
    date_and_time: 'Data e hora',
    gap: 'Intervalo',
    state: 'Estado',
    save: 'Salvar',
    users: 'Usuários',
    users_and_groups: 'Usuários e grupos',
    description: 'Descrição',
    hour: 'Hora',
    alert: 'alerta',
    delete: 'Excluir',
    cancel: 'cancelar',
    accept: 'aceitar',
    notify: 'Notificar',
    view_group_detail: 'Ver detalhe do grupo',
    view_group: 'Ver grupo',
    group_label: 'Grupo',
    notify_user: 'Quero notificar ',
    sure: 'Você tem certeza?',
    delete_task: 'Você irá excluir esta tarefa',
    delete_tasks: 'Você irá excluir estas tarefas: ',
    reset: 'Restabelecer',
    old_version: 'Versão Antiga',
    task_created: 'Tarefa criada',
    our_problem: 'Temos um problema',
    task_update: 'Tarefa atualizada com sucesso',
    export: 'Exportar',
    date_necessary: 'uma data é necessária',
    required: 'Requerido',
    blanck: 'Existem campos vazios',
    notification_sent: 'Notificação enviada com sucesso',
    notification_skipped: 'A tarefa não pode ser notificada no estado atual',
    notifications_sent: 'Notificações enviadas com sucesso',
    tasks_delete:
      'Tarefas excluídas com sucesso. Aguarde alguns minutos para ver as alterações refletidas.',
    task_delete: 'Tarefa excluída com sucesso',
    new_place: 'Novo local',
    start: 'Começa',
    end: 'Final',
    history: 'Registro',
    actions: '',
    dobleClick: 'Clique duplo na tarefa = abrir detalhes',
    shiftMouse: 'shift + roda do mouse = mover linha do tempo esquerda/certa',
    altMouse: 'alt + roda do mouse = zoom in/out',
    timeline: 'Linha do tempo',
    taskAssignID: 'ID tarefa atribuída',
    selected_range: 'Intervalo selecionado',
    notifications: 'Adicionar notificações',
    add_notification: 'Adicionar uma notificação',
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'dias',
    weeks: 'semanas',
    months: 'meses',
    years: 'anos',
    notification: 'Notificação',
    email: 'Email',
    max_one_date: 'Máximo uma data no modo de edição',
    max_one_user: 'Máximo um usuário no modo de edição',
    no_location_warning: 'O local não foi especificado, ou pode ter sido removido',
    showing_results_for: 'Mostrando resultados para',
    task: 'Tarefa',
    no_tasks_available: 'Você não tem Tarefas disponíveis neste moment',
    gap_hours: 'Duração da tarefa em horas',
    allow_late_submission: 'Permitir responder à tarefa após o prazo ter expirado',
    add_tasks: 'Adicionar tarefas',
    add_tasks_caption:
      'Você pode adicionar tarefas rapidamente separando-as com vírgulas "," ou pressionando Enter',
    configuration: 'Configuração',
    voluntary_task:
      'Tornar esta tarefa voluntária (Todos os usuários podem aceitar/rejeitar a tarefa)',
    mandatory_task: 'Tornar esta tarefa obrigatória (Todos os usuários devem responder à tarefa)',
    notification_type: 'Tipo de notificação',
    notification_time: 'Tempo',
    notification_period: 'Período de tempo',
    app_notification: 'Notificação no aplicativo',
    confirmation_title_prefix: ' Você tem certeza de que deseja criar ',
    confirmation_title_suffix: ' tarefas?',
    confirmation_title_suffix_singular: ' tarefa?',
    confirmation_title_suffix_one: 'tarefas por',
    confirmation_title_suffix_one_singular: 'tarefa por',
    confirmation_title_suffix_two: 'dias?',
    edit_confirmation_title: 'Você tem certeza de que deseja editar esta tarefa?',
    success_message:
      'Tarefas criadas com sucesso! Por favor, aguarde alguns segundos para que sejam refletidas. Lembre-se de atualizar a página para visualizá-las.',
    update_success_message: 'Tarefa atualizada com sucesso!',
    forms_info: 'Se você selecionar vários formulários, criará várias tarefas com os selecionados.',
    asset: 'Ativo',
    asset_autocomplete_hint:
      'O ativo atribuído será preenchido automaticamente no formulário, se aplicável',
    filters_asset_title: 'Ativo',
    edit: 'Editar',
    show_answer: 'Mostrar resposta',
    notify_title: 'Você tem certeza de que deseja notificar o seguinte usuário?',
    bulk_notify_title: 'Você tem certeza de que deseja notificar os seguintes usuários?',
    notify_group_title: 'Você tem certeza de que deseja notificar os usuários do seguinte grupo?',
    edit_group_title: 'Você tem certeza de que deseja editar esta tarefa?',
    edit_group_description:
      'Esta tarefa só pode ser editada para os usuários que ainda não a iniciaram. Deseja continuar?',
    continue_action: 'Continuar',
    delete_title: 'Você tem certeza de que deseja excluir esta tarefa?',
    delete_description: 'Será excluído e você não poderá recuperá-lo',
    delete_group_description: 'Será excluído para todos os usuários e você não poderá recuperá-lo',
    delete_member_description:
      'Se você excluí-la, ela desaparecerá da lista de tarefas pendentes do usuário e ele não poderá respondê-la',
    bulk_delete_title_one: 'Você tem certeza de que deseja excluir',
    bulk_delete_title_two: 'tarefas?',
    bulk_delete_description:
      'Se você excluí-los, eles desaparecerão da lista de tarefas pendentes dos usuários e eles não poderão respondê-los',
    bulk_actions: 'Ações em massa',
    creation_date: 'Data criação',
    start_date: 'Data início',
    answers: 'Respostas',
    backToTasks: 'Voltar para Tarefas',
    groupDetail: {
      searchPlaceholder: 'Buscar por usuário ou email',
      emailColumn: 'E-mail',
      onTimeColumn: 'No prazo',
      onTimeYes: 'Sim',
      onTimeNo: 'Não',
      emptyMembers: 'Esta tarefa de grupo não tem membros atribuídos',
      answerDrawerTitle: 'Resposta do membro',
      bulkSelectedSingular: 'selecionado',
      bulkSelectedPlural: 'selecionados',
      bulkDeleteTitle: 'Excluir membros selecionados',
      bulkDeleteText:
        'Tem certeza de que deseja remover %{count} membros desta tarefa de grupo? Os membros que já responderam não serão removidos.',
      bulkDeleteSummary: '%{deleted} removidos, %{skipped} ignorados',
      bulkNotifyTitle: 'Notificar membros selecionados',
      bulkNotifyText:
        'Tem certeza de que deseja notificar os %{count} membros selecionados? Somente os membros pendentes receberão a notificação.',
      mandatoryBanner: {
        for_everyone: 'Esta tarefa está configurada como: Resposta obrigatória',
        for_nobody: 'Esta tarefa está configurada como: Resposta voluntária',
        for_one: 'Esta tarefa está configurada como: Apenas uma resposta por grupo',
      },
    },
    duration: 'Duração:',
    answered: 'responderam',
    out_of_time: 'Fora de tempo',
    late: 'atrasado',
    no_location: 'Sem local',
    task_does_not_exist: 'A tarefa não existe',
    location_copied: 'Localização copiada para a área de transferência',
    completed_tasks_cannot_be_deleted: 'Tarefas completadas não podem ser excluídas',
    some_tasks_skipped_due_to_answers:
      '%{count} tarefa(s) foram ignoradas porque já possuem respostas e não podem ser excluídas',
    no_tasks_were_modified: 'Nenhuma tarefa foi modificada',
    complete_task: 'Completar tarefa',
    complete_task_description: 'Você tem certeza de que deseja completar esta tarefa?',
    complete_task_button: 'Completar',
    reject_task_button: 'Rejeitar',
    accept_task_button: 'Aceitar',
    accept_reject_confirmation: 'Você pode aceitar e completar, ou rejeitar se não puder realizar.',
    import: {
      title: 'Importar Tarefas',
      step1Title: 'Passo 1: Baixar modelo',
      step1Description:
        'Baixe o arquivo Excel de exemplo. Certifique-se de preencher os campos marcados com * para importar seu arquivo corretamente.',
      downloadExample: 'Baixar exemplo',
      step2Title: 'Passo 2: Editar o arquivo',
      step2Description:
        'Preencha o modelo com os dados das suas tarefas. Certifique-se de que todos os campos obrigatórios estejam preenchidos.',
      step2MoreInfo: 'Saiba mais aqui',
      step3Title: 'Passo 3: Carregar seu arquivo',
      step3Description:
        'Arraste e solte seu arquivo aqui ou selecione-o do seu computador. Pode levar alguns minutos para processar.',
      dragDropText: 'Arraste e solte seu Excel aqui',
      browseText: 'ou procure em seu computador',
      replaceText: 'Substituir',
      fileUploadedText: 'Seu arquivo foi carregado',
      fileUploadError: 'Seu arquivo não pôde ser carregado',
      invalidFileType: 'Por favor, selecione um arquivo Excel válido (.xlsx)',
      importError: 'Erro ao importar tarefas',
      importButton: 'Importar',
      cancel: 'Cancelar',
      importing: 'Importando...',
      success: 'Tarefas importadas com sucesso. Aguarde alguns segundos para que sejam refletidas.',
      errorTitle: 'Detectamos um erro.',
      templateDownloadError: 'Erro ao baixar o arquivo de exemplo',
      downloadingTemplate: 'Baixando...',
      baseTemplateUrl: 'https://s3-us-west-2.amazonaws.com/data-scope/templates/',
      templateFileLegacy: `task_assign_pt3_v1.xlsx`,
      templateFileV5: `task_assign_pt_v5.xlsx`,
      templateFileLegacyV6: `task_assign_pt3_v2.xlsx`,
      templateFileV6: `task_assign_pt_v6.xlsx`,
      // v6 template including the group columns (assignment type + group
      // name). Used when the GroupTaskAssign flag is on. Hosted on S3.
      templateFileGroupV6: `task_assign_pt_v6_group.xlsx`,
      requirements: {
        title: 'Requisitos do arquivo',
        uniqueIds: "Evite valores repetidos em 'ID'.",
        duplicateIdMessage: "O ID '{id}' está repetido. Será usado o último valor.",
        formNameComplete: "Coluna 'Nome Formulario' completa.",
        missingFormNameMessage: "Falta o nome do formulário em '{cell}'.",
        missingFormNameColumn: "A coluna 'Nome Formulario' não foi encontrada.",
        userEmailComplete: "Se for tarefa individual, 'Email Usuario' completa.",
        userEmailCompleteLegacy: "Coluna 'Email Usuario' completa.",
        missingUserEmailMessage: "Falta o e-mail do usuário em '{cell}'.",
        missingUserEmailColumn: "A coluna 'Email Usuario' não foi encontrada.",
        groupFieldsComplete:
          "Se for tarefa em grupo, 'Nome do grupo' e 'Tipo de atribuição' completas.",
        missingGroupNameMessage: "Falta o nome do grupo em '{cell}'.",
        missingAssignmentTypeMessage: "Falta o tipo de atribuição em '{cell}'.",
        dateAndGapComplete: "Colunas 'Data / Hora Início' e 'Margem de horas' completas.",
        missingStartDateMessage: "Falta a data de início em '{cell}'.",
        missingStartDateColumn: "A coluna 'Data / Hora Início' não foi encontrada.",
        missingGapMessage: "Falta a margem de horas em '{cell}'.",
        missingGapColumn: "A coluna 'Margem de horas' não foi encontrada.",
        seeMore: 'Ver mais {count}',
        seeLess: 'Ver menos',
      },
      confirmIncomplete: {
        title: 'Algumas linhas estão incompletas',
        body: 'Detectamos {skipped} de {total} linha(s) com dados incompletos em campos obrigatórios. Essas linhas serão omitidas e {valid} linha(s) válida(s) serão importadas. Deseja continuar?',
        cancel: 'Cancelar',
        confirm: 'Importar {valid} linha(s)',
      },
      helpUrl:
        'https://help.mydatascope.com/pt-BR/articles/2852072-como-importar-tarefas-de-forma-massiva',
      errors: {
        invalidFileType: 'Por favor, selecione um arquivo Excel válido (.xlsx)',
        importError:
          'Erro ao importar tarefas. Por favor, verifique se seus dados têm o formato correto.',
        templateDownloadError: 'Erro ao baixar o arquivo de exemplo',
        errorTitle: 'Detectamos um erro.',
      },
    },
    import_audit: {
      title: 'Historico de importacoes',
      tab: 'Historico',
      menuImportNow: 'Importar agora',
      menuViewHistory: 'Ver historico',
      genericImportError:
        'Houve um problema ao processar esta importacao. Se o problema persistir, entre em contato com o suporte.',
      taskImportsTab: 'Tarefas importadas',
      backToTasks: 'Voltar para Tarefas',
      rowsTitle: 'Linhas',
      emptyState: 'Nenhuma importacao recente',
      viewDetails: 'Ver detalhes',
      back: 'Voltar para historico',
      retrySuccess: 'Tarefa criada com sucesso',
      retryError: 'Nao foi possivel criar a tarefa',
      statuses: {
        pending: 'Pendente',
        processing: 'Processando',
        completed: 'Concluida',
        failed: 'Falhou',
        created: 'Criada',
        updated: 'Atualizada',
        skipped: 'Ignorada',
        resolved_manually: 'Resolvida',
      },
      error_codes: {
        task_form_not_found: 'Formulario nao encontrado',
        mobile_user_not_found: 'Usuario nao encontrado',
        date_unparseable: 'Data invalida',
        assign_id_in_use: 'ID em uso (tarefa em andamento ou concluida)',
        validation_failed: 'Erro de validacao',
      },
      columns: {
        file: 'Arquivo',
        date: 'Data',
        triggeredBy: 'Importado por',
        status: 'Status',
        summary: 'Resumo',
        rowNumber: 'Linha',
        assignId: 'ID da tarefa',
        task: 'Formulario',
        user: 'Usuario',
        error: 'Erro',
        actions: 'Acoes',
      },
      summary: {
        read: '%{n} lidas',
        created: '%{n} criadas',
        updated: '%{n} atualizadas',
        failed: '%{n} falharam',
        skipped: '%{n} ignoradas',
      },
      fixAndRetry: 'Corrigir',
      resolvedBy: 'Resolvida por',
      resolvedByHelp: 'Usuario que corrigiu e reprocessou esta linha manualmente',
      resolvedAssignId: 'ID atribuido',
      locationCreated: 'Local criado automaticamente',
      idReplaced: 'ID solicitado: %{requested} - usado: %{used}',
      changedFields: 'Alteracoes',
      fixModal: {
        title: 'Corrigir linha %{row}',
        submit: 'Criar tarefa',
        cancel: 'Cancelar',
        submitting: 'Criando...',
      },
    },
    exportModal: {
      title: 'Exportar tarefas atribuídas',
      bannerWithRange:
        'Serão exportadas as tarefas cuja data de execução esteja dentro do intervalo de datas %{from} - %{to}',
      bannerWithoutRange: 'Serão exportadas as tarefas conforme os filtros aplicados',
      filenameLabel: 'Nome do arquivo',
      filenameHelp: 'Você pode alterar o nome antes de exportar',
      cancel: 'Cancelar',
      submit: 'Exportar',
      defaultFilenamePrefix: 'tarefas-atribuidas-exportadas',
    },
    integrations: {
      button: 'Google Sheets',
      title: 'Integração Tarefas Atribuídas',
      gsheetsIntegrationLabel: 'Ir ao Google Sheets',
      gsheetsNewLinkUrl: 'https://sheets.new/',
      infoTextPart1:
        'Para garantir uma integração adequada, privada e segura, compartilhe seu documento com permissões de',
      infoTextPart2: 'editor',
      infoTextPart3: 'somente para',
      inputLabel: 'Novo link',
      inputPlaceholder: 'Insira o link do documento para integrar',
      optional: '(Opcional)',
      save: 'Salvar',
      cancel: 'Cancelar',
      copyUrl: 'URL copiada!',
      copyEmail: 'E-mail copiado!',
      created: 'Integração configurada com sucesso!',
      saved: 'Alterações salvas com sucesso!',
      deleted: 'Integração removida com sucesso',
      savingError: 'Erro ao configurar a integração',
      removeTitle: 'Remover a integração com Google Sheets?',
      removeBody:
        'A planilha deixará de receber atualizações de tarefas atribuídas do DataScope. O documento no Google Drive não é excluído.',
      removeConfirm: 'Remover integração',
      removeCancel: 'Cancelar',
    },
  },
  form_answer: {
    answer_again: 'Responder novamente',
    success_message: 'Recebemos sua respostas corretamente',
    submit_button: 'Enviar',
    edit_button: 'Editar',
    edit_form: 'Editar formulário',
    incomplete_edit_alert: 'Você deve responder a todas as perguntas obrigatórias',
    incomplete_submit_alert: 'Você ainda não enviou nenhuma resposta',
    error_submit_alert: 'Ocorreu um erro ao enviar sua resposta',
    error_edit_alert: 'Ocorreu um erro ao editar a sua resposta',
    sync_pending_message:
      'Esta resposta ainda está a sincronizar. Poderá editá-la dentro de momentos.',
    no_edit_alert: 'Você ainda não editou a resposta original',
    no_answer_alert: 'Sua resposta está vazia',
    required_question: 'Esta pergunta é obrigatória',
    withinMarginRangeError: 'Insira uma leitura entre {min} e {max}.',
    withinMarginMinimumError: 'Insira uma leitura maior ou igual a {min}.',
    withinMarginExactError: 'Insira exatamente {min}.',
    no_options: 'Sem opções',
    invalid_question_type_1: 'Pergunta tipo ',
    invalid_question_type_2:
      'Este tipo de pergunta não pode ser respondida/editada em nossa plataforma web. Baixe o aplicativo móvel DataScope.',
    some_invalid_question_types:
      'Aviso: este formulário inclui tipos de perguntas inválidos para a versão da Web do DataScope',
    download_mobile: 'Baixe nosso aplicativo móvel aqui',
    download_mobile_link: 'https://datascope.page.link/DQbR',
    answer_placeholder: 'Sua resposta',
    simple_text_placeholder: 'Sua resposta de texto',
    text_rut_placeholder: 'Seu RUT de resposta',
    text_container_placeholder: 'Seu ID de contêiner',
    invalidRutError: 'RUT inválido',
    invalidContainerError: 'ID de contêiner inválido',
    text_email_placeholder: 'Seu e-mail de resposta',
    select_your_date: 'Seleciona uma data',
    select_your_datetime: 'Seleciona data e hora',
    select_your_time: 'Seleciona um horário',
    datetime_errors: {
      invalidDate: 'Data inválida',
      minDate: 'A data é anterior à data mínima permitida',
      maxDate: 'A data é posterior à data máxima permitida',
    },
    add_repeatable_questions: 'Adicionar outro grupo de perguntas',
    signature_type: 'Assinatura',
    photo_type: 'Foto',
    barcode_type: 'Código de barras',
    filter_elements: 'Procurar elementos...',
    exact_match: 'Correspondência exata',
    exact_match_tooltip: 'Busca o texto exatamente como foi escrito',
    search_suggestions_title: 'Sugestões de busca',
    search_action: 'Buscar',
    search_general_hint: 'Busca geral em perguntas e respostas',
    search_exact_hint: 'Correspondência exata da frase',
    upload_image: 'Enviar Imagem',
    no_image_loaded: 'Nenhuma imagem foi enviada ainda',
    image_max_size_exceeded: 'Um ou mais de seus arquivos excedem o límite de',
    image_max_amount_exceeded_part_one: 'Você pode subir até',
    image_max_amount_exceeded_part_two: 'imágenes por comentario',
    image_upload_error: 'Ocorreu um erro ao enviar os arquivos, tente novamente',
    photo_gps_notice: 'As imagens carregadas pelo navegador podem não incluir localização GPS.',
    no_signature_loaded: 'Nenhuma firma foi enviada ainda',
    clear: 'Limpar',
    save_canvas: 'Guardar',
    modify_signature: 'Modificar',
    next: 'Próximo',
    previous: 'Atrás',
    upload_file: 'Subir arquivo',
    uploading_file: 'Enviando...',
    unsupported_file_type: 'Este tipo de arquivo não é permitido para esta pergunta.',
    exceeded_max_number_files:
      'Você excedeu o número máximo de arquivos permitidos para esta questão',
    download_app_suggestion:
      'Procura uma forma melhor e mais rápida de responder aos seus formulários?',
    confirm_section_change:
      'Esta seção tem uma pergunta obrigatória que você ainda não respondeu corretamente. Deseja continuar?',
    load_more_data: 'Carregar mais dados',
    no_data_left: 'Não há dados restantes para carregar',
    clear_all: 'Limpar tudo',
    no_header_warning:
      'O criador desta questão não especificou os títulos das listas relacionadas.',
    more_answers_alert: 'Role para baixo para ver mais',
    subform_limit: 'Limite do grupo de perguntas atingido',
    subform_min: 'Por favor, adicione o número mínimo de respostas',
    multi_option_placeholder: 'Seleciona uma opção',
    locked_asset_hint: 'Este ativo foi atribuído na tarefa',
    image: 'Imagem',
    download: 'Descarga',
    multiple_options: 'Selecione várias opções',
    group: 'Grupo',
    start: 'Começo',
    end: 'Final',
    invalid_date: 'Data inválida',
    invalid_time: 'Hora inválida',
    invalid_datetime: 'Data e Hora inválida',
    locationUpdate: {
      description: 'Você deve selecionar para alterar seu local',
      lastLocationLabel: 'Último local',
      currentLocationLabel: 'Local atual',
      currentLocationPlaceholder: 'Selecione uma opção',
    },
    optionComments: {
      addNote: 'Adicionar uma nota',
      removeNote: 'Excluir nota',
      writeComment: 'Escrever um comentário...',
      requiredNote: 'Comentário obrigatório',
      addNoteMobile: 'Nota',
      addImage: 'Anexar imagem',
      addImageMobile: 'Imagem',
      removeNoteMobile: 'Excluir',
      requiredImage: 'Imagem obrigatória',
      requiredFinding: 'Não conformidade obrigatória',
      deleteImageWarningTitle: 'Tem certeza de que deseja excluir esta imagem?',
      deleteImageWarningSubTitle: 'Uma vez excluída, você não poderá recuperá-la',
      cancel: 'Cancelar',
      delete: 'Excluir',
    },
    drag_drop_file: 'Arraste e solte seus arquivos aqui',
    or_browse_for_file: 'ou procure por eles em seu computador',
    missingRequiredAnswersAlert:
      'Ops! Parece que ainda faltam algumas perguntas para responder. Por favor, complete todas as perguntas obrigatórias para poder continuar.',
    totalPercentage: 'Porcentagem total',
    enterSampleTotal: 'Digite o total da amostra',
    forbidden_access:
      'Parece que você não tem permissão para editar este formulário. Solicite-a para poder fazer alterações',
    automated_signature_on_response:
      'Este formulário tem assinatura automática configurada. A solicitação será enviada aos usuários atribuídos ao finalizar o formulário.',
    electronic_signature: 'Assinatura eletrônica',
    sign_now: 'Assinar agora',
    sign_later: 'Assinar mais tarde',
    sign_modal_description: 'Este formulário requer sua assinatura, você deseja assinar agora?',
    leave_form_title: 'Você está saindo do formulário',
    leave_form_message:
      'Você tem alterações não salvas nesta resposta. Se você sair desta tela agora, suas alterações serão perdidas. Deseja sair e descartá-las?',
    leave_stay_button: 'Continuar editando',
    leave_confirm_button: 'Sair e descartar',
    exit_form_title: 'Sair do formulário incompleto',
    exit_form_message: 'Tem certeza de que deseja sair do formulário?',
    exit_cancel_button: 'Cancelar',
    exit_confirm_button: 'Sim',
    draft_found_title: 'Rascunho encontrado',
    draft_found_message:
      'Você tem respostas salvas de uma sessão anterior neste formulário. Como deseja continuar?',
    draft_continue_button: 'Continuar com o rascunho',
    draft_start_fresh_button: 'Começar um novo',
    draft_recovered_banner:
      'Rascunho recuperado. Verifique os anexos e os campos de assinatura, caso se aplique.',
    signature_creation_failed: 'Houve um erro ao tentar assinar o formulário',
    saveSuccessAndRedirect: 'Resposta salva corretamente! Redirecionando para suas assinaturas...',
    saveAndSignSuccessAndRedirect:
      'Resposta salva e assinada corretamente! Redirecionando para suas assinaturas...',
    subtasks: 'Tarefas',
    editingActivity: 'Editando atividade',
    selectActivityAndDuration: 'Seleciona atividade e duração',
    update: 'Atualizar',
    add: 'Adicionar',
    to: 'a',
    activityPlaceholder: 'Atividade',
    durationPlaceholder: 'Duração',
    durationExceedsLimit: 'A duração excede o tempo restante',
    cancel: 'Cancelar',
    requiredQuestionIncomplete: 'Todas as horas de trabalho devem ser atribuídas',
    deleteActivityMessage: 'Tem certeza de que deseja excluir esta atividade?',
    allActivitiesRegistered: 'Todas as horas atribuídas',
    workingTimeNotSet: 'Horas de trabalho não definidas',
    remainingTimePrefix: 'Falta atribuir',
    activityNotSelected: 'Atividade faltante',
    editActivity: 'Editar',
    insertBelow: 'Inserir abaixo',
    deleteActivity: 'Excluir',
    addActivity: 'Adicionar atividade',
    noAssignedLocations:
      'Você não tem locais atribuídos para este formulário. Entre em contato com seu administrador.',
    filterAssetsByLocationBlocked: 'Selecione primeiro um local para ver os ativos disponíveis.',
    filterAssetsByLocationNoAssets: 'O local selecionado não tem ativos atribuídos.',
  },
  percentage: 'Porcentagem',
  build_your_own_form: 'Construa seu próprio formulário com DataScope',
  back_to_taskForms: 'Voltar à lista de formulários',
  date_fns: 'pt',
  yes: 'Sim',
  no: 'Não',
  insert_value: 'Insira um valor',
  and: 'E',
  invalidEmail: 'Email inválido',
  ok: 'OK',
  clearAll: 'Remover tudo',
  group: 'Grupo',
  folder: 'Arquivo',
  users: 'Usuários',
  forms: 'Formulários',
  actions: 'Ações',
  select: 'Selecionar',
  selectAll: 'Selecionar Tudo',
  form_builder: {
    formName: 'Nome do formulario',
    saveForm: 'Salvar',
    title: 'Título',
    titleDescription: 'Título curto para identificar a questão. Aparece ao exportar dados.',
    instruction: 'Descrição',
    instructionDescription:
      'Texto mais longo para exibir no aplicativo. Não aparece ao exportar dados (opcional).',
    questionType: 'Alterar tipo de pergunta',
    copy: 'Duplicar pergunta',
    delete: 'Apagar pergunta',
    add: 'Adicionar nova pergunta',
    advanced: 'Opções avançadas',
    type: 'Tipo',
    date: 'Data',
    dateAndTime: 'Data e hora',
    time: 'Hora',
    alternativeColumns: 'Colunas alternativas',
    addOption: 'Adicionar opção',
    dataListSource: 'Fonte da lista de dados',
    changeDataList: 'Alterar lista de dados',
    listValues: 'Valores de lista',
    addListValue: 'Adicionar valor de lista',
    deleteAlternative: 'Excluir alternativa',
    required: 'Obrigatória',
    validateRutChile: 'RUT (Chile)',
    validateMail: 'Email',
    validateContainer: 'ID de contêiner',
    validate: 'Validar',
    codeType: 'Alterar tipo de código',
    disableGallery: 'Desativar galeria',
    maxImagesPerItem: 'Máximas imagens por item',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    alternative: 'Alternativa',
    snackBarShared: 'convites enviados',
    snackBar: 'Seu formulário foi salvo com sucesso!',
    activityStartTimeRequired: 'Defina o horário de início da jornada para continuar.',
    newListData: 'Nova Lista De Dados',
    section: 'Adicionar Seção',
    sectionName: 'Seção sem nome',
    duplicateSection: 'Replicar seção',
    deleteSection: 'Deletar seção',
    delSectionsQuestions: 'deletar seção e perguntas',
    areYouSure: 'Tem certeza?',
    cancel: 'Cancelar',
    sectionAlertOne: 'A seção será removida, mas as perguntas serão adicionadas à seção anterior.',
    sectionAlertTwo: 'A seção será excluída e também as perguntas dentro dela.',
    yesDelete: 'Sim, eliminar',
    questionAlert: 'Esta questão será removida permanentemente',
    questionAlertWithAssetLinksPrefix:
      'Esta pergunta será excluída permanentemente junto com seus ',
    questionAlertWithAssetLinksHighlight: 'vínculos a dados do ativo',
    copyName: 'Cópia',
    nameAlert: 'As perguntas devem ter nomes diferentes.',
    isRepeated: 'é repetido.',
    if: 'se',
    is: 'é',
    to: 'a',
    goTo: 'ir a',
    sectionNameTag: 'Nome da Seção',
    skipQuestions: 'Saltar perguntas',
    equal: 'igual',
    dif: 'diferente',
    contains: 'contém',
    notContains: 'não contém',
    empty: 'vazio',
    notEmpty: 'não vazio',
    skipOnlyMobile: 'Somente aplicável para formulários móveis',
    disableSkip: 'Este tipo de pergunta não está habilitada para a lógica de saltos',
    next: 'próxima questão',
    end: 'terminar formulário',
    payingAlert:
      'Esta funcionalidade não está disponível no plano gratuito, você deve ativar seu plano na configuração / faturamento.',
    showPercent: 'Mostrar porcentagem',
    showSamplingPercent: 'Mostrar porcentagem de amostragem',
    showPrice: 'Mostrar preço',
    showAvg: 'Mostrar média',
    showFactor: 'Mostrar multiplicação',
    camQuality: 'Qualidade da câmera',
    high: 'Alta',
    mid: 'Media',
    low: 'Baixa',
    recommended: 'recomendado',
    photoAlert: 'a sincronização pode demorar mais',
    sectionNameAlert: 'Não deve haver seções com o mesmo nome. Renomeie a seção: ',
    formatType: 'Tipos de formato',
    audioDuration: 'Duração do áudio',
    secondsLabel: 'segundos',
    cannotCombineWithVoiceAudioRecording: 'Não pode ser combinado com gravação de áudio',
    anyIncludeAllFormatsExceptVoiceAudioRecording:
      'Qualquer inclui todos os tipos de arquivo, exceto gravação de áudio',
    voiceAudioRecording: 'Gravação de áudio',
    any: 'Qualquer',
    howToCreate: 'como criar formulários',
    good: 'Bom',
    regular: 'Regular',
    bad: 'Mau',
    newOption: 'Nueva opção',
    moveSection: 'Mover seção',
    oldShareForm: 'Compartilhe este formulário com um link público',
    shareForm: 'Link Formulário',
    shareEmail: 'Compartilhe através da email',
    shareWhatsapp: 'Compartilhe através da WhatsApp',
    shareWhatsappMessage: 'Envie seu formulário junto com uma mensagem via WhatsApp',
    shareWhatsappMessageApi: 'Olá, convido você a preencher o formulário {form_name}: ',
    formMadePublic: 'O link do formulário foi ativado',
    undoFormPublic: 'O link do formulário foi desativado',
    shareForm2: 'Compartilhe este formulário',
    shareFormTip:
      'Qualquer pessoa, usuários registrados e não registrados, poderá preencher este formulário web se você compartilhar o link público com eles. Suas respostas serão registradas com o nome de um usuário genérico.',
    shareFormOn: 'Tornar este formulário público',
    shareFormOff: 'Remover o acesso público',
    shareViaEmailTip: 'Pode incluir mais de um e-mail pressionando o enter, vírgula ou um espaço',
    quantity: 'Número máximo de arquivos',
    new: 'Novo!',
    warning: 'Temporariamente disponível apenas para formulários da web',
    testYourForm1: 'Baixa nosso aplicativo oficial em ',
    testYourForm2: 'Mais tarde, você pode fazer login com essas mesmas credenciais.',
    testYourForm3: 'Teste seu formulário em nosso aplicativo!',
    testYourForm4:
      'Digitalize este código QR com a câmera do seu celular para visualizar o seu formulário!',
    testYourForm5:
      'Digitalize este código QR com a câmera do seu celular para baixar nosso aplicativo e visualizar seu formulário!',
    copyLink: 'Copiar link',
    copiedLink: 'Copiado!',
    visitForm: 'Visita',
    accessYourForm: 'Acesse seu formulário aqui',
    downloadApp: 'Baixe nosso aplicativo',
    ok: 'ok',
    and: 'e',
    greater: 'Maior que',
    greaterOrEqual: 'Maior ou igual que',
    less: 'Menor que',
    lessOrEqual: 'Menor ou igual que',
    between: 'Entre',
    notBetween: 'Não está entre',
    betweenQuestionOffset: 'Entre valor questão e deslocamento',
    withinMargin: 'Dentro da margem da última leitura',
    withinMarginBack: 'Margem para trás',
    withinMarginForward: 'Margem para frente',
    withinMarginLastReading: 'a última leitura do medidor',
    withinMarginExactly: 'exatamente',
    withinMarginRequiresMeter: 'Requer usar esta pergunta para atualizar um medidor',
    withinMarginNotInRepeatable: 'Não disponível dentro de um grupo de perguntas repetíveis',
    withinMarginUnlinkedWarning: 'Esta validação não será aplicada até que a pergunta esteja vinculada a um medidor novamente.',
    withinMarginInert: 'Esta validação está desativada por enquanto. A configuração é mantida e voltará a ser aplicada quando for reativada.',
    // Keys here are intentionally duplicated from form_builder's numeric-mode
    // keys rather than cross-read (see betweenQuestionOffset vs.
    // form_builder.betweenQuestionOffset above) — a numeric-mode rewording
    // should never silently change this panel. Divergent wording between the
    // two is deliberate per D19, not a typo to unify.
    dateValidation: {
      addValidation: 'Adicionar validação',
      validationType: 'Tipo de validação',
      fixedRange: 'Faixa fixa',
      fixedRangeDescription: 'Em relação à data da resposta',
      fixedRangeDescriptionTime: 'Em relação à hora da resposta',
      relativeRange: 'Faixa relativa',
      relativeRangeDescription: 'Em relação a outra pergunta de data no formulário',
      relativeRangeDescriptionTime: 'Em relação a outra pergunta de hora no formulário',
      rangeCondition: 'Condição temporal',
      selectRangeCondition: 'Selecione uma opção',
      predefinedConditions: 'Predefinidas',
      customConditions: 'Personalizadas',
      offset: 'Deslocamento',
      hours: 'horas',
      days: 'dias',
      day: 'dia',
      hour: 'hora',
      timeModeWarning:
        'Hora não considera mudanças de dia. Use Data e hora para intervalos entre dias.',
      relativeTimeModeWarning:
        'Hora não considera mudanças de dia. Use Data e hora para comparar entre dias.',
      pickQuestion: 'Selecione uma pergunta',
      noQuestionsAvailable: 'Não há perguntas disponíveis para comparação',
      validationComparisonType: 'Tipo de comparação',
      betweenQuestionOffset: 'Entre pergunta e deslocamento',
      minimumValue: 'Valor mínimo',
      maximumValue: 'Valor máximo',
      and: 'e',
      minimumValueForOffsetIs: 'O deslocamento mínimo permitido é de',
      maximumValueForOffsetIs: 'O deslocamento máximo permitido é de',
      onlyToday: 'Somente hoje',
      noFutureDates: 'Não permitir datas futuras',
      noPastDates: 'Não permitir datas passadas',
      onlyCurrentTime: 'Somente hora atual',
      noFutureTimes: 'Não permitir horas futuras',
      noPastTimes: 'Não permitir horas passadas',
      after: 'Depois que',
      afterOrEqual: 'Depois ou igual que',
      before: 'Antes que',
      beforeOrEqual: 'Antes ou igual que',
      between: 'Entre',
      notBetween: 'Não está entre',
      rangeValidationErrorMessageForDate: 'O valor deve ser de pelo menos 1 dia.',
      rangeValidationErrorMessageForTime: 'O valor deve estar entre 1 e 23 horas.',
      rangeValidationErrorMessageForDateTime: 'O valor deve ser de pelo menos 24 horas.',
      notBetweenTimeWindowTooWideMessage: 'A soma de ambos os valores deve ser menor que 24 horas.',
      date_only_today: 'Selecione a data de hoje.',
      date_no_future: 'Insira uma data igual ou anterior a hoje.',
      date_no_past: 'Insira uma data igual ou posterior a hoje.',
      date_after_tomorrow: 'Insira a data de amanhã.',
      date_after_days:
        'Insira uma data desde amanhã até os próximos {{numOfOffsetDays}} {{stringOfOffsetDays}}.',
      date_after_or_equal_days:
        'Insira uma data desde hoje até {{numOfOffsetDays}} {{stringOfOffsetDays}} depois.',
      date_before_yesterday: 'Insira a data de ontem.',
      date_before_days:
        'Insira uma data desde ontem até {{numOfOffsetDays}} {{stringOfOffsetDays}} atrás.',
      date_before_or_equal_days:
        'Insira uma data desde hoje até {{numOfOffsetDays}} {{stringOfOffsetDays}} atrás.',
      date_between_days:
        'Insira uma data entre {{numOfLeftDays}} {{stringOfLeftDays}} antes e {{numOfRightDays}} {{stringOfRightDays}} depois de hoje.',

      time_only_now: 'Insira a hora atual.',
      time_no_future: 'Insira uma hora igual ou anterior a agora.',
      time_no_past: 'Insira uma hora igual ou posterior à hora atual.',
      time_after_next_hour: 'Insira uma hora dentro da próxima hora.',
      time_after_hours: 'Insira uma hora dentro das próximas {{hours}} {{stringOfOffsetHours}}.',
      time_after_or_equal_hours:
        'Insira uma hora desde agora ou até {{hours}} {{stringOfOffsetHours}} depois.',
      time_before_last_hour: 'Insira uma hora dentro da última hora.',
      time_before_hours:
        'Insira uma hora até {{numOfOffsetHours}} {{stringOfOffsetHours}} antes deste momento.',
      time_before_or_equal_hours:
        'Insira uma hora desde agora ou até {{numOfOffsetHours}} {{stringOfOffsetHours}} atrás.',
      time_between_hours:
        'Insira uma hora desde {{numOfLeftHours}} {{stringOfLeftHours}} antes até {{numOfRightHours}} {{stringOfRightHours}} depois deste momento.',

      datetime_only_today: 'Selecione uma data e hora de hoje.',
      datetime_no_future: 'Insira uma data e hora igual ou anterior a agora.',
      datetime_no_past: 'Insira uma data e hora igual ou posterior à hora atual.',
      datetime_after:
        'Insira uma data e hora até {{numOfOffsetDays}} {{stringOfOffsetDays}} e {{numOfOffsetHours}} {{stringOfOffsetHours}} depois deste momento.',
      datetime_after_days_only:
        'Insira uma data e hora até {{numOfOffsetDays}} {{stringOfOffsetDays}} depois deste momento.',
      datetime_after_or_equal:
        'Insira uma data e hora desde agora até {{numOfOffsetDays}} {{stringOfOffsetDays}} e {{numOfOffsetHours}} {{stringOfOffsetHours}} depois.',
      datetime_after_or_equal_days_only:
        'Insira uma data e hora desde agora até {{numOfOffsetDays}} {{stringOfOffsetDays}} depois.',
      datetime_before:
        'Insira uma data e hora até {{numOfOffsetDays}} {{stringOfOffsetDays}} e {{numOfOffsetHours}} {{stringOfOffsetHours}} atrás.',
      datetime_before_days_only:
        'Insira uma data e hora até {{numOfOffsetDays}} {{stringOfOffsetDays}} atrás.',
      datetime_before_or_equal:
        'Insira uma data e hora desde agora até {{numOfOffsetDays}} {{stringOfOffsetDays}} e {{numOfOffsetHours}} {{stringOfOffsetHours}} antes.',
      datetime_before_or_equal_days_only:
        'Insira uma data e hora desde agora até {{numOfOffsetDays}} {{stringOfOffsetDays}} antes.',
      datetime_between:
        'Insira uma data e hora entre {{numOfLeftDays}} {{stringOfLeftDays}} e {{numOfLeftHours}} {{stringOfLeftHours}} antes e {{numOfRightDays}} {{stringOfRightDays}} e {{numOfRightHours}} {{stringOfRightHours}} depois deste momento.',
      datetime_between_days_only:
        'Insira uma data e hora entre {{numOfLeftDays}} {{stringOfLeftDays}} antes e {{numOfRightDays}} {{stringOfRightDays}} depois deste momento.',
      datetime_between_left_days_only:
        'Insira uma data e hora entre {{numOfLeftDays}} {{stringOfLeftDays}} antes e {{numOfRightDays}} {{stringOfRightDays}} e {{numOfRightHours}} {{stringOfRightHours}} depois deste momento.',
      datetime_between_right_days_only:
        'Insira uma data e hora entre {{numOfLeftDays}} {{stringOfLeftDays}} e {{numOfLeftHours}} {{stringOfLeftHours}} antes e {{numOfRightDays}} {{stringOfRightDays}} depois deste momento.',
      date_relative_after: 'Insira uma data posterior a {{limit}}.',
      date_relative_after_or_equal: 'Insira uma data igual ou posterior a {{limit}}.',
      date_relative_before: 'Insira uma data anterior a {{limit}}.',
      date_relative_before_or_equal: 'Insira uma data igual ou anterior a {{limit}}.',
      date_relative_between: 'Insira uma data entre {{minLimit}} e {{maxLimit}}.',
      date_relative_not_between:
        'Insira uma data fora do intervalo entre {{minLimit}} e {{maxLimit}}.',
      date_relative_between_question_offset: 'Insira uma data entre {{minLimit}} e {{maxLimit}}.',
      datetime_relative_after: 'Insira uma data e hora posterior a {{limit}}.',
      datetime_relative_after_or_equal: 'Insira uma data e hora igual ou posterior a {{limit}}.',
      datetime_relative_before: 'Insira uma data e hora anterior a {{limit}}.',
      datetime_relative_before_or_equal: 'Insira uma data e hora igual ou anterior a {{limit}}.',
      datetime_relative_between: 'Insira uma data e hora entre {{minLimit}} e {{maxLimit}}.',
      datetime_relative_not_between:
        'Insira uma data e hora fora do intervalo entre {{minLimit}} e {{maxLimit}}.',
      datetime_relative_between_question_offset:
        'Insira uma data e hora entre {{minLimit}} e {{maxLimit}}.',
      time_relative_after: 'Insira uma hora posterior a {{limit}}.',
      time_relative_after_or_equal: 'Insira uma hora igual ou posterior a {{limit}}.',
      time_relative_before: 'Insira uma hora anterior a {{limit}}.',
      time_relative_before_or_equal: 'Insira uma hora igual ou anterior a {{limit}}.',
      time_relative_between: 'Insira uma hora entre {{minLimit}} e {{maxLimit}}.',
      time_relative_not_between:
        'Insira uma hora fora do intervalo entre {{minLimit}} e {{maxLimit}}.',
      time_relative_between_question_offset: 'Insira uma hora entre {{minLimit}} e {{maxLimit}}.',

      date_not_between_days:
        'Insira uma data fora do intervalo entre {{numOfLeftDays}} {{stringOfLeftDays}} antes e {{numOfRightDays}} {{stringOfRightDays}} depois de hoje.',
      time_not_between_hours:
        'Insira uma hora fora do intervalo entre {{numOfLeftHours}} {{stringOfLeftHours}} antes e {{numOfRightHours}} {{stringOfRightHours}} depois deste momento.',
      datetime_not_between:
        'Insira uma data e hora fora do intervalo entre {{numOfLeftDays}} {{stringOfLeftDays}} e {{numOfLeftHours}} {{stringOfLeftHours}} antes e {{numOfRightDays}} {{stringOfRightDays}} e {{numOfRightHours}} {{stringOfRightHours}} depois deste momento.',
      datetime_not_between_days_only:
        'Insira uma data e hora fora do intervalo entre {{numOfLeftDays}} {{stringOfLeftDays}} antes e {{numOfRightDays}} {{stringOfRightDays}} depois deste momento.',
      datetime_not_between_left_days_only:
        'Insira uma data e hora fora do intervalo entre {{numOfLeftDays}} {{stringOfLeftDays}} antes e {{numOfRightDays}} {{stringOfRightDays}} e {{numOfRightHours}} {{stringOfRightHours}} depois deste momento.',
      datetime_not_between_right_days_only:
        'Insira uma data e hora fora do intervalo entre {{numOfLeftDays}} {{stringOfLeftDays}} e {{numOfLeftHours}} {{stringOfLeftHours}} antes e {{numOfRightDays}} {{stringOfRightDays}} depois deste momento.',

      datetime: {
        afterMessage:
          'A data e hora deve ser posterior ao momento em que o formulário é respondido, com um máximo de {days} {daysUnit} e {hours} {hoursUnit} depois.',
        afterOrEqualMessage:
          'A data e hora deve ser igual ou posterior ao momento em que o formulário é respondido, com um máximo de {days} {daysUnit} e {hours} {hoursUnit} depois.',
        beforeMessage:
          'A data e hora deve ser anterior ao momento em que o formulário é respondido, com um máximo de {days} {daysUnit} e {hours} {hoursUnit} atrás.',
        beforeOrEqualMessage:
          'A data e hora deve ser o dia em que o formulário é respondido ou até {days} {daysUnit} e {hours} {hoursUnit} atrás.',
        betweenMessage:
          'A data e hora deve estar dentro do intervalo que vai desde {daysBefore} {daysBeforeUnit} e {hoursBefore} {hoursBeforeUnit} antes até {daysAfter} {daysAfterUnit} e {hoursAfter} {hoursAfterUnit} depois do momento em que o formulário é respondido.',
        notBetweenMessage:
          'A data e hora deve estar fora do intervalo que vai desde {daysBefore} {daysBeforeUnit} e {hoursBefore} {hoursBeforeUnit} antes até {daysAfter} {daysAfterUnit} e {hoursAfter} {hoursAfterUnit} depois do momento em que o formulário é respondido.',
        relativeAfterMessage:
          'A data e hora deve ser posterior a {questionName} mais {days} {daysUnit} e {hours} {hoursUnit}.',
        relativeAfterOrEqualMessage:
          'A data e hora deve ser igual ou posterior a {questionName} mais {days} {daysUnit} e {hours} {hoursUnit}.',
        relativeBeforeMessage:
          'A data e hora deve ser anterior a {questionName} mais {days} {daysUnit} e {hours} {hoursUnit}.',
        relativeBeforeOrEqualMessage:
          'A data e hora deve ser igual ou anterior a {questionName} mais {days} {daysUnit} e {hours} {hoursUnit}.',
        relativeBetweenMessage:
          'A data e hora deve estar entre {minQuestionName} e {maxQuestionName}.',
        relativeNotBetweenMessage:
          'A data e hora não deve estar entre {minQuestionName} e {maxQuestionName}.',
        relativeBetweenQuestionOffsetMessage:
          'A data e hora deve estar entre {questionName} e {questionName} mais {days} {daysUnit} e {hours} {hoursUnit}.',
      },
      date: {
        afterMessage:
          'A data deve ser posterior ao dia em que o formulário é respondido, com um máximo de {days} {daysUnit} depois.',
        afterOrEqualMessage:
          'A data deve ser o dia em que o formulário é respondido ou até {days} {daysUnit} depois.',
        beforeMessage:
          'A data deve ser anterior ao dia em que o formulário é respondido, com um máximo de {days} {daysUnit} atrás.',
        beforeOrEqualMessage:
          'A data deve ser o dia em que o formulário é respondido ou até {days} {daysUnit} atrás.',
        betweenMessage:
          'A data deve estar dentro do intervalo que vai de {daysBefore} {daysBeforeUnit} antes até {daysAfter} {daysAfterUnit} depois do momento em que o formulário é respondido.',
        notBetweenMessage:
          'A data deve estar fora do intervalo que vai de {daysBefore} {daysBeforeUnit} antes até {daysAfter} {daysAfterUnit} depois do momento em que o formulário é respondido.',
        relativeAfterMessage: 'A data deve ser posterior a {questionName} mais {days} {daysUnit}.',
        relativeAfterOrEqualMessage:
          'A data deve ser igual ou posterior a {questionName} mais {days} {daysUnit}.',
        relativeBeforeMessage: 'A data deve ser anterior a {questionName} mais {days} {daysUnit}.',
        relativeBeforeOrEqualMessage:
          'A data deve ser igual ou anterior a {questionName} mais {days} {daysUnit}.',
        relativeBetweenMessage: 'A data deve estar entre {minQuestionName} e {maxQuestionName}.',
        relativeNotBetweenMessage:
          'A data não deve estar entre {minQuestionName} e {maxQuestionName}.',
        relativeBetweenQuestionOffsetMessage:
          'A data deve estar entre {questionName} e {questionName} mais {days} {daysUnit}.',
      },
      time: {
        afterMessage:
          'A hora deve ser posterior ao momento em que o formulário é respondido, com um máximo de {hours} {hoursUnit} depois.',
        afterOrEqualMessage:
          'A hora deve ser no momento em que o formulário é respondido ou até {hours} {hoursUnit} depois.',
        beforeMessage:
          'A hora deve ser no máximo {hours} {hoursUnit} antes do momento em que o formulário é respondido.',
        beforeOrEqualMessage:
          'A hora deve ser no momento em que o formulário é respondido ou até {hours} {hoursUnit} atrás.',
        betweenMessage:
          'A hora deve estar dentro do intervalo que vai de {hoursBefore} {hoursBeforeUnit} antes até {hoursAfter} {hoursAfterUnit} depois do momento em que o formulário é respondido.',
        notBetweenMessage:
          'A hora deve estar fora do intervalo que vai de {hoursBefore} {hoursBeforeUnit} antes até {hoursAfter} {hoursAfterUnit} depois do momento em que o formulário é respondido.',
        relativeAfterMessage:
          'A hora deve ser posterior a {questionName} mais {hours} {hoursUnit}.',
        relativeAfterOrEqualMessage:
          'A hora deve ser igual ou posterior a {questionName} mais {hours} {hoursUnit}.',
        relativeBeforeMessage:
          'A hora deve ser anterior a {questionName} mais {hours} {hoursUnit}.',
        relativeBeforeOrEqualMessage:
          'A hora deve ser igual ou anterior a {questionName} mais {hours} {hoursUnit}.',
        relativeBetweenMessage: 'A hora deve estar entre {minQuestionName} e {maxQuestionName}.',
        relativeNotBetweenMessage:
          'A hora não deve estar entre {minQuestionName} e {maxQuestionName}.',
        relativeBetweenQuestionOffsetMessage:
          'A hora deve estar entre {questionName} e {questionName} mais {hours} {hoursUnit}.',
      },
    },
    number: 'Número',
    noValidation: 'Sem validação',
    validNumberWarning: 'Insira um número válido',
    validSetWarning: 'Insira um conjunto válido',
    separator: 'Separador',
    separatorWarning: 'Insira um separador válido',
    relatedList: 'Lista relacionada',
    updateAssetData: 'Atualizar dados',
    filterAssetsByLocation: 'Filtrar ativos por local',
    filterAssetsByLocationTitle: 'Filtrar ativos por local',
    filterAssetsByLocationPlaceholder: 'Selecione uma pergunta de local',
    filterAssetsByLocationSameRow: 'Local dentro da pergunta repetível',
    filterAssetsByLocationWholeForm: 'Local fora da pergunta repetível',
    filterAssetsByLocationCreateQuestion: 'Criar pergunta de local',
    filterAssetsByLocationNewQuestionName: 'Local',
    selectData: 'Selecione o dado do ativo a ser atualizado',
    selectMeterQuestion: 'Selecione a pergunta que capturará o dado',
    meterConfigBannerMeter:
      'O sistema atualizará automaticamente a informação do ativo com os dados registrados neste formulário.',
    addMeterQuestion: 'Adicione outra pergunta que capture o dado',
    addMeterConfiguration: 'Adicionar medidor',
    createNumberQuestion: 'Criar pergunta tipo número',
    createSelectMetadataQuestion: 'Criar pergunta tipo dados de opção única',
    header: 'Cabeçalho',
    headerPlaceholder: 'País | Cidade | Rua',
    headerWarning: 'Você deve inserir um cabeçalho que contenha o separador.',
    headerDefault: 'Lista sem cabeçalho',
    deprecatedWarning: 'Este tipo de pergunta não é mais suportado',
    combineAlert1: 'As perguntas só podem ser arrastadas para grupos de perguntas repetíveis.',
    combineAlert2:
      'Um grupo de perguntas repetíveis não pode conter outro grupo de perguntas repetíveis.',
    combineAlertTitle: 'Erro',
    emptySubform: 'Esvaziar',
    emptySubformAlert:
      'Não é possível deixar um grupo de perguntas repetíveis vazio; uma pergunta foi criada automaticamente.',
    emptySubformAlertTitle: 'Aviso',
    emptySubformTooltip: 'Remover todas as perguntas do grupo de perguntas repetíveis.',
    removeSubformQuestionTooltip: 'Remover pergunta do grupo de perguntas repetíveis.',
    subformRemoveConfirm:
      'Esta pergunta será removida deste grupo de perguntas repetíveis e adicionada ao formulário principal.',
    subformEmptyConfirm:
      'Todas as perguntas serão removidas do grupo de perguntas repetíveis e adicionadas ao formulário principal.',
    confirm: 'Confirmar',
    subformLimit: 'Limite de repetições',
    subformWarning: 'Para mais de 5 repetições, atualize seu plano em ajustes > faturamento',
    answer: 'Responda',
    includeComments: 'Comentário',
    commentsFormLabel: 'Selecione as respostas nas quais deseja incluir um comentário obrigatório',
    textCommentBtnTooltip: 'Texto Obrigatório',
    imageCommentBtnTooltip: 'Imagem Obrigatória',
    findingCommentBtnTooltip: 'Não Conformidade Obrigatória',
    imageCommentBtnTooltipDisabled: 'Você não pode adicionar mais de 500 imagens em total',
    share: 'Compartilhar',
    mobileTab: 'Celular',
    webTab: 'Computadora',
    max: 'Máximo',
    min: 'Mínimo',
    asCount: 'Contador',
    dataListSearchModalTitle: 'Minhas listas',
    editLists: 'Editar listas',
    editLocations: 'Editar locais',
    editAssets: 'Editar ativos',
    use: 'Usar',
    usedInThisForm: 'Usadas neste formulário',
    otherLists: 'Outras listas',
    customLists: 'Personalizadas',
    locations: 'Locais',
    selectAll: 'Selecionar todos',
    customLocations: 'Locais personalizados',
    searchInListPlaceholder: 'Buscar nesta lista...',
    locationAccessAlert:
      'Alguns usuários podem não ver esta pergunta se não tiverem acesso aos locais selecionados',
    customListsDescription:
      'Armazene qualquer tipo de dados que você precise consultar (incluindo locais antigos)',
    locationsDescription: 'Centralize e controle as informações sobre seus espaços físicos',
    assetsDescription: 'Gerencie ativos com todas as suas informações, localização e medidores',
    selectDataListInstruction: 'Selecione a lista de dados que melhor se adequa à sua pergunta',
    multi_photo: 'Múltiplas fotos',
    mobileOnlyAlert:
      'Disponível apenas no aplicativo. Se você tornar esta pergunta obrigatória, poderá responder ao formulário pela web, mas a pergunta não será exibida.',
    oldLocationsListWarning:
      'Você está usando uma lista de localizações antiga. Crie uma nova para aproveitar os benefícios.',
    availableAppWeb: 'Disponível na Web e no app',
    imageDisabledByLimit:
      'A opção de imagem foi desativada. Não é possível subir mais de 500 imagens em total',
    formBuilderBlockedAlertPart1:
      'Você não tem permissão para editar este formulário. Se você quiser criar ou editar formulários ',
    formBuilderBlockedAlertPart2: 'atualize seu plano',
    formBuilderBlockedAlertPart3: ' agora e desbloqueie a produtividade ilimitada',
    formNameExists: 'O nome do formulário já existe',
    saveError: 'Erro ao salvar o formulário',
    formLockedForEditing: 'O formulário está bloqueado para edição.',
    validationFixedRange: 'Rango fixo',
    validationRelativeRange: 'Rango relativo(disponível apenas no aplicativo)',
    validationComparisonType: 'Tipo de comparação',
    validationSelectComparisonType: 'Selecione tipo de comparação',
    minimumValue: 'Valor mínimo',
    maximumValue: 'Valor máximo',
    offset: 'Deslocamento',
    pickQuestion: 'Selecione uma pergunta',
    noQuestionsAvailable: 'Não há perguntas disponíveis para comparação',
    validationType: 'Tipo de validação',
    theNumberMustBe: 'O número deve ser',
    theNumberMustNotBe: 'O número não deve ser',
    than: 'que',
    plus: 'mais',
    minus: 'menos',
    hoursLabel: 'hrs',
    hourLabel: 'hr',
    andMinutesLabel: 'e',
    minuteLabel: 'minuto',
    minutesLabel: 'minutos',
    activityStartTime: 'Selecione a hora de início da jornada',
    activityDuration: 'Selecione a duração da jornada',
    activityInterval: 'Selecione o intervalo de tempo',
    activityDurationHours: 'Horas',
    activityDurationMinutes: 'Minutos',
    hourWord: 'hora',
    hoursWord: 'horas',
    workdayEndsAt: 'A jornada terminará às {time}.',
    workdayEndsAtNextDay: 'A jornada terminará às {time} do dia seguinte.',
    activityIntervalPlaceholderDisabled: 'Configure a duração primeiro',
    activityIntervalPlaceholderEmpty: 'Selecione um intervalo',
    activityIntervalHelperText: 'As opções disponíveis dependem da duração configurada.',
    activityIntervalRequired: 'Selecione um intervalo para poder salvar.',
    activityPeriodTimeIncomplete:
      'Há perguntas de atividade sem duração ou sem intervalo. Complete-as para salvar o formulário.',
    activityDurationInvalid: 'A duração deve ser de pelo menos 5 minutos.',
    every: 'Cada',
    chooseSelectMetadataQuestion: 'Selecione uma pergunta tipo {select_metadata}',
    chooseNumberQuestion: 'Selecione uma pergunta tipo {number}',
    tabs: {
      builder: 'Editor de formulários',
      integrations: 'Integrações',
      signature: 'Assinatura',
      email: 'Email',
      pdf: 'PDF',
    },
    dynamicSignatureModificationAlert: {
      title: 'Algumas assinaturas podem parar de funcionar',
      description:
        'As alterações que você está fazendo podem afetar as assinaturas eletrônicas associadas a essas perguntas.\nSe continuar, essas assinaturas podem ser desativadas.',
      continue: 'Continuar',
      cancel: 'Cancelar',
    },
  },
  help: {
    multi_option: 'Selecione uma opção em uma lista de itens',
    select_metadata: 'Selecione uma opção de uma lista de dados dinâmica',
    select_option_metadata: 'Selecione uma opção para cada item na lista',
    select_option_metadata_comments: 'Respostas fixas para cada item de uma lista de perguntas',
    track_code:
      'Forneça a opção de alterar ou selecionar o código de rastreamento de cada formulário',
    static_text: 'Permite adicionar texto fixo como instrução do formulário',
    select_check_metadata: 'Selecione vários itens em uma lista de dados dinâmica',
    select_number_metadata: 'Selecione um número para cada item na lista de dados dinâmica',
    select_text_metadata: 'Escreva um texto para cada item em uma lista de dados dinâmica',
    table: 'Crie um grupo de perguntas que você pode responder mais de uma vez',
  },
  types: {
    text: 'Texto',
    date: 'Data/Hora',
    number: 'Número',
    signature: 'Assinatura',
    barcode: 'Scanner',
    photo: 'Foto',
    multi_photo: 'Foto',
    multi_option: 'Seleção Única',
    select_option_metadata: 'Checklist',
    select_option_metadata_comments: 'Checklist',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Dados numéricos',
    select_text_metadata: 'Dados de texto',
    static_text: 'Instrução',
    select_metadata: 'Dados de opção única',
    table: 'Grupo de perguntas repetíveis',
    attachment: 'Anexar Arquivo',
    deprecated: 'Descontinuada',
    select_activity_period_time: 'Dados de atividade',
  },
  links: {
    appStore: 'https://itunes.apple.com/us/app/datascope-forms/id1132697668?l=pt&ls=1&mt=8',
    playStore: 'https://app.datascope.io/apk',
    appLink: 'https://datascope.page.link/3N7P',
  },
  listManager: {
    dataListSource: 'Fonte de dados',
    name: 'Nome',
    description: 'Descrição',
    code: 'Código',
    listItems: 'Lista de itens',
    emptyList: 'Esta lista não tem itens',
    attribute1: 'Atributo 1',
    attribute2: 'Atributo 2',
    listSubtitle:
      'Você pode usar essas listas nos tipos de perguntas: Checklist, checkbox, número lista dados, texto lista dados e seleção lista dados',
    seeAll: 'Veja todas as listas',
    seeObj: 'Ver os itens da lista',
    edit: 'Editar lista',
    editObj: 'Editar item',
    delete: 'Deletar lista',
    deleteAction: 'Eliminar',
    deleteObj: 'Deletar item',
    nameInUse: 'Nome já em uso',
    codeInUse: 'Código já em uso',
    nameEmpty: 'O nome não pode estar vazio',
    itemsStillEditing: 'Há itens em edição. Confirme ou cancele antes de salvar.',
    deleteObjectWarning: 'Tem certeza de que deseja remover este item da lista?',
    deleteYes: 'Sim, eliminar',
    confirmDeleteItemsTitle: 'Tem certeza de que deseja excluir {count} itens?',
    confirmDeleteItemsDesc:
      'Serão excluídos, mas as respostas enviadas anteriormente não serão afetadas',
    saveChanges: 'Salvar',
    cancel: 'Cancelar',
    itemsOf: 'Itens de:',
    addNewItem: '+ Novo item',
    page: 'Página ',
    of: ' de ',
    close: 'Cerrar',
    legacy: 'Ir para o gerenciador de lista completa',
    locations: 'Locais',
    assets: 'Ativos',
    customLists: 'Listas personalizadas',
    search: 'Buscar',
    searchPlaceholder: 'Buscar por nome da lista, criador, nome do formulário',
    import: 'Importar',
    importSuccess: 'Listas carregadas com sucesso. Podem levar alguns segundos para aparecer',
    importError: 'Erro ao importar lista',
    importDescription: 'Envie um arquivo XLS, XLSX ou CSV com os dados da lista. Máximo 5MB.',
    export: 'Exportar',
    newList: 'Nova lista',
    switchToLegacy: 'Voltar para a versão anterior',
    switchToNew: 'Voltar para a versão nova',
    duplicate: 'Duplicar',
    createdAt: 'Data de criação',
    type: 'Tipo',
    items: 'Itens',
    creator: 'Criador',
    usedIn: 'Usada em',
    usedInDescription: 'Formulários que usam esta lista',
    notUsed: 'Esta lista não está sendo usada em nenhum formulário.',
    noResults: 'Nenhuma lista encontrada',
    emptyTitle: 'Você não tem listas personalizadas',
    emptyDescription:
      'Crie sua primeira lista para organizar dados que poderá usar em seus formulários.',
    deleteConfirmTitle: 'Excluir lista',
    deleteSuccess: 'Listas excluídas com sucesso',
    deleteError: 'Erro ao excluir listas',
    duplicateSuccess: 'Lista duplicada com sucesso',
    duplicateError: 'Erro ao duplicar lista',
    createList: 'Criar lista',
    editList: 'Editar lista',
    details: 'Detalhes',
    listName: 'Nome da lista',
    listDescriptionOptional: 'Descrição da lista (opcional)',
    listType: 'Tipo de lista',
    typeStandard: 'Padrão',
    typePrice: 'Preço',
    typePercent: 'Porcentagem',
    typeStandardDesc: "Utiliza a pergunta 'Lista de dados'",
    typePriceDesc: "Utiliza a pergunta 'Número de lista de dados'",
    itemAttributes: 'Atributos dos itens',
    attributesExportHelper: 'Serão refletidos na exportação PDF',
    attributeNamePlaceholder: 'Nome do atributo',
    listItemsSection: 'Itens da lista',
    addItemsHelper: 'Adicione os itens que esta lista conterá',
    addItem: 'Adicionar item',
    noItemsYet: 'Nenhum item adicionado no momento',
    create: 'Criar',
    update: 'Atualizar',
    formInfoHelper:
      'Na resposta do formulário você só verá os itens desta lista que foram selecionados',
    actions: 'Ações',
    newItem: 'Novo item',
    list: 'Lista',
    searchByNameCode: 'Buscar por nome, código',
    lastResponse: 'Última resposta',
    results: 'Resultados',
    itemSelected: 'item selecionado',
    itemsSelected: 'itens selecionados',
    confirmDeleteItems: 'Tem certeza de que deseja excluir {count} itens?',
    confirmDeleteItem: 'Tem certeza de que deseja excluir "{name}"?',
    listNotFound: 'Lista não encontrada',
    nameItem: 'Nome do item',
    textType: 'Texto',
    imageType: 'Imagem',
    nameRequired: 'O nome é obrigatório',
    codeOptional: 'Codigo (opcional, gerado automaticamente)',
    codeInvalid: 'Apenas letras, numeros, espacos e sublinhado',
    codeTooLong: 'Maximo 30 caracteres',
    auditLogsTitle: 'Registros de importacao',
    importsTab: 'Listas importadas',
    menuImportNow: 'Importar agora',
    menuViewHistory: 'Ver historico',
    statusStarted: 'Iniciado',
    statusProcessing: 'Processando',
    statusCompleted: 'Concluido',
    statusFailed: 'Erro',
    typeSingle: 'Simples',
    typeMassive: 'Massivo',
    colDate: 'Data',
    colUser: 'Usuario',
    colType: 'Tipo',
    colList: 'Lista',
    colFile: 'Arquivo',
    colStatus: 'Status',
    colResult: 'Resultado',
    colDuration: 'Duracao',
    noImportsFound: 'Nenhuma importacao registrada',
    listsCount: 'listas',
    itemsDeleted: 'itens excluidos',
    deleteItemsError: 'Erro ao excluir itens',
    reorderError: 'Não foi possível salvar a nova ordem',
    reorderErrorListChanged: 'A lista mudou durante a ordenação. Recarregue e tente novamente',
    reorderItem: 'Reordenar {name}',
    orderListNoticeTitle: 'Quer reordenar os itens?',
    orderListNoticeBody: 'Habilite esta opção para arrastá-los e mudar sua posição.',
    orderListButton: 'Habilitar',
    orderListSuccess: 'Lista ordenada. Agora você pode arrastar os itens',
    orderListError: 'Não foi possível ordenar a lista. Tente novamente',
    noItemsInList: 'Nenhum item nesta lista',
    searchForm: 'Procurar formulário',
    noFormsFound: 'Nenhum formulário encontrado',
    lastResponseSent: 'Última resposta enviada usando esta lista',
    selectedList: 'lista selecionada',
    selectedLists: 'listas selecionadas',
    importTitle: 'Importar listas personalizadas',
    importStep1: 'Passo 1: Baixe o arquivo',
    importStep1Desc: 'Baixe o Excel de exemplo. Certifique-se de que os campos marcados com',
    importStep1Desc2: 'para importar seu arquivo corretamente.',
    importStep2: 'Passo 2: Edite o arquivo',
    importStep3: 'Passo 3: Envie o arquivo',
    importStep3Desc: 'Arraste e solte seu arquivo aqui ou selecione-o do seu computador.',
    downloadTemplate: 'Baixar exemplo',
    exportList: 'Exportar lista',
    dragDropExcel: 'Arraste e solte seu Excel aqui',
    browseComputer: 'procure',
    fileUploaded: 'Seu arquivo foi carregado',
    fileNotLoaded: 'Seu arquivo não pôde ser carregado',
    replaceFile: 'Substituir',
    fileRequirements: 'Requisitos do arquivo',
    reqNameColumn: "Coluna 'Nome' completa.",
    reqUniqueValues: "Colunas 'Nome' e 'Código' devem ter valores únicos.",
    reqMaxItems: 'Máximo 10.000 itens por lista.',
    assignListNames: 'Atribua um nome para cada lista carregada',
    formatError: 'Formato incorreto. O arquivo deve ser .XLSX ou .CSV',
    multiSheetError:
      'O arquivo contém várias planilhas. Para importar várias listas, use o importador na página principal de listas.',
    importing: 'Importando...',
    invalidListId: 'ID de lista inválido',
    duplicateCodeError: "O código '{key}' está repetido {count} vezes",
    duplicateNameError: "O nome '{key}' está repetido {count} vezes",
    templateExampleItem: 'Exemplo de item',
    templateExampleDesc: 'Descrição exemplo',
    inYourComputer: 'no seu computador',
    orPrefix: 'ou',
    listNameLabel: 'Nome da lista',
    sheetLabel: 'Folha',
    deleteConfirmTitlePlural: 'Excluir {count} listas',
    deleteConfirmDescSingle: 'Tem certeza de que deseja excluir "{name}"?',
    deleteConfirmDescPlural:
      'Tem certeza de que deseja excluir {count} listas? Esta ação não pode ser desfeita.',
    deleting: 'Excluindo...',
    form: 'formulário',
    forms: 'formulários',
  },
  locations: {
    summary: {
      tabs: { summary: 'Resumo do local', info: 'Informações do local' },
      header: {
        copyLink: 'Copiar link do local',
        copyLinkSuccess: 'Link do local copiado',
        copyLinkError: 'Não foi possível copiar o link',
        edit: 'Editar',
        origin: 'Local de origem',
        code: 'Código',
        subLocationsOne: '1 Sublocal',
        subLocationsOther: '{count} Sublocais',
        scopedTo: 'Vendo: {name}',
      },
      dateFilter: { title: 'Filtrar por data' },
      viewAll: 'Ver todos',
      dragToReorder: 'Arraste para reordenar',
      dragHandleAriaLabel: 'Reordenar {name}. Pressione espaço e use as setas.',
      inheritedLabel: 'Herdado',
      close: 'Fechar',
      seeMore: 'Ver mais {count}',
      seeLess: 'Ver menos',
      searchPlaceholder: 'Buscar',
      errorLoading: 'Não foi possível carregar este bloco.',
      retry: 'Tentar novamente',
      accessDenied: 'Você não tem acesso a este local.',
      blocks: {
        users: {
          title: 'Usuários',
          searchPlaceholder: 'Buscar por nome ou função',
          empty: 'Não há usuários neste alcance.',
          emptySearch: 'Nenhum usuário encontrado',
          emptySearchHint: 'Tente buscar com outro nome.',
          noPermission: 'Você não tem permissão para ver os usuários deste local.',
        },
        answers: {
          title: 'Respostas de formulário',
          searchPlaceholder: 'Buscar por ID ou nome do formulário',
          empty: 'Não há respostas neste alcance',
          emptySearch: 'Nenhuma resposta encontrada',
          emptySearchHint: 'Tente buscar com outro nome.',
          editAnswer: 'Editar resposta',
          downloadPdf: 'Baixar PDF',
          noState: 'Sem estado',
        },
        assets: {
          title: 'Ativos',
          searchPlaceholder: 'Buscar por nome ou tipo de ativo',
          empty: 'Não há ativos neste local.',
          emptySearch: 'Nenhum ativo encontrado',
          emptySearchHint: 'Tente buscar com outro nome.',
          noMeter: 'Não aplicável',
          noReading: '-',
          countOne: '1 ativo',
          countOther: '{count} ativos',
          columnAsset: 'Ativo',
          columnLastMeasurement: 'Última medição',
          noPermission: 'Você não tem permissão para ver os ativos deste local.',
        },
        tickets: {
          title: 'Tickets',
          searchPlaceholder: 'Buscar por ID ou nome',
          empty: 'Não há tickets neste alcance',
          emptySearch: 'Nenhum ticket encontrado',
          emptySearchHint: 'Tente buscar com outro nome.',
          createdBy: 'Criado por {name}',
        },
        signatures: {
          title: 'Assinaturas',
          searchPlaceholder: 'Buscar por usuário ou nome do formulário',
          empty: 'Não há assinaturas neste alcance',
          emptySearch: 'Nenhuma assinatura encontrada',
          emptySearchHint: 'Tente buscar com outro nome.',
          countOne: '{count}/{total} assinatura',
          countOther: '{count}/{total} assinaturas',
          showingLimited: 'Mostrando {shown} de {total}',
        },
        tasks: {
          title: 'Tarefas atribuídas',
          searchPlaceholder: 'Buscar por ID ou nome do formulário',
          overdue: 'Atrasada',
          completed: 'Concluída',
          empty: 'Não há tarefas atribuídas neste alcance',
          emptySearch: 'Nenhuma tarefa encontrada',
          emptySearchHint: 'Tente buscar com outro nome.',
          dueToday: 'Hoje',
          daysRemainingOne: 'Falta 1 dia',
          daysRemainingOther: 'Faltam {count} dias',
          daysOverdueOne: 'Há 1 dia',
          daysOverdueOther: 'Há {count} dias',
          showingLimited: 'Mostrando {shown} de {total}',
        },
        plannings: {
          title: 'Planejamentos',
          searchPlaceholder: 'Buscar por nome ou ativo',
          empty: 'Não há planejamentos neste alcance',
          emptySearch: 'Nenhum planejamento encontrado',
          emptySearchHint: 'Tente buscar com outro nome.',
          supervisorsCount: '{count} supervisores',
          showingLimited: 'Mostrando {shown} de {total}',
        },
      },
    },
    planLimits: {
      actionBlocked1: 'Esta ação está bloqueada pelos limites do seu plano atual.',
      actionBlocked2: 'Atualize seu plano para desbloquear.',
    },
    nestableLocationsBanner: {
      title: 'Você já experimentou os novos locais?',
      description:
        'Crie listas de locais hierárquicas para uma operação mais organizada, precisa e com controle de acesso. ',
      link: 'Criar locais',
    },
    title: 'Locais',
    searchPlaceholder: 'Pesquisar',
    header: {
      export: 'Exportar',
      import: 'Importar',
      createPlace: 'Criar local',
    },
    export: {
      success:
        'Locais exportados com sucesso. Enviaremos o arquivo para o seu e-mail assim que estiver pronto.',
      error:
        'Erro ao exportar locais. Tente novamente ou entre em contato com o suporte se o problema persistir.',
    },
    import: {
      title: 'Importar Locais',
      description: 'Importar locais de um arquivo Excel',
      step1Title: 'Passo 1: Baixe o arquivo',
      step1Description:
        'Use nossa planilha Excel para garantir que seus locais tenham o formato correto',
      downloadExample: 'Baixar exemplo',
      step2Title: 'Passo 2: Complete o Excel',
      step2Description: 'Adicione seus locais e sublocais seguindo o formato do exemplo.',
      step3Title: 'Passo 3: Carregue o arquivo',
      step3Description: 'Arraste e solte seu arquivo aqui ou selecione-o do seu computador.',
      dragDropText: 'Arraste e solte seu Excel aqui',
      browseText: 'ou procure em seu computador',
      replaceText: 'Substituir',
      fileUploadedText: 'Seu arquivo foi carregado',
      invalidFileType: 'Por favor, selecione um arquivo Excel válido (.xlsx)',
      importError: 'Erro ao importar locais',
      importButton: 'Importar',
      cancel: 'Cancelar',
      importing: 'Importando...',
      importingDescription: 'Apenas um momento, estamos organizando tudo...',
      errorTitle: 'Detectamos um erro.',
      errorMessage: 'Por favor, verifique se seus dados têm o formato correto.',
      templateDownloadError: 'Erro ao baixar o arquivo de exemplo',
      downloadingTemplate: 'Baixando...',
      templateUrlV2:
        'https://s3-us-west-2.amazonaws.com/data-scope/templates/nestable_locations/import_template_pt_v2.xlsx',
      instructions: {
        maxSheets: 'O arquivo deve conter no máximo {maxSheets} hojas para anidación de locais',
        maxRows: 'O arquivo deve conter no máximo {maxRows} linhas por cada hoja',
        maxColumns: 'O arquivo deve conter no máximo {maxColumns} colunas por cada fila',
        maxLengthSheetName: 'O nome da planilha deve ter no máximo {maxLengthSheetName} caracteres',
        nestingSheetName:
          'O nome da planilha de aninhamento deve ser o nome do local que está sendo aninhado',
      },
      errors: {
        templateDownloadError: 'Erro ao baixar o arquivo de exemplo',
        invalidFileType: 'Por favor, selecione um arquivo Excel válido (.xlsx)',
        importError: 'Erro ao importar locais',
        importButton: 'Importar',
        cancel: 'Cancelar',
        importing: 'Importando...',
        errorTitle: 'Detectamos um erro.',
        errorMessage: 'Por favor, verifique se seus dados têm o formato correto.',
      },
    },
    table: {
      locationName: 'Nome do local',
      users: 'Usuários',
      lastActivity: 'Última atividade',
      actions: 'Ações',
      resultsCount: 'Resultados: {start}-{end} de {total}',
      loadMore: 'Carregar mais locais',
      loadMoreError: 'Erro ao carregar mais locais. Por favor, tente novamente.',
      noResults: 'Nenhum resultado encontrado',
    },
    row: {
      location: 'Local',
      locations: 'Locais',
      selected: 'selecionado',
      selected_plural: 'selecionados',
      address: 'Endereço: ',
      phone: 'Telefone: ',
      viewLocation: 'Ver local',
      users: 'usuários',
      today: 'Hoje',
      sublocation: 'Sublocal',
      sublocations: 'Sublocais',
      sublocationTooltip:
        'Para criar mais sublocais você precisa de um plano superior. Atualize seu plano e desbloqueie esta e outras funcionalidades',
      viewDetails: 'Ver detalhes',
      edit: 'Editar',
      delete: 'Excluir',
      view: 'Ver local',
      deselectAll: 'Desmarcar todos',
      selectAll: 'Selecionar todos',
    },
    create: {
      title: 'Criar local',
      success: 'Local criado com sucesso',
      error: 'Erro ao criar local',
    },
    update: {
      title: 'Atualizar local',
      success: 'Local atualizado com sucesso',
      error: 'Erro ao atualizar local',
    },
    form: {
      displayDescription: 'Informações do local',
      createDescription: 'Criar novo local',
      updateDescription: 'Novo local',
      sections: {
        locationInfo: 'Informações de local',
        contactInfo: 'Informações de contato',
        ubication: 'Localização',
      },
      name: {
        label: 'Nome',
        placeholder: 'Digite o nome do local...',
        required: 'O nome do local é obrigatório',
        maxLength: 'O nome deve ter 1000 caracteres ou menos',
      },
      code: {
        label: 'Código do local',
        placeholder: 'Digite o código do local...',
        required: 'O código do local é obrigatório',
        maxLength: 'O código deve ter 255 caracteres ou menos',
        tooltip: 'Opcional. Se deixado em branco, um código único será gerado automaticamente.',
      },
      type: {
        label: 'Tipo de local',
        required: 'O tipo de local é obrigatório',
        placeholder: 'Selecione o tipo de instalação que você está criando...',
        options: {
          plant: 'Planta',
          enterprise: 'Empresa',
          warehouse: 'Armazém',
          production_line: 'Linha de produção',
          office: 'Escritório',
          branch: 'Filial',
          distribution_center: 'Centro de distribuição',
          other: 'Outro',
        },
      },
      origin: {
        label: 'Origem',
        required: 'A origem do local é obrigatória',
        placeholder: 'Selecione um local existente para associar...',
        tooltip:
          'Ao escolher um Local de origem, este novo local será posicionado dentro de outro, fazendo parte de uma estrutura.',
        options: {
          main: 'Local Principal',
          subsidiary: 'Subsidiária',
          remote: 'Local Remoto',
          temporary: 'Local Temporário',
          partner: 'Local do Parceiro',
        },
      },
      phone: {
        label: 'Telefone',
        placeholder: 'Digite o número de telefone...',
        validation: {
          missingCountryCode: 'O número deve incluir o código do país (ex: +55)',
          invalidCountryCode: 'Código do país inválido',
          invalidFormat: 'Formato de número inválido',
          invalidLength: 'Comprimento do número inválido para este país',
        },
      },
      description: {
        label: 'Descrição',
        placeholder: 'Digite uma descrição...',
        helper: 'Detalhes opcionais para este local',
        validation: {
          tooLong: 'A descrição deve ter 1000 caracteres ou menos',
        },
      },
      users: {
        title: 'Usuários e grupos',
        label: 'Usuários',
        placeholder: 'Digite informações dos usuários...',
        helper: 'Adicione informações sobre os usuários atribuídos a este local',
        showLess: 'Mostrar menos',
        showAll: 'Mostrar todos',
      },
      emails: {
        label: 'Emails',
        placeholder: 'Digite endereços de e-mail...',
        helper: 'Adicione endereços de e-mail relevantes para este local',
        inputHint: 'Separe os e-mails com vírgulas ou pressione Enter',
        validation: {
          tooMany: 'Limite máximo de caracteres excedido.',
        },
      },
      coordinates: {
        fetchAddressError: 'Não foi possível obter o endereço para as coordenadas inseridas.',
        latitude: {
          label: 'Latitude',
          invalid: 'A latitude deve estar entre -90 e 90.',
          placeholder: 'Insira a latitude...',
        },
        longitude: {
          label: 'Longitude',
          invalid: 'A longitude deve estar entre -180 e 180.',
          placeholder: 'Insira a longitude...',
        },
      },
      ubication: {
        label: 'Localização',
        search: 'Buscar endereço',
        hideMap: 'Ocultar mapa',
        showMap: 'Mostrar mapa',
        placeholder: 'Digite o endereço...',
        address: 'Endereço',
        city: 'Cidade',
        region: 'Estado/Região',
        country: 'País',
        postalCode: 'Código Postal',
        noLocationsFound: 'Nenhuma localização encontrada',
        clearData: 'Limpar dados',
        optionalLabel: 'Opcional',
        coordinatesInfoTooltip:
          'Você pode inserir a localização buscando um endereço ou digitando as coordenadas de latitude e longitude manualmente. Ambas as opções são válidas.',
      },
      buttons: {
        create: 'Criar',
        creating: 'Criando…',
        update: 'Atualizar',
        updating: 'Atualizando…',
        cancel: 'Cancelar',
      },
    },
    deleteConfirmation: {
      title: 'Tem certeza que deseja excluir este local?',
      message:
        'O local e todos os seus sublocais serão excluídos, mas as respostas, assinaturas e não conformidades não serão perdidas.',
      confirmButton: 'Excluir',
      cancelButton: 'Cancelar',
      success: 'Local excluído com sucesso',
      error: 'Erro ao excluir local',
    },
    emptyState: {
      noLocations: 'Nenhum local encontrado',
      suggestion: 'Tente palavras-chave diferentes ou verifique a ortografia',
      noLocationsCreated: 'Você ainda não tem locais criados',
      createNewLocation: 'Criar um novo local',
      migration: {
        title: 'Ainda não migrou seus locais?',
        description:
          'Agora você pode agrupar seus locais por tipo e visualizar tudo em um único lugar.',
        button: 'Migrar meus locais',
        close: 'Fechar',
        imgAlt:
          'Representação de um trabalhador com um calendário, um checklist e um PC flutuando ao redor',
        viewTitle: 'Migre seus locais para a nova estrutura',
        backButton: 'Voltar para locais',
        whyMigrate: 'Por que migrar?',
        reason1Title: 'Reúna toda a atividade recente em um único lugar:',
        reason1Description:
          'constatações, formulários completos, assinaturas, usuários e grupos associados.',
        reason2Title: 'Organize seus espaços:',
        reason2Description:
          'adicionando até quatro subníveis por local, para representar como seus sites realmente funcionam.',
        reason3Title:
          'Decida facilmente quais usuários ou grupos podem ver e trabalhar em cada local.',
        reason3Description: 'Os usuários só verão os locais que lhes foram atribuídos.',
        stepsTitle: 'Passo a passo para migrar seus locais',
        step1Title: 'Use seus locais atuais como base',
        step1Description:
          'Baixe um Excel com os locais que você já tem no DataScope daqui e use-o como base para completar o modelo e economizar tempo.',
        step2Title: 'Baixe o modelo',
        step2Description:
          'Use nosso modelo Excel para garantir que seus locais sejam carregados corretamente. Na primeira folha você define todos os locais. Se precisar de hierarquia, crie folhas adicionais para atribuir sublocais.',
        step3Title: 'Carregue o novo modelo para a plataforma',
        step3Description:
          'Quando você completar o modelo, importe-o aqui para atualizar seus locais com a nova estrutura.',
        faqTitle: 'Perguntas frequentes',
        faq1Question: 'O que vai acontecer com meus locais criados anteriormente?',
        faq1Answer:
          'Os locais antigos continuarão funcionando por um tempo. Em breve começaremos um processo gradual de fechamento para dar lugar à nova estrutura de locais.',
        faq2Question: 'Posso ainda acessar os locais antigos?',
        faq2Answer:
          'Sim! Você ainda poderá acessar seus locais antigos. Eles permanecerão no mesmo lugar, apenas mudarão de nome para Lista (Locais antigos) para diferenciá-los dos novos.',
        faq3Question: 'Meus formulários anteriores continuarão funcionando?',
        faq3Answer:
          'Sim, os formulários criados com locais antigos permanecerão ativos. No construtor de formulários você verá claramente diferenciados os locais antigos dos novos.',
        faq3Gif:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/old_locations_pt.gif',
        faq4Question: 'Como atribuo locais aos usuários?',
        faq4Answer:
          'Para Locais (novos) você pode atribuir usuários individualmente da seção Usuários. Para atribuições em massa, baixe e carregue o Excel de usuários.',
        faq5Question: 'Posso associar um formulário a vários locais?',
        faq5Answer:
          'Sim, desde que os locais estejam no mesmo nível hierárquico. Não é possível associar um formulário a locais de diferentes níveis.',
        faq6Question: 'Posso usar os novos locais sem ter migrado todos os anteriores?',
        faq6Answer:
          'Sim, você pode migrar parcialmente, desde que os locais pai já estejam criados na plataforma. Os locais antigos continuarão funcionando enquanto você completa a migração.',
        faq7Question: 'Como identifico se um local já foi migrado?',
        faq7Answer:
          'Na tabela de locais você poderá ver quais sublocais foram migrados sob cada local pai. Se ocorrer algum erro durante a migração, notificaremos você diretamente no processo.',
        helpTitle: 'Dúvidas ou precisa de ajuda?',
        helpDescription:
          'Se você tiver dúvidas sobre o processo, entre em contato conosco e ajudaremos você a completar a migração.',
        helpButton: 'Solicitar ajuda',
        accessBanner: 'Todos os usuários terão acesso aos locais que você migrar',
        bannerImageUrl:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/location-migration-banner-pt.png',
        modal: {
          title: 'Migrar seus locais',
          step1: 'Passo 1: Use seus locais existentes como base',
          step1Description:
            'Se você já tem locais criados no DataScope, pode baixá-los e usá-los como base para completar o modelo.',
          downloadExistingButton: 'Baixar seus locais existentes',
          downloading: 'Baixando...',
          step2: 'Passo 2: Baixe o modelo',
          step2Description:
            'Use o formato do modelo para garantir que seus locais sejam carregados corretamente.',
          downloadTemplateButton: 'Baixar o modelo',
          step3: 'Passo 3: Carregue seu arquivo',
          step3Description:
            'Quando tiver o modelo pronto, carregue-o aqui para migrar seus locais.',
          cancel: 'Cancelar',
          migrateButton: 'Migrar locais',
          migrating: 'Importando...',
          exportSuccess: 'Locais exportados com sucesso',
          exportError: 'Erro ao exportar locais',
          helpAccordion: {
            title: 'Como funciona o modelo?',
            videoTitle: 'Vídeo passo a passo',
            videoPlaceholder: '0:00 / 0:10',
            videoUrlV2:
              'https://fast.wistia.net/embed/iframe/yrylpsju9a?web_component=true&seo=true',
            fileStructureTitle: 'Estrutura do arquivo:',
            fileStructure1: 'Folha de importação:',
            fileStructure1Description:
              'Aqui você importa todos os seus locais e sublocais de um único arquivo.',
            fileStructure2: 'Você quer que um local tenha sublocais?',
            fileStructure2Description:
              'Na coluna Local de Origem, escreva o local ao qual pertencem.',
            fileStructure3: 'Lembre-se de completar os campos obrigatórios:',
            fileStructure3Description: 'Nome e Tipo de local.',
            fileStructure4: 'Latitude e longitude opcionais:',
            fileStructure4Description:
              'Você pode obtê-las pesquisando o endereço no Google Maps ou de',
            fileStructure4Link: 'aqui',
            fileStructure4Note: 'Use a mesma localização para evitar erros ao importar.',
            technicalLimitsTitle: 'Limites técnicos para importar:',
            technicalLimit1: 'Você pode importar até 2.500 locais por arquivo.',
          },
        },
      },
      utility: {
        title: 'Estrutura e controla sua operação com locais',
        preConfigTitle: 'Para quê serve locais?',
        utilityTitle1: 'Centralizar a informação:',
        utilityDescription1:
          'reúne em um único lugar toda a atividade recente, incluindo não conformidades, formulários, assinaturas e usuários.',
        utilityTitle2: 'Criar hierarquias de locais:',
        utilityDescription2:
          'adiciona até quatro sublocais por local para representar a estrutura real de suas operações.',
        utilityTitle3: 'Atribuir acesso facilmente:',
        utilityDescription3: 'define quais usuários podem visualizar e trabalhar em cada local.',
      },
      reasons: {
        title: 'Por que usar locais?',
        cardTitle1: 'Estrutura flexível',
        cardDescription1:
          'Adaptar os níveis de local à forma como sua operação funciona no mundo real.',
        cardTitle2: 'Informação por níveis e tipos',
        cardDescription2:
          'Você pode visualizar e gerenciar formulários, não conformidades, usuários e assinaturas associados a cada local.',
        cardTitle3: 'Atribuir usuários em cada local',
        cardDescription3: 'Atribuir usuários responsáveis a cada local.',
      },
      carousel: {
        title: 'Crie seu primeiro local',
        gifAlt: 'Demostração gif para criar locais',
        step1Title: 'Criar local',
        step1Description:
          'Crie um local clicando em Criar local e defina um nome, nível de local, tipo e se aplicável, associe-o a um existente.',
        step2Title: 'Complete os dados',
        step2Description:
          'Adicione um número de telefone, email e uma breve descrição ajudará você a identificá-lo mais tarde.',
        step3Title: 'Adicione o endereço',
        step3Description:
          'Digite o endereço e detalhes extras para melhor identificá-lo no mapa. Para finalizar, clique em Criar.',
        nextStep: 'Próximo',
        previousStep: 'Anterior',
      },
      legacy: {
        title: 'Locais antigos (Temporário)',
        description:
          'Você ainda pode acessá-los aqui, embora não sejam compatíveis com todas as novas funcionalidades',
        button: 'Ver locais antigos',
      },
      createNewTitle: 'Crie uma nova forma de organizar sua operação',
      oldLocationsTitle: 'Seus locais são antigos.',
      oldLocationsDescription: 'Crie novos e aproveite os benefícios',
      createButton: 'Criar locais',
      selectorEmptyIllustrationAlt: 'Ilustração do estado vazio de locais',
      noLocationsAvailable: 'Não há locais disponíveis',
      searchPlaceholder: 'Pesquisar locais...',
      loadingLocations: 'Carregando locais...',
    },
  },
  tasksForms: {
    activateScroll: 'Ativar scroll na app',
    disableScroll: 'Desativar scroll na app',
    scrollActiveSuccess: 'Scroll ativado com sucesso',
    scrollDisabledSuccess: 'Scroll desativado com sucesso',
    templates: 'Modelos de formulários',
    useTemplate: 'Usar modelo',
    newVersion: 'Mudar para a nova versão',
    oldVersion: 'Mudar para a versão antiga',
    uniq: 'O nome da pergunta deve ser exclusivo',
    title: 'Formulários',
    preview: 'visualização',
    export: 'Exportar',
    export_help: 'Você pode copiar este código fonte e colar em outro formulário',
    import: 'Importar',
    import_confirm: 'Tem certeza de que deseja importar este formulário?',
    import_success: 'Seu formulário está sendo importado, pode demorar alguns minutos',
    importSuccessSync: 'Seu formulário foi importado com sucesso',
    start_testing: 'É hora de testar seu primeiro formulário!',
    test_button: 'Testar formulário',
    start_testing_desc:
      'Parabéns, você tem um novo formulário! Agora você pode começar a testá-lo em seu aplicativo móvel.',
    import_error:
      'Falha ao importar o formulário. Verifique se é um formulário válido ou se já está importado.',
    clone: 'Clone',
    default_title: 'Meu formulário',
    default_question: 'Pergunta',
    drag_questions:
      'Ainda não existem perguntas no seu formulário. Arraste e solte as perguntas que deseja utilizar aqui',
    new: 'Novo Formulário',
    new_ai: 'Formulário com IA',
    google_forms: 'Importar Google Form',
    are_you_sure: 'Você tem certeza?',
    status: 'Status',
    active: 'Publicados',
    inactive: 'Oculto',
    publish: 'Publicar',
    unpublish: 'Omitir',
    last_info: 'Adicione HTML no final do PDF',
    current_logo: 'Forma atual Logo',
    form_logo: 'Logo formulário',
    form_name: 'Nome',
    // Labels of the Status sort control of the paginated forms tables. Ascending
    // is active forms first, matching the service.
    sortByStatus: {
      unsorted: 'Ordenar por status',
      ascending: 'Formulários ativos primeiro',
      descending: 'Formulários ocultos primeiro',
    },
    actions: 'Configurar',
    answer_form: 'Responder',
    edit_app: 'Configurar Formulário',
    edit_share: 'Compartilhar',
    error_form: 'Ocorreu um erro',
    success_form: 'Sucesso',
    delete: 'Deletar',
    date: 'Data hora',
    date_type: 'Tipo de data',
    date_type_date: 'Data',
    date_type_datetime: 'Data hora',
    date_type_time: 'Tempo',
    text: 'Texto',
    number: 'Número',
    multi_option: 'Seleção Única',
    signature: 'Assinatura',
    barcode: 'Scanner',
    photo: 'Foto',
    select_metadata: 'Dados de opção única',
    select_option_metadata: 'Checklist',
    track_code: 'Código de acompanhamento',
    static_text: 'Texto estático',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Dados numéricos',
    select_text_metadata: 'Dados de texto',
    table: 'Grupo de perguntas repetíveis',
    name: 'Questão',
    description: 'Pergunta Descrição',
    label: 'Nome da Seção de Perguntas',
    choices: 'Alternativas',
    choice: 'Escolha',
    add_choice: 'Adicionar escolha',
    list_values: 'Lista de Valores',
    add_list_value: 'Adicionar valor da lista',
    add_question: 'Adicionar pergunta',
    delete_choice: 'Excluir',
    drop_question: 'Drop as perguntas repetíveis aqui',
    metadata_type: 'Fonte da Lista de Dados',
    create_metadata: 'Criar nova fonte de lista de dados',
    change_metadata: 'Alterar fonte da lista de dados',
    save_form: 'Salvar Formulário',
    version: 'versão',
    no_name: 'Sem nome',
    no_questions: 'Deve ter pelo menos uma pergunta',
    no_data: 'Nenhum formulário disponível',
    blank_table: 'Subformulário deve ter pelo menos uma pergunta',
    sub_questions: 'Sub-Perguntas',
    disable_gallery: 'Desativar Galeria',
    required: 'Obrigatório',
    back: 'Voltar',
    location: 'Lista de Locais',
    help_title: 'Precisa de ajuda para criar seu formulário?',
    help_instruction: 'Solicite ajuda para criar formulário',
    help_description:
      '***Por favor, explique as informações que deseja coletar e anexe uma imagem do formulário que deseja converter',
    example_title_1: 'Crie seus próprios formulários digitais',
    example_description_1:
      'Com o Form Builder você pode criar formulários perfeitos. É fácil, intuitivo e poderoso.',
    success_created: 'O formulário foi criado com sucesso.',
    hide_logic: 'Mover com base na resposta',
    show_price: 'Mostrar preço',
    show_avg: 'Mostrar Média',
    show_factor: 'Mostrar Multiplicação',
    show_percent: 'Mostrar por cento',
    equal: 'Igual',
    not_equal: 'Diferente',
    if: 'SE',
    is: 'É',
    to: 'A',
    go_to: 'IR PARA',
    next_question: 'Próxima pergunta',
    finish_form: 'Termine o formulário',
    standard_pdf: 'PDF Padrão',
    customized_pdf: 'PDF Personalizado',
    open_editor: 'Abra o Editor PDF',
    own_pdf: 'Crie seu próprio layout de PDF',
    need_your_pdf: 'Precisa do seu próprio design de PDF?',
    pdf_description:
      'O construtor de PDF mais flexível para criar seus próprios documentos em um layout personalizado a partir dos dados coletados.',
    folders: 'Pastas',
    manage_folders: 'Nova pasta',
    manage_states: 'Gerenciar estados',
    view_all_folders: 'Ver todas as pastas',
    searchSend: 'Procurar',
    searchForm: 'Procurar formulário...',
    custom_pdf: {
      step1: 'Criar Modelo',
      step1_desc:
        'O primeiro passo é criar seu próprio modelo usando o editor de PDF. É possível usar todas as perguntas do formulário. A última resposta será usada como exemplo.',
      step2: 'Ativar Modelo',
      step2_desc:
        'O próximo passo é ativar o modelo quando estiver pronto. Quando você ativar isso, todos os novos PDF serão gerados com este formato.',
    },
    help: {
      multi_option: 'Selecione 1 alternativa entre varias opções inseridas manualmente',
      select_metadata: 'Selecione 1 item dentro de uma lista importada na plataforma',
      select_option_metadata: 'Respostas fixas para cada item de uma lista de perguntas',
      track_code:
        'Forneça a opção de alterar ou selecionar o código de rastreamento de cada formulário',
      static_text: 'Instruções de preenchimento (não aparece nas respostas)',
      select_check_metadata: 'Checklist de items (permite selecionar vários)',
      select_number_metadata: 'Vários campos para respostas de números em uma mesma tela',
      select_text_metadata: 'Selecione um texto para vários itens de uma lista personalizada',
      table:
        'Crie loopings para que um conjunto de perguntas possa ser respondido quantas vezes forem necessárias',
      description:
        'Texto mais longo para mostrar no aplicativo. Não aparece na exportação dos dados. (Opcional)',
      title: 'Título curto para identificar a pergunta. Aparece na exportação dos dados.',
    },
    share: {
      title: 'Gerar link Google Forms',
      link: 'Link:',
      edit_link: 'Editar Google Form',
      export: 'Exportar Google Form',
      sendgrid_template_id: 'd-8f629bbc6b7e4af7a28346e9f27bf3e7',
      inactive_public_form: 'Este formulário não está mais acessível por meio deste link.',
      success_message: 'Recebemos sua respostas corretamente',
      make_form_private: 'Remova o acesso público ao formulário',
      make_form_private_notice:
        'Este formulário agora é privado. Links públicos compartilhados anteriormente não são mais válidos.',
      make_form_public: 'Tornar este formulário público',
      make_form_public_notice:
        'Este formulário agora é público. Agora você pode compartilhar com pessoas fora de sua organização!',
      share_via_email: 'Compartilhe este formulário por meio de um email',
      share_email_tooltip:
        'Um link público, acessível a qualquer pessoa, será enviado para os e-mails que não estão associados a esta conta. Um link de uso privado será enviado para os e-mails que pertencem a usuários registrados desta conta.',
      share_public_link: 'Compartilhe este formulário por meio de um link público',
      share_public_link_tooltip:
        'Qualquer pessoa, usuários registrados e não registrados, poderá preencher este formulário se você compartilhar o link público com eles. Suas respostas serão registradas com o nome de um usuário genérico, webforms_account_',
      share: 'Compartilhar',
      copy: 'Copiar',
      trigger: 'Gatilho não instalado. Limite de 20 atingido.',
      loading: 'O formulário está carregando...',
      failed: 'Falha na exportação do formulário.',
      auth: "Adendo: 'se você tiver problemas, tente sair do Google (por exemplo, no google.com.br) e faça login apenas com a conta para a qual deseja exportar o formulário.'",
      add_all_permissions: 'Adicione este formulário a todos os usuários',
      permission_success:
        'Permissão adicionada a todos os usuários, você precisa fazer logout e login novamente no aplicativo para atualizar os formulários ',
    },
    delete_form_confirm: 'Tem certeza de que deseja eliminar este formulário?',
    delete_form_warning: 'Uma vez deletado, não pode ser recuperado',
    delete_form_success: 'Formulário deletado com sucesso',
    delete_form_failure: 'Exclusão do formulário falhou',
    clone_form_success: 'Formulário duplicado com sucesso',
    clone_form_failure: 'Falha na duplicação do formulário',
    publish_form_success: 'Formulário publicado com sucesso',
    publish_form_failure: 'Falha na publicação do formulário',
    unpublish_form_success: 'Formulário omitido com sucesso',
    unpublish_form_failure: 'Falha na omissão do formulário',
    rename: 'Renomear',
    rename_folder: 'Renomear pasta',
    folder_name: 'Nome do pasta',
    new_name: 'Novo nome',
    update: 'Atualizar',
    cancel: 'Cancelar',
    rename_success: 'Pasta renomeada com sucesso',
    rename_failure: 'Erro ao renomear a pasta',
    delete_folder_confirm: 'Tem certeza de que quer eliminar la pasta ',
    delete_warning:
      'Uma vez eliminada, estes formulários passarão a seção de Formulários (sem pasta).',
    delete_folder_success: 'Pasta eliminada com sucesso',
    delete_folder_failure: 'Erro ao eliminar a pasta',
    move_to_folder: 'Mover para a pasta',
    lockEditing: 'Bloquear edição',
    unlockEditing: 'Habilitar edição',
    unlockEditingSuccess: 'Formulário habilitado com sucesso para edição',
    unlockEditingFailure: 'Erro ao habilitar o formulário para edição',
    editingLocked: 'Edição bloqueada',
    editingLockedBy: 'Edição bloqueada por:',
    unknownUser: 'Usuário desconhecido',
    lockEditingConfirmModal: {
      title: 'Bloquear edição do formulário',
      message:
        'Se você bloquear, ninguém mais poderá editar este formulário. Apenas você ou o suporte poderão desbloqueá-lo.',
      confirmButton: 'Bloquear',
      cancelButton: 'Cancelar',
      successMessage: 'Formulário bloqueado com sucesso para edição',
      failureMessage: 'Erro ao bloquear o formulário para edição',
    },
    remove_from_folder: 'Remover da pasta',
    move: 'Mover',
    warn_empty_folder: 'Esta ação eliminará a pasta que ficar vazia.',
    move_form_success: 'Formulário movido com sucesso',
    move_forms_success: 'Formulários movidos com sucesso',
    move_form_failure: 'Erro ao tentar mover o formulário',
    move_forms_failure: 'Erro ao tentar mover os formulários',
    create: 'Criar',
    create_form_folder: 'Criar pasta de formulários',
    create_folder_success: 'Pasta criada com sucesso',
    create_folder_failure: 'Erro ao criar a pasta',
    how_to_create_folder: 'Como você quer criar sua pasta?',
    next: 'Seguinte',
    form_selection: 'Seleção de formulários',
    no_forms_available: 'Você não tem formulários disponíveis neste moment',
    forms: 'Formulários',
    form: 'formulário',
    bulk_action: {
      publish: {
        confirm: 'Tem certeza de que deseja publicar',
        info: 'Uma vez publicados, você pode desativá-los novamente.',
        success: 'Formulários publicados com sucesso',
        failure: 'Falha na publicação dos formulários',
      },
      unpublish: {
        confirm: 'Tem certeza de que deseja omitir',
        info: 'Uma vez omitidos, você pode publicá-los novamente.',
        success: 'Formulários publicados com sucesso',
        failure: 'Falha na publicação dos formulários',
      },
      delete: {
        confirm: 'Você tem certeza de que deseja eliminar',
        info: 'Uma vez eliminados, você não poderá recuperá-los novamente.',
        success: 'Formulários excluídos com sucesso',
        failure: 'Exclusão do formulários falhou',
      },
    },
    formResults: 'Resultados: ',
    formResultsOf: 'de',
    current_folder: 'Pasta atual:',
    formLimitReachedTooltip: 'Você atingiu o limite de formulários permitidos. ',
    upgradePlanTooltipLink: 'Atualize seu plano',
    upgradePlanTooltip: ' para criar formulários',
    importPermissionError: 'Você não tem permissão para importar modelos de formulários',
    projectLimitReachedError:
      'Não foi possível importar o formulário. Você atingiu o número máximo de formulários permitidos.',
    folder: 'Pasta',
    new_form_create: 'Formulário',
    form_ai: 'Formulário com IA',
    forms_limit: {
      title: 'Limite de formulários atingido',
      description:
        'Você atingiu o limite de 3 formulários em seu plano atual. Para criar mais formulários, atualize seu plano e acesse mais funcionalidades:',
      benefit1: 'Formulários ilimitados',
      benefit2: 'Mais opções de personalização',
      benefit3: 'Maior capacidade de armazenamento',
      confirm: 'Desbloqueie mais formulários agora',
      cancel: 'Continuar com a versão gratuita',
      confirm_chat_message: 'Olá, preciso criar mais formulários. Como posso atualizar meu plano?',
    },
  },
  mobileUsers: {
    users: 'Usuários',
    new: 'Novo usuário',
    import: 'Importar',
    import_users: 'Importar Usuários',
    how_import: 'Como importar usuários?',
    bulk_actions: 'Ações em massa',
    add_users_to_group: 'Adicionar usuários ao grupo',
    deactivate_users: 'Desativar usuários',
    add: 'Adicionar',
    add_to_group: 'Adicionar ao grupo',
    selectAGroup: 'Selecionar um grupo',
    identifier_help: 'Necessário iniciar sessão no aplicativo móvel e na web',
    duplicate_user:
      'Um usuário excluído com o mesmo e-mail já existe. Por favor, reative esse usuário em vez disso',
    old_password_required:
      'inválido. Para alterar a confirmação da senha do administrador necessária.',
    group_users: 'Grupos de usuários',
    group_new: 'Novo grupo',
    you: 'você',
    advanced: 'Configuração avançada',
    location_perm:
      'Permissões de locais (visualizar apenas as respostas que foram preenchidas escolhendo determinados locais. Em branco = poderá visualizar todos)',
    forms_perm:
      'Permissões de formulários (Pode acessar apenas determinados formularios. Em branco = poderá acessar todos)',
    activated: 'Ativos',
    deactivated: 'Desativados',
    modifications_history: 'história',
    noGroups: 'Você não tem grupos de usuários',
    infoNotice:
      'Os usuários só poderão ver os formulários e as respostas que se aplicam a eles de acordo com seu grupo.',
    delete_group: 'Excluir grupo',
    cancel: 'Cancelar',
    delete: 'Excluir',
    rename: 'Renomear',
    rename_group: 'Renomear grupo',
    group_name: 'Nome do grupo',
    new_name: 'Novo nome',
    update: 'Atualizar',
    confirm_group_delete: 'Tem certeza que deseja deletar o grupo?',
    confirm_group_delete2:
      'Depois de excluí-lo, os usuários que não estiverem em outros grupos ficarão sem grupo e terão as permissões individuais atribuídas anteriormente.',
    update_groups_success: 'Alterações feitas com sucesso',
    update_groups_error: 'Ocorreu um erro ao salvar as alterações',
    userInfo: 'Informação do Usuário',
    userGroupsHelp: 'Este usuário pertence aos seguintes grupos:',
    manageGroupModalTitle: 'Permissões em',
    searchForm: 'Procurar formulário...',
    searchUser: 'Procurar usuário...',
    groupUpdateSuccess: 'Grupo atualizado com sucesso',
    permissions_title: 'Permissões',
    forms_title: 'Formulários',
    group_name_exists: 'Já existe um grupo com esse nome',
    edit_group_permissions: 'Permissões de formulário',
    edit_groups: 'Editar grupos',
    save: 'Salvar',
    editGroupsInfo:
      'Usuários atribuídos a um ou mais grupos receberão permissões para acessar os formulários desses grupos. Consequentemente, eles não poderão ter formulários atribuídos individualmente ao mesmo tempo.',
    modifiedGroup: 'Grupo modificado',
    modificationAuthor: 'Autor da modificação',
    modificationDate: 'Data',
    modification: 'Modificação',
    added: 'Adicionado',
    removed: 'Removido',
    group: 'Grupo',
    createdGroup: 'Grupo criado',
    deletedGroup: 'Grupo excluído',
    renamedGroup: 'Grupo renomeado',
    emptyHistory: 'Não há histórico de modificações',
    previousName: 'Nome anterior',
    assetAssigned: 'Ativo atribuído ao usuário',
    assetRemoved: 'Ativo removido do usuário',
    removeFromGroup: 'Remover do grupo',
    remove: 'Remover',
    removeUsersConfirm: 'Você tem certeza de que deseja remover',
    removeUsersConfirm2: 'usuário(s) do grupo',
    onceUsersRemoved:
      'Uma vez removidos, eles se tornarão usuários sem grupo ou permanecerão nos outros grupos aos quais pertencem.',
    noUsersInGroup: 'Você ainda não adicionou usuários a este grupo',
    searchGroups: 'Procurar grupos...',
    pendingConfirmationTitle: 'Confirmação pendente',
    pendingConfirmationSubtitle: 'Compartilhe este link apenas com este usuário',
    copy: 'Copiar',
    linkCopied: 'Link copiado!',
    resendInvitation: 'Reenviar',
    deleteGroupPendingSignatureError: 'O grupo tem assinaturas pendentes',
    invite_user: {
      title: 'Convidar usuários',
      placeholder: 'exemplo@exemplo.com',
      help: 'Esses usuários terão permissões básicas, se você quiser alterá-las, clique em configurar permissões',
      btn: 'Convidar',
      config: 'Configurar permissões',
      successSingular: 'Convite enviado com sucesso',
      successPlural: 'Convites enviados com sucesso',
      error:
        'Falha ao convidar usuários, verifique se os e-mails são válidos e não são usados anteriormente',
      emailFormatError: 'Formato de e-mail incorreto, siga o exemplo@exemplo.com',
      emails: 'E-mails',
    },
    permissions: {
      answers: 'Pode visualizar as respostas dos formulários',
      evaluate: 'Pode alterar o status dos formulários (Plataforma Web)',
      chat: 'Pode usar o Chat (bate-papo) entre usuários da plataforma',
      tasks: 'Pode acessar todos os formulários disponíveis',
      assigned: 'Pode acessar formulários atribuidos a ele',
      users: 'Pode editar acessos ou criar novos usuários (Plataforma Web)',
      export: 'Pode exportar os dados (Plataforma Web)',
      metadata: 'Pode criar Listas Personalizadas  (Plataforma Web)',
      modify: 'Pode modificar suas próprias respostas (App)',
      edit_forms: 'Editar Formulários',
      evaluate_delete: 'Excluir/Recuperar Respostas do Formulário',
      access_to_charts: 'Acesso a gráficos',
      admin_account_config: 'Gerenciar configuração da conta',
      admin_signatures: 'Gerenciar assinaturas',
      admin_findings: 'Gerenciar não conformidades',
      admin_assets: 'Gerenciar ativos',
      admin_places: 'Gerenciar locais',
      assign_new_places: 'Atribuir novos locais automaticamente',
    },
    roles: {
      customized: 'Personalizado',
      administrator: 'Administrador',
      superadmin: 'Administrador Principal',
      supervisor: 'Supervisor',
      editing_operator: 'Operador de edição',
      operator: 'Operador',
    },
    table: {
      name: 'Nome',
      user: 'Usuário',
      role: 'Perfil',
      lastConnection: 'Última conexão',
      noLastConnection: 'Nenhuna conexão disponível',
      actions: 'Ações',
      configure: 'Configurar',
      edit: 'Editar',
      deactivate: 'Desabilitar',
      activate: 'Habilitar',
      no_data: 'Nenhum Usuário disponível',
      groups: 'Grupos',
      viewMore: 'Ver mais',
      noForms: 'Este grupo de usuários não possui formulários atribuídos',
      not_confirmed: 'Confirmação Pendente',
    },
    logs: {
      user: 'Usuário modificado',
      author: 'Autor da modificação',
      date: 'Data',
      modification: 'Modificação',
      activated: 'Habilitado',
      deactivated: 'Desabilitado',
    },
    deactivation: {
      cancel: 'Cancelar',
      confirmationTitle: 'Tem certeza de que deseja desativar este usuário?',
      revokesAllTitle: 'Isto remove o acesso a TODAS as contas dessa pessoa',
      revokesAllMessage:
        'O login dela vive nesta conta, então desativá-la aqui a deixa fora das outras %{count} contas onde trabalha, não só desta. Ela não poderá reverter isso sozinha.',
      revokesAllMessageNoCount:
        'O login dela vive nesta conta, então desativá-la aqui a deixa fora das demais contas onde trabalha, não só desta. Ela não poderá reverter isso sozinha.',
      confirmationMessage:
        'Os dados não serão perdidos. Você pode ativar o usuário novamente na seção Desativado',
      bulkConfirmationTitle: 'Tem certeza de que deseja desativar',
      bulkConfirmationMessage:
        'Os dados não serão perdidos. Você pode ativá-los novamente na seção Desativado.',
      bulkRevokesAllTitle: 'Alguns perdem o acesso a TODAS as suas contas',
      bulkRevokesAllMessageOne:
        'Um dos usuários que você selecionou tem o login nesta conta (%{emails}). Desativá-lo aqui o deixa de fora de todas as outras contas em que trabalha, e ele não vai poder reverter isso sozinho.',
      bulkRevokesAllMessage:
        '%{count} dos usuários que você selecionou têm o login nesta conta (%{emails}). Desativá-los aqui os deixa de fora de todas as outras contas em que trabalham, e eles não vão poder reverter isso sozinhos.',
      bulkRevokesAllMore: 'e mais %{count}',
      bulkImpactPartial:
        'Só conseguimos verificar os primeiros %{count} usuários selecionados, então pode haver mais.',
      bulkImpactUnavailable:
        'Não conseguimos verificar se algum deles perde o acesso às suas outras contas.',
      impactUnavailable:
        'Não conseguimos verificar se isso remove o acesso dele a todas as suas contas.',
      success: 'Usuário(s) desativado(s) com sucesso',
      error: 'Ocorreu um erro ao desativar o(s) usuário(s)',
    },
    activation: {
      error: 'Ocorreu um erro ao ativar o usuário',
    },
    createUser: {
      information: {
        title: 'Informação',
        name: 'Nome',
        lastName: 'Sobrenome',
        email: 'Email',
        example: 'exemplo@exemplo.com',
        password: 'Senha',
        passwordHelper: 'A senha deve ter pelo menos 6 caracteres',
        emailBelongsToIdentity:
          'Este usuário já tem conta no DataScope. Entrará com suas próprias credenciais',
        phone: 'Telefone',
      },
      group: {
        title: 'Grupo',
        selectHelper: 'Selecione um grupo existente (pode selecionar vários)',
        noGroup: 'Sem grupo',
        newGroup: 'Novo grupo',
        newGroupHelper: 'Escreva o nome do grupo',
        newGroupSuccess: 'Novo grupo criado com sucesso!',
        newGroupError: 'Ocorreu um erro ao criar o novo grupo',
        configuration: 'Deve configurar autorizações a formulários para este grupo',
        formsHelp: 'Formulários aos quais este usuário terá acesso:',
        cantEditPermissions:
          'Você não pode alterar suas próprias permissões de grupo. Peça para outra pessoa fazer isso se você quiser mudá-la.',
      },
      forms: {
        title: 'Formulários',
        allForms: 'Formulários',
        addForm: 'Adicionar formulário',
        formsHelper: 'Você poderá ver os formulários e as respostas dos selecionados',
        formsHelperDisabled: 'Você poderá ver esses formulários e suas respostas.',
        formsGroupHelper:
          'Os formulários e locais a que terá acesso este usuário são os que pertencem ao grupo previamente selecionado',
        seeMore: 'ver mais',
        groupsAlert:
          'Você não pode adicionar formulários porque você atribuiu ou criou um grupo anteriormente',
        back: 'Voltar',
        folders: 'Pastas',
        close: 'Fechar',
        formHasPendingSignature:
          'Este usuário tem assinaturas pendentes. Enquanto não forem respondidas ou excluídas, você não poderá modificar as permissões.',
        massSelectionBlockedByPendingSignature:
          'Seleção em massa de formulários está desativada devido a assinaturas pendentes.',
        foldersBlockedByPendingSignature:
          'Seleção de pastas está desativada devido a assinaturas pendentes. Abra a pasta para selecionar formulários.',
        cantEditPermissions:
          'Você não pode alterar suas próprias permissões de formulários. Peça para outra pessoa fazer isso se você quiser mudá-la.',
      },
      permissions: {
        title: 'Permissões',
        editingMyself:
          'Você não pode alterar suas próprias permissões. Peça para outra pessoa fazer isso se você quiser mudá-la.',
        basic: {
          title: 'Essencial',
          viewFormAnswers: 'Pode visualizar as respostas dos formulários',
          chat: 'Pode usar o Chat (bate-papo) entre usuários da plataforma',
          submitFormAnswers: 'Pode acessar todos os formulários disponíveis',
          viewAssignedForms: 'Pode acessar formulários atribuidos a ele',
        },
        advanced: {
          title: 'Avançado',
          changeFormStatus: 'Pode alterar o status dos formulários (Plataforma Web)',
          createMetadata: 'Pode criar Listas Personalizadas  (Plataforma Web)',
          editFormAnswers: 'Pode modificar suas próprias respostas (App)',
          editForms: 'Pode modificar seus formulários',
          evaluateDelete: 'Excluir e recuperar respostas de formulário',
          accessToCharts: 'Acesso a gráficos',
          assignNewPlaces: 'Atribuir novos locais automaticamente',
        },
        admin: {
          title: 'Administrador',
          viewAndCreateUsers: 'Pode editar acessos ou criar novos usuários (Plataforma Web)',
          exportData: 'Pode exportar os dados (Plataforma Web)',
          adminAccountConfig: 'Gerenciar configuração da conta',
          adminSignatures: 'Gerenciar assinaturas',
          adminFindings: 'Gerenciar não conformidades',
          adminAssets: 'Gerenciar ativos',
          adminPlaces: 'Gerenciar locais',
        },
        editFormsTooltip1: 'Este usuário não tem permissão para editar formulários. ',
        editFormsTooltipLink: 'Atualize seu plano',
        editFormsTooltip2: ' agora e desbloqueie a produtividade sem limites!',
      },
      locations: {
        title: 'Locais (Opcional)',
        helper:
          'Se ativar esta opção, o usuário só poderá ver os formulários associados aos locais que selecionar',
        locations: 'Locais',
        andOthers: ', e outros...',
        cantEditPermissions:
          'Você não pode alterar suas próprias permissões de locais. Peça para outra pessoa fazer isso se você quiser mudá-la.',
        allLocationsAccessBanner:
          'Este usuário tem acesso a todos os locais já criados. Se você quiser restringir os locais que ele pode ver, deverá selecioná-los manualmente nesta seção.',
        allNewLocationsAccessBadge: 'Acesso a todos os novos locais',
      },
      signature: {
        name: 'Nome completo',
        companyName: 'Nome da empresa',
        pronoun: 'Seu',
        userIdNumber: {
          default: 'Número de Identificação',
          CL: 'RUT',
          PE: 'DNI',
          MX: 'CURP/RFC',
          CO: 'CC',
          AR: 'DNI',
          PY: 'CI',
          ES: 'DNI/NIE',
          BR: 'CPF',
          UY: 'CI',
          BO: 'CI',
          EC: 'Cédula',
          VE: 'Cédula de identidade',
          US: 'SSN/DL/PP/ID',
          CA: 'SIN',
          DO: 'Cédula de identidade e eleitoral',
          CR: 'Cédula',
          PA: 'Cédula',
          GT: 'DPI',
          SV: 'DUI',
          HN: 'DNI',
          NI: 'Cédula',
          PR: 'SSN',
          CU: 'CI',
          JM: 'TRN',
          PT: 'NIF',
          FR: 'INSEE',
          DE: 'Personalausweisnummer/Steuer-ID',
          IT: 'Codice Fiscale',
          GB: 'Número de Seguro Nacional',
          IE: 'Número PPS',
          NL: 'BSN',
          BE: 'Número Nacional',
          CH: 'Número AHV',
          AT: 'Número de Segurança Social',
          SE: 'Número Pessoal',
          NO: 'ID Nacional',
          DK: 'Número CPR',
          FI: 'Código de Identidade Pessoal',
          IS: 'Kennitala',
          PL: 'PESEL',
          CZ: 'Número de Nascimento',
          SK: 'Número de Nascimento',
          HU: 'Número Tributário',
          RO: 'CNP',
          BG: 'EGN',
          GR: 'AMKA/AFM',
          HR: 'OIB',
          SI: 'EMSO',
          RS: 'JMBG',
          BA: 'JMBG',
          ME: 'JMBG',
          MK: 'EMBG',
          MT: 'Cartão de ID',
          CY: 'Número de ID',
          LU: 'ID Nacional',
          LT: 'Código Pessoal',
          LV: 'Código Pessoal',
          EE: 'Código Pessoal',
          TR: 'TC Kimlik No',
          IL: 'Número de ID',
          SA: 'ID Nacional',
          AE: 'Emirates ID',
          QA: 'QID',
          KW: 'ID Civil',
          BH: 'CPR',
          OM: 'ID Civil',
          JO: 'ID Nacional',
          LB: 'Número de ID',
          EG: 'ID Nacional',
          MA: 'CIN',
          TN: 'CIN',
          DZ: 'ID Nacional',
          ZA: 'Número de ID',
          NG: 'NIN',
          KE: 'Número de ID',
          GH: 'Ghana Card',
          UG: 'ID Nacional',
          TZ: 'NIDA',
          RW: 'ID Nacional',
          BW: 'Omang',
          NA: 'Número de ID',
          ZM: 'NRC',
          ZW: 'ID Nacional',
          ET: 'ID Nacional',
          CN: 'ID Nacional',
          IN: 'Aadhaar',
          PK: 'CNIC',
          BD: 'NID',
          JP: 'My Number',
          KR: 'RRN',
          SG: 'NRIC/FIN',
          MY: 'MyKad',
          ID: 'KTP',
          PH: 'UMID',
          TH: 'ID Nacional',
          VN: 'CCCD',
          HK: 'HKID',
          TW: 'ID Nacional',
          LK: 'NIC',
          NP: 'ID Nacional',
          AU: 'TFN/Medicare',
          NZ: 'Número IRD',
          RU: 'SNILS',
          UA: 'Número Tributário',
          BY: 'ID Nacional',
          KZ: 'IIN',
          UZ: 'PINFL',
          GE: 'Número Pessoal',
          AM: 'Cartão Social',
          AZ: 'FIN',
        },
        country: 'País',
        selectCountry: 'Selecione um país',
        noResults: 'Nenhum país encontrado',
        userEmail: 'E-mail pessoal',
        legalRepresentative: 'Representante legal',
        companyIdNumber: {
          default: 'Número de Identificação Fiscal',
          CL: 'RUT',
          PE: 'RUC',
          MX: 'RFC',
          CO: 'NIT',
          AR: 'CUIT',
          PY: 'RUC',
          ES: 'NIF',
          BR: 'CNPJ',
          UY: 'RUT',
          BO: 'NIT',
          EC: 'RUC',
          VE: 'RIF',
          US: 'EIN',
          CA: 'BN',
          DO: 'RNC',
          CR: 'Cédula Jurídica',
          PA: 'RUC',
          GT: 'NIT',
          SV: 'NIT',
          HN: 'RTN',
          NI: 'RUC',
          PR: 'EIN',
          CU: 'NIT',
          JM: 'TRN',
          PT: 'NIPC',
          FR: 'SIREN',
          DE: 'Número Tributário',
          IT: 'Partita IVA',
          GB: 'Número',
          IE: 'Número',
          NL: 'KvK',
          BE: 'BCE/KBO',
          CH: 'UID',
          AT: 'Número Tributário',
          SE: 'Número Org',
          NO: 'Número Org',
          DK: 'CVR',
          FI: 'Y-tunnus',
          IS: 'Kennitala',
          PL: 'NIP',
          CZ: 'IČO',
          SK: 'IČO',
          HU: 'Número Tributário',
          RO: 'CUI',
          BG: 'UIC',
          GR: 'AFM',
          HR: 'OIB',
          SI: 'Número Tributário',
          RS: 'PIB',
          BA: 'Número Tributário',
          ME: 'Número Tributário',
          MK: 'Número Tributário',
          MT: 'Número IVA',
          CY: 'Número Tributário',
          LU: 'Número Tributário',
          LT: 'Código',
          LV: 'Número',
          EE: 'Código',
          TR: 'Número Tributário',
          IL: 'Número',
          SA: 'Número CR',
          AE: 'Licença Comercial',
          QA: 'Número CR',
          KW: 'Número CR',
          BH: 'Número CR',
          OM: 'Número CR',
          JO: 'Número Tributário',
          LB: 'Número Tributário',
          EG: 'Número Tributário',
          MA: 'RC',
          TN: 'Número Tributário',
          DZ: 'NIS',
          ZA: 'Número',
          NG: 'Número RC',
          KE: 'PIN',
          GH: 'TIN',
          UG: 'TIN',
          TZ: 'TIN',
          RW: 'TIN',
          BW: 'Número Tributário',
          NA: 'Número Tributário',
          ZM: 'TPIN',
          ZW: 'Número Tributário',
          ET: 'TIN',
          CN: 'USCI',
          IN: 'CIN',
          PK: 'NTN',
          BD: 'TIN',
          JP: 'Número',
          KR: 'Número de Registro',
          SG: 'UEN',
          MY: 'Número SSM',
          ID: 'NPWP',
          PH: 'TIN',
          TH: 'ID Tributário',
          VN: 'Código Tributário',
          HK: 'Número BR',
          TW: 'UBN',
          LK: 'Número BRC',
          NP: 'PAN',
          AU: 'ABN',
          NZ: 'NZBN',
          RU: 'INN',
          UA: 'EDRPOU',
          BY: 'UNP',
          KZ: 'BIN',
          UZ: 'Número Tributário',
          GE: 'Número Tributário',
          AM: 'Número Tributário',
          AZ: 'Número Tributário',
        },
        companyLabel: 'empresa',
        address: 'Endereço',
        companyEmailError: 'Você deve usar um e-mail diferente',
        userIdNumberError: 'inválido',
        userIdNumberSuccess: 'foi verificado',
        companyIdNumberError: 'inválido',
        companyIdNumberSuccess: 'foi verificado',
      },
      cancel: 'Cancelar',
      save: 'Guardar',
      success: 'Novo usuário criado corretamente!',
      error: 'Ocorreu um erro ao criar o novo usuário móvel',
    },
    editUser: {
      information: {
        oldPassword: 'Senha atual',
        newPassword: 'Nova senha',
        passwordChange: 'Alterar a senha',
        error: 'Ocurreu um erro ao atualizar o usuário',
        success: 'Usuário atualizado corretamente!',
      },
    },
    createGroup: {
      button: 'Criar grupo',
      title: 'Criar grupo de usuários',
      chooseHeader: 'Como quer criar o grupo?',
      name: 'Nome grupo',
      nameHelper: 'Nome do grupo',
      userSelection: 'Seleção de usuários',
      formSelection: 'Seleção de formulários',
      importExcelNote: '*Você terá que atribuir acessos aos formulários',
      warning:
        'Usuários atribuídos a um grupo terão acesso aos formulários desse grupo e não poderão ter formulários atribuídos individualmente ao mesmo tempo.',
      empty_state: {
        title: 'Segmenta formularios e tarefas por grupos de usuarios',
        subtitle: 'O que é um grupo de usuarios?',
        descriptionPart1:
          'Os grupos de usuarios permitem controlar o que cada pessoa pode ver. Quando você atribui formulários a um grupo, apenas seus membros terão acesso a esses formulários e seus dados.',
        descriptionPart2:
          'Isso garante que cada usuário veja apenas o que deveria de acordo com seu cargo ou área, melhorando o controle e a segurança da informação.',
        block1: {
          title: 'Por que usar grupos de usuários?',
          card1: {
            title: 'Controle e segurança da informação',
            description:
              'Agrupe usuários com permissões e acessos especiais. Proteja dados sensíveis e garanta a confidencialidade.',
          },
          card2: {
            title: 'Gestão de equipes simplificada',
            description:
              'Atribua permissões por grupo para gerenciar equipes com facilidade. Economize tempo e evite erros manuais.',
          },
          card3: {
            title: 'Otimize a experiência da equipe',
            description:
              'Mostre apenas as informações relevantes para cada usuário. Agilize processos e melhore o trabalho em campo.',
          },
        },
        block2: {
          title: 'Crie seu primeiro grupo de usuários',
          demo1: {
            title: 'Através do DataScope',
            description:
              'Crie um grupo de usuários diretamente no DataScope selecionando manualmente os usuários e os formulários associados.',
          },
          demo2: {
            title: 'Importando sua lista de usuários',
            description:
              'Baixe o modelo Excel no DataScope, preencha com os dados dos seus usuários e envie novamente para a plataforma. Importante! Não modifique os cabeçalhos e respeite o formato para garantir um envio bem-sucedido.',
          },
          next: 'Próximo',
          previous: 'Anterior',
        },
        block3: {
          title: 'Agrupe, atribua e simplifique',
          description:
            'Agora que você sabe como os grupos funcionam, crie um, comece a usá-los nas suas tarefas diárias e comece a otimizar suas operações.',
        },
      },
    },
    setProfile: {
      completeProfile: 'Complete seu perfil',
      completeProfileDescription:
        'Por favor, complete as seguintes informações para acessar o DataScope',
      newPassword: 'Nova senha',
      name: 'Nome',
      lastName: 'Sobrenome',
      phone: 'Telefone',
      save: 'Finalizar',
      updateSuccess: 'Perfil atualizado com sucesso',
      updateError: 'Ocorreu um erro ao atualizar o perfil',
      identifier: 'Identificador',
    },
    exportUsers: {
      export: 'Exportar',
      success: 'Usuários exportados com sucesso!',
      error: 'Falha ao exportar os usuários',
    },
    importUsers: {
      blockedUsersTitle: '%{blocked} e-mail(s) não podem ser importados',
      blockedUsersBody:
        'Esses e-mails já estão em uso no DataScope e não podem ser criados nesta conta. O resto do arquivo é importado normalmente.',
      blockedUsersListTitle: 'E-mails que não podem ser importados',
      previewUnavailable:
        'Não conseguimos verificar se algum desses usuários já tem conta no DataScope. A importação continua da mesma forma.',
      previewTooLarge:
        'Este arquivo é grande demais para pré-visualizar, então não conseguimos verificar quem já tem conta na DataScope. A importação vai funcionar mesmo assim.',
      existingUsersTitle: '%{linked} de %{total} usuários já têm conta no DataScope',
      existingUsersBody:
        'Esses usuários mantêm as credenciais atuais. A senha do arquivo será aplicada somente aos outros %{new} usuário(s).',
      existingUsersListTitle: 'Usuários que já têm conta no DataScope',
      invalidFileType: 'Tipo de arquivo inválido. Por favor, faça upload de um arquivo .xlsx',
      dragDropHere: 'Arraste e solte seu arquivo aqui',
      orBrowse: 'ou navegue',
      downloadSuccess: 'Modelo baixado com sucesso!',
      downloadError: 'Falha ao baixar o modelo',
      uploadSuccess: 'Arquivo enviado com sucesso!',
      uploadError: 'Falha ao enviar o arquivo',
      importTitle: 'Importar Usuários',
      upload: 'Importar',
      downloadStep: 'Etapa 1: Baixe o arquivo modelo',
      downloadStepHelper: 'Baixe o arquivo modelo para preencher as informações do usuário',
      editStep: 'Etapa 2: Edite o arquivo',
      editStepHelper: 'Edite o arquivo Excel e preencha os campos obrigatórios *.',
      uploadStep: 'Etapa 3: Faça upload do arquivo',
      uploadStepHelper: 'Faça upload do arquivo editado para importar usuários.',
      downloadTemplate: 'Baixar Exemplo',
      afterUploadInfo:
        'Após o upload, os usuários serão processados e você será notificado se houver erros.',
      replace: 'Substituir',
      fileLoadedMessage: 'Seu arquivo foi carregado',
    },
  },
  login: {
    greeting: 'Oi de novo!',
    loginHelper: 'Para continuar, insira suas credenciais',
    googleLogin: 'Faça login no Google',
    email: 'E-mail',
    password: 'Senha',
    forgotPassword: 'Você esqueceu sua senha?',
    login: 'Iniciar sessão',
    noAccount: 'Ainda não tem uma conta?',
    signUp: 'Inscreva-se aqui',
    success: 'Login realizado com sucesso',
    error: 'Erro ao fazer login',
    wrongCredentials: 'Email ou senha incorretos. Verifique suas credenciais e tente novamente.',
    logoutError: 'Erro ao fazer logout',
    recaptchaError: 'Verificação de captcha falhou. Por favor, tente novamente.',
    mfaTitle: 'Autenticação de dois fatores',
    mfaSubtitle: 'Insira o código de 6 dígitos do seu aplicativo de autenticação',
    mfaCodeLabel: 'Código de verificação',
    verify: 'Verificar',
    backToLogin: '← Voltar para o login',
    invalidMfaCode: 'Por favor, insira um código válido de 6 dígitos',
    invalidMfaCodeError: 'Código de verificação inválido. Por favor, tente novamente.',
    mfaStatusError: 'Erro ao consultar o status do 2FA',
    mfaEnableError: 'Erro ao habilitar MFA',
    mfaEnabledSuccess: 'MFA habilitado com sucesso',
    mfaVerifyError: 'Erro ao verificar MFA',
    mfaDisableError: 'Erro ao desabilitar MFA',
    mfaDisabledSuccess: 'MFA desabilitado com sucesso',
    mfaSetupTitle: 'Configure seu app autenticador',
    mfaScanQr: 'Escaneie o código QR com seu app autenticador.',
    mfaSecretCode: 'Código secreto',
    mfaCancel: 'Cancelar',
    mfaClose: 'Fechar',
    mfaSetup: 'Configurar MFA',
    mfaDisable: 'Desabilitar MFA',
    ssoLogin: 'Login SSO',
    ssoSubtitle: 'Para continuar, insira seu e-mail corporativo',
    ssoCompanyEmail: 'E-mail Corporativo',
    ssoCompanyEmailPlaceholder: 'Digite seu endereço de e-mail corporativo',
    ssoValidating: 'Validando seu e-mail...',
    ssoContinue: 'Continuar com SSO',
    ssoHelpText: 'Vamos te redirecionar para a página de login da sua empresa',
    ssoBackToLogin: 'Login com senha',
    ssoSignInWithSSO: 'Entrar com SSO',
    ssoCompletingAuth: 'Completando autenticação...',
    ssoVerifyingCredentials: 'Verificando suas credenciais',
    ssoAuthSuccessful: 'Autenticação bem-sucedida!',
    ssoAuthFailed: 'Falha na autenticação',
    ssoRedirecting: 'Redirecionando...',
    ssoError: 'A autenticação SSO falhou. Por favor, tente novamente.',
    ssoTooManyAttempts: 'Muitas tentativas de login. Por favor, tente novamente mais tarde.',
    ssoInvalidIdentifier:
      'Endereço de e-mail inválido. Por favor, verifique seu e-mail corporativo e tente novamente.',
    ssoNoAccountsFound: 'Nenhuma conta habilitada para SSO encontrada para este domínio de e-mail.',
    ssoFailedValidation:
      'Falha na validação do e-mail. Por favor, verifique seu e-mail corporativo e tente novamente.',
    ssoFailedStatus: 'Falha ao verificar o status SSO. Por favor, tente novamente.',
    secureLoginMessage:
      'Você está iniciando sessão com sua conta corporativa através de um login seguro.',
    ssoFailedInitiate: 'Falha ao iniciar o login SSO. Por favor, tente novamente.',
    checkingAuthentication: 'Verificando autenticação...',
    ssoConnecting: 'Conectando com sua conta corporativa...',
    ssoRedirectingToSSO:
      'Estamos te redirecionando para a página de login da sua empresa para completar o acesso.',
    ssoNoSSO: 'Esta conta não utiliza login único (SSO).',
    ssoContinueWith: 'Continuar com',
    ssoAuthenticationFailed: 'Autenticação falhou. Por favor, tente novamente.',
    ssoAuthenticationError: 'Ocorreu um erro ao autenticar. Por favor, tente novamente.',
    ssoAuthenticationProcessing: 'Processando autenticação...',
    ssoAuthenticationFailedRedirect: 'Autenticação falhou. Redirecionando para o login...',
    ssoAuthenticationCompleting: 'Completando autenticação...',
    ssoFailedProviderLogin: 'Erro ao iniciar o login com o provedor selecionado.',
    ssoSelectProvider: 'Selecione uma opção para continuar',
  },
  forgotPassword: {
    title: 'Redefina sua senha',
    description: 'Insira seu e-mail e receberemos um link para redefinir sua senha.',
    email: 'E-mail',
    continue: 'Continuar',
    backToLogin: 'Voltar para o login',
    success:
      'Se o e-mail inserido for válido, enviaremos uma mensagem com os passos. Se não vir, verifique sua pasta de spam.',
    error: 'Ocorreu um erro ao enviar o e-mail, por favor, tente novamente.',
    recaptchaError: 'Verificação de captcha falhou. Por favor, tente novamente.',
  },
  resetPassword: {
    title: 'Redefina sua senha',
    description: 'Escreva e confirme sua nova senha.',
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
    continue: 'Reestabelecer senha',
    passwordsMatchError: 'As senhas não coincidem',
    success: 'Senha atualizada com sucesso',
    error: 'Ocorreu um erro ao atualizar a senha, por favor, tente novamente.',
  },
  changePassword: {
    title: 'Altere sua senha',
    description: 'Você entrou com uma senha temporária. Defina uma nova senha para continuar.',
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
    continue: 'Alterar senha',
    passwordsMatchError: 'As senhas não coincidem',
    minLengthError: 'A senha deve ter no mínimo 6 caracteres',
    success: 'Senha atualizada. Você já pode continuar.',
    error: 'Ocorreu um erro ao alterar a senha, tente novamente.',
  },
  signUp: {
    emailExistsTitle: 'Este e-mail já existe',
    emailExistsBody:
      'Entre com %{email} para adicionar esta conta à sua identidade e alternar entre suas contas sem fazer login novamente.',
    useAnotherEmail: 'Usar outro e-mail',
    title: 'Crie sua conta',
    subtitle: 'Sem cartão de crédito, cancele em qualquer momento',
    templatePreviewTitle: 'Você está a apenas um passo de usar:',
    name: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    password: 'Senha',
    companyName: 'Empresa',
    role: 'Cargo',
    phoneNumber: 'País e telefone',
    alreadyHaveAccount: 'Já tem uma conta?',
    signUp: 'Criar conta',
    error: 'Ocorreu um erro ao criar a conta, por favor, tente novamente.',
    privacyPolicyText: 'Clicando você concorda com nossa',
    privacyPolicyLink: 'Política de privacidade',
    emailError: 'Email inválido',
    phoneNumberError: 'Número de telefone inválido',
    passwordError: 'A senha deve ter pelo menos 6 caracteres',
  },
  templates: {
    total_templates: 'Total templates',
    see_all: 'Ver todos',
    showing_results: 'Mostrando resultados de',
    categories: 'Categorias',
    in: 'em',
    useTemplate: 'Usar modelo',
    loginToAnswerTemplate: 'Você poderá responder este modelo depois de entrar em sua conta',
    backToDataScope: 'Voltar para DataScope',
    noResults:
      'Não pudemos encontrar o que você está buscando, mas ficaremos felizes em encontrar uma solução!',
    contactSupport: 'Conte-nos qual formulário você precisa através do Chat',
    next: 'Seguinte',
    back: 'Atrás',
    useCase: 'Pode ser usado para:',
    createdBy: 'Criado por',
    anonymousUser: 'Usuario anônimo',
    preview: 'Vista prévia',
    editableTemplate: 'Este template é editável quando for importado',
    allTemplates: 'Templates',
    noDescription: 'Sem descrição',
    bannerSlogan: 'Transforme suas operações com formulários móveis',
    templateView: 'Vista de template',
    seeLess: 'Ver menos',
    seeMore: 'Ver mais',
    importError: {
      formLimitReached:
        'Limite de formulários atingido. Por favor, atualize seu plano para importar mais formulários.',
      alreadyImported: 'Este formulário já foi importado.',
      validationError: 'Erro de validação ao importar o template.',
      loginRequired: 'Você deve fazer login para importar templates.',
      genericError: 'Ocorreu um erro ao importar o template. Por favor, tente novamente.',
      invalidUrl: 'URL de template inválida. Por favor, verifique o link e tente novamente.',
    },
  },
  navbar: {
    features: 'Funcionalidades',
    solutions: 'Soluções',
    work_orders: 'Ordens de Trabalho',
    safety: 'Segurança',
    inspections: 'Inspeções',
    quality: 'Qualidade',
    resources: 'Recursos',
    blog: 'Blog',
    ds_academy: 'Academia DataScope',
    digitize: 'Carregar seu Formulário',
    roi: 'Calculadora ROI',
    pricing: 'Preços',
    sales: 'Fala com vendas',
    wapp: '',
    call: '',
    demo: '',
    sign_in: 'Acessar',
    sign_up: 'Inscreva-se Grátis',
    log_out: 'Sair',
    paths: {
      work_orders: 'ordens-trabalho',
      safety: 'seguranca',
      inspections: 'inspecoes',
      quality: 'qualidade',
      blog: 'blog',
      ds_academy: 'digitalize-suas-operacoes-usando-datascope',
      digitize: 'carregar-formulario',
      roi: 'roi',
    },
  },
  uiComponents: {
    search: 'Procurar',
    showingResultsFor: 'Mostrando resultados de pesquisa para',
    found: 'encontrados',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    selected: 'selecionado',
    close: 'Fechar',
    chooseMethodDialog: {
      fromDatascope: 'A partir de DataScope',
      importExcel: 'Importar Excel',
    },
    signature: {
      title: 'Assinatura eletrônica',
      alert:
        'Complete as informações a seguir para ativar a assinatura eletrônica. O nome e sobrenome na área de informação são necessários para criar sua assinatura.',
      accountAlert: 'Lembre-se de clicar em "Salvar assinatura".',
      saveSignature: 'Salvar assinatura',
      completeSignatureWarning:
        'Você deve preencher todos os campos obrigatórios para salvar sua assinatura',
      signatureRequiredFieldError: 'Este campo é obrigatório para criar a assinatura eletrônica',
      updateSuccess: 'Assinatura atualizada com sucesso.',
      updateError: 'Ocorreu um erro ao atualizar a assinatura.',
      invalidEmailError: 'Email inválido.',
      emailExistsError: 'O email já está em uso.',
      validatingRut: 'Validando RUT...',
      emailErrors: {
        REGEX_INVALID: 'Email inválido',
        IN_USE: 'O email já está em uso',
      },
    },
  },
  formEmailBuilder: {
    message: 'Mensagem',
    subject: 'Assunto',
    senderName: 'Nome do Remetente do Email',
    addFooter: 'Adicionar Assinatura',
    footerTitle: 'Assinatura',
    notification: 'Notificação',
    autoNotify: 'Notificar emails fixos',
    save: 'Salvar',
    cancel: 'Cancelar',
    linkName: 'Link de Download do Formulário em PDF',
    linkNamePlaceholder: 'Digite o nome que deseja que o link tenha',
    linkNameHelp:
      'O nome que você configurar será o nome no link de download que chegará ao e-mail.',
    saveSuccess: 'Configurações salvas com sucesso',
    saveError: 'Ocorreu um erro ao salvar as configurações',
    autoGeneratePdf: 'Gerar PDF automaticamente',
  },
  accountConfig: {
    information: {
      title: 'Configurações da conta',
      name: 'Nome da empresa',
      description: 'Descrição da empresa',
      email: 'Email da empresa',
      phone: 'Telefone da empresa',
      address: 'Endereço da empresa',
      timezone: 'Fuso horário',
      locale: 'Idioma',
      dateFormat: 'Formato de data',
      dateFormatDescription: 'Selecione o formato de data que será usado em toda a aplicação',
      dateFormatDdMm: 'dd/mm/YYYY',
      dateFormatDdMmExample: 'Exemplo: 25/12/2024',
      dateFormatMmDd: 'mm/dd/YYYY',
      dateFormatMmDdExample: 'Exemplo: 12/25/2024',
      dateFormatPreview: 'Visualização',
      logo: 'Logotipo',
      uploadLogo: 'Imagem',
      logoDescription:
        'A imagem deve estar no formato .PNG ou .JPG e o tamanho deve ser 400x400 px com um peso não superior a 2 MB.',
      logoSizeError: 'O tamanho da imagem deve ser inferior a 2 MB',
      saveSuccess: 'Configuração atualizada com sucesso',
      saveError: 'Ocorreu um erro ao atualizar a configuração',
      pdfAlert: 'As informações configuradas aqui aparecerão no cabeçalho do PDF padrão.',
      confirmDeleteLogo: 'Tem certeza de que deseja excluir o logotipo?',
      languages: {
        es: 'Español',
        en: 'English',
        pt: 'Português',
      },
      exampleLabel: 'Exemplo:',
      dateLabel: 'Data:',
      timeLabel: 'Hora:',
      dateTimeLabel: 'Data e hora:',
      dateFormatProfiles: {
        european: 'Europeu',
        english: 'Inglês',
      },
    },
    advancedConfig: {
      title: 'Configuração avançada',
      activateSupportUser: 'Conceder acesso ao usuário de suporte DataScope',
      securityConfig: 'Configuração de segurança',
      deactivateAccount: 'Desativar conta',
      confirmTitle: 'Você tem certeza de que deseja desativar sua conta?',
      confirmMessage:
        'Esta ação é irreversível. Também desativará todos os usuários e dados associados a esta conta.',
    },
    mfaConfig: {
      title: 'Segurança da conta (2FA)',
      subtitle:
        'Proteja sua conta com um nível adicional de segurança.\nQuando ativado, um código temporário será solicitado do seu aplicativo autenticador ao fazer login.',
      activateMfa: 'Ativar autenticação de dois fatores',
      configMode: 'Como você deseja configurá-lo para os usuários da sua conta?',
      optional: 'Opcional',
      mandatory: 'Obrigatório',
      optionalDescription: 'Cada usuário pode ativá-lo a partir de suas configurações de usuário',
      mandatoryDescription: 'Todos os membros devem configurá-lo para acessar a plataforma',
    },
  },
  formSignatureBuilder: {
    signatureTitle: 'Ativação de Assinatura',
    checkboxSignatureActivate: 'Ativar assinatura eletrônica',
    settingsTitle: 'Configurações gerais',
    save: 'Salvar',
    cancel: 'Cancelar',
    saveSuccess: 'Configurações salvas com sucesso',
    saveError: 'Ocorreu um erro ao salvar as configurações',
    saveErrorReload:
      'Ocorreu um erro ao salvar as configurações. Por favor, recarregue a página e tente novamente',
    accountSignatureConfigError: 'Falta configurar a assinatura eletrônica da conta',
    generalSettings: 'Configuração geral',
    mandatorySignature:
      'Assinatura obrigatória (Todos os usuários configurados devem responder à solicitação, seja assinando ou rejeitando)',
    optionalSignature: 'Assinatura opcional (Um dos signatários configurados deve assinar)',
    signersSettings: 'Configuração de signatários',
    authorMustSign: 'O usuário que enviar uma resposta também deve assinar',
    fixedSignerTitle: 'Assinante Fixo',
    changeSelection: 'Alterar seleção',
    dynamicSignerTooltip:
      'Assinantes dinâmicos estão disponíveis no plano Enterprise. Atualize seu plano e acesse esta e mais funcionalidades avançadas.',
    upgradePlan: 'Atualize seu plano',
    quorumBlockedTitle: 'Quórum de assinaturas',
    quorumBlockedEnterpriseChip: 'Enterprise',
    quorumBlockedDescription:
      'Permite que um documento avance ao atingir um número mínimo de assinaturas, sem exigir a assinatura de todos os signatários. Disponível no plano Enterprise.',
    quorumBlockedCta: 'Conhecer os planos',
    pricingEmptyStateTag: 'Disponível no Professional e Enterprise',
    pricingEmptyStateTitle: 'Gerencie assinaturas e aprovações em um só lugar',
    pricingEmptyStateIntro:
      'Garanta a rastreabilidade de cada aprovação e reduza erros nos seus processos de assinatura.',
    pricingEmptyStateFeature1: 'Solicite assinaturas e envie notificações automáticas.',
    pricingEmptyStateFeature2: 'Defina processos de aprovação e acompanhamento.',
    pricingEmptyStateFeature3: 'Mantenha a rastreabilidade de cada documento assinado.',
    pricingEmptyStateDtBanner: 'Assinatura eletrônica validada pela Dirección del Trabajo',
    pricingEmptyStateKnowPlans: 'Conhecer os planos',
    pricingEmptyStateContactSales: 'Falar com vendas',
    pricingEmptyStateContactSalesMessage:
      'Olá, tenho interesse na assinatura eletrônica. Podem me contar sobre os planos?',
    pricingEmptyStateDemoTitle: 'Conheça o processo de assinatura do início ao fim',
    pricingEmptyStateEnterpriseChip: 'Enterprise',
    pricingEmptyStatePrev: 'Anterior',
    pricingEmptyStateNext: 'Próximo',
    pricingEmptyStateSlide1Title: 'Defina quem assina e em que ordem',
    pricingEmptyStateSlide1Description:
      'Configure um ou vários signatários para cada documento. Você pode solicitar assinaturas simultâneas ou definir uma sequência de aprovação conforme o seu processo.',
    pricingEmptyStateSlide2Title: 'Acompanhe cada solicitação',
    pricingEmptyStateSlide2Description:
      'Revise o status das suas solicitações de assinatura e saiba quem deve assinar em seguida. Mantenha a visibilidade de cada documento sem sair do DataScope.',
    pricingEmptyStateSlide3Title: 'Acesse documentos e histórico de assinaturas',
    pricingEmptyStateSlide3Description:
      'Consulte documentos assinados, datas e participantes para manter um registro centralizado de cada aprovação.',
    pricingEmptyStateSlide4Title: 'Assinatura dinâmica e quóruns de aprovação',
    pricingEmptyStateSlide4Description:
      'Defina signatários automaticamente a partir das respostas do formulário ou permita que um documento avance quando o número mínimo de assinaturas exigido for alcançado.',
    assignOwner: 'Atribuir responsável',
    searchPlaceholder: 'Buscar usuário ou grupo',
    usersTab: 'Usuários',
    groupsTab: 'Grupos',
    addButton: 'Adicionar',
    cancelButton: 'Cancelar',
    externalUsers: 'Usuários externos',
    externalUsersDescription: 'Usuários externos poderão visualizar e assinar o formulário',
    selectResponsible: 'Selecione o responsável pela solicitação',
    addResponsible: 'Adicionar responsável',
    selectUsersToSign: 'Selecione os usuários que devem assinar o documento',
    selectResponsibleTooltip:
      'O usuário selecionado poderá acompanhar o status de todas as solicitações e editá-las, mas não poderá assinar. Para assinar, deve ser adicionado à lista de assinantes',
    simultaneousSign: 'Assinatura Simultânea',
    sequentialSign: 'Sequência de assinaturas',
    simultaneousSignInfo: 'A solicitação será enviada simultaneamente para todos os usuários',
    sequentialSignInfo: 'A solicitação será enviada na ordem que você estabelecer',
    simultaneousEmptyState: 'Arraste os usuários aqui para removê-los da sequência',
    sequentialEmptyState: 'Arraste os usuários aqui para criar uma sequência de assinaturas',
    sequentialWarningInfo:
      'Você deve adicionar todos os usuários para gerar uma solicitação - {value} usuários',
    sequentialSignSuccess: 'Sequência completa',
    automatedSignature: 'Ativar solicitação de assinatura automática',
    locationUser: 'E-mails de locais',
    locationUserTooltip:
      'Ao selecionar "Conexão com locais", a solicitação será enviada a todos os correios registrados no primeiro local associado.',
    locationUserViewEmails: 'Ver e-mails',
    locationConnection: 'Conexão com locais',
    locationConnectionTooltip1:
      'Se o formulário incluir uma pergunta para selecionar um local, uma solicitação será enviada para os e-mails configurados lá',
    locationConnectionTooltip2:
      'Se você atribuir uma tarefa com este formulário e escolher um local, os e-mails configurados lá receberão uma solicitação quando a tarefa for concluída',
    optionalSignatureOrderDisabled:
      'Esta opção não está disponível para a configuração de assinatura opcional',
    author: 'Autor da resposta',
    authorMustSignFirst:
      'Esta posição é fixa dentro da sequência, mas você pode movê-la para Assinatura Simultânea',
    deleteSigner: 'Excluir usuário',
    unGroupSigner: 'Desagrupar',
    authorUserTooltip:
      'Se o autor da resposta já faz parte da sequência, sua posição original será mantida em vez da atribuída para o autor',
    addSigners: 'Adicionar Assinantes',
    addSignersTitle: 'Adicionar Assinantes',
    selectConfigurationType:
      'Selecione o tipo de configuração que você precisa. Você pode escolher um ou ambos.',
    fixedSigner: 'Assinante Fixo',
    fixedSignerDescription: 'Usuários internos ou externos',
    dynamicSignerCardDescription: 'Baseado nas respostas do formulário',
    dynamicSigner: 'Assinante Dinâmico',
    dynamicSignerDescription:
      'Os assinantes dinâmicos são definidos a partir de respostas em perguntas tipo',
    dynamicSignerDescriptionBold:
      'Seleção lista de dados com listas de locais ou personalizadas, ou tipo Texto com validação de email.',
    formQuestionsTitle: 'Perguntas deste formulário',
    noDynamicSignatureQuestionsAvailable: 'Você não tem perguntas deste tipo\nno momento',
    selectedSignerSingular: 'selecionado',
    selectedSignersPlural: 'selecionados',
    quorumLabel: 'Pelo menos',
    quorumSuffix: 'devem assinar',
    quorumAll: 'Todos',
    quorumTooltip:
      'A solicitação será enviada seguindo a ordem definida. Cada etapa avançará quando o número necessário de pessoas assinar.',
    quorumTooltipSimultaneous:
      'Todos os usuários receberão a solicitação ao mesmo tempo. O processo terminará quando o número necessário de pessoas assinar.',
    quorumError: 'O quórum deve estar entre 1 e a quantidade de participantes',
    rejectReasonsTitle: 'Configuração de motivos de rejeição',
    rejectReasonsInfoBanner: 'Serão exibidos quando um signatário rejeitar uma solicitação',
    rejectReasonsSaveError: 'Não foi possível salvar estes motivos (verifique duplicados ou tamanho): {reasons}',
    rejectReasonsEmptyError: 'O motivo não pode ficar vazio',
    rejectReasonsAddPlaceholder: 'Escreva o motivo de rejeição',
    rejectReasonsAddButton: '+ Adicionar motivo de rejeição',
    rejectReasonsEmptyText: 'Você ainda não adicionou motivos de rejeição. Se não adicionar nenhum, quem assina escreverá o motivo em texto livre.',
    rejectReasonsDuplicateError: 'Já existe um motivo com esse texto neste formulário',
    rejectReasonsDeleteTitle: 'Tem certeza de que deseja eliminar este motivo de rejeição?',
    rejectReasonsDeleteDescription: 'As solicitações enviadas anteriormente não serão afetadas e permanecerão na plataforma',
    rejectReasonsDeleteConfirm: 'Eliminar',
    rejectReasonsDeleteCancel: 'Cancelar',
  },
  pricing: {
    title: 'Descubra o plano perfeito para o seu negócio!',
    basic: {
      title: 'Básico',
      subtitle: 'Perfeito para explorar as funcionalidades do DataScope',
      features: [
        'Usuários ilimitados',
        '60 respostas de formulário/mês',
        'Dados armazenados por 30 dias',
        'Construtor de formulários básico',
        'Atribuidor de tarefas',
        'Painel padrão',
        'Resolução padrão de fotos',
        'Funcionalidade offline',
      ],
      buttonText: 'Plano atual',
    },
    standard: {
      title: 'Padrão',
      subtitle:
        'Ideal para equipes que estão dando os primeiros passos na digitalização de processos',
      features: [
        'Tudo incluído no Plano Básico +',
        'Respostas ilimitadas de formulários',
        'Dados armazenados para sempre',
        'Construtor de formulários avançado',
        'Gerador de relatórios PDF personalizado',
        'Permissões de usuário editáveis',
        'Integração de dados com outras plataformas',
        'Chat entre usuários no aplicativo',
        'Suporte por e-mail/telefone/chat',
      ],
    },
    premium: {
      title: 'Premium',
      subtitle:
        'Para empresas que precisam de uma visão abrangente e em tempo real de todas as suas operações',
      features: [
        'Tudo incluído no Plano Padrão +',
        'Dashboards avançados',
        'Suporte API',
        'Resolução configurável de fotos',
        'Executivo de conta atribuído',
        'Suporte em fluxos de trabalho',
      ],
      buttonText: 'Mudar para Premium',
    },
    enterprise: {
      title: 'Empresarial',
      subtitle: 'Para grandes empresas que buscam uma solução e suporte personalizados',
      features: [
        'Tudo incluído no Plano Premium +',
        'Implementação personalizada',
        'Suporte preferencial 24/7',
      ],
      buttonText: 'Falar com vendas',
    },
    features: 'Recursos',
    start: 'Começar',
    currentPlan: 'Plano atual',
    free: 'Grátis',
    mostPopular: 'Mais popular',
    monthlyPerUser: 'mensal por usuário',
    users: 'usuários',
    standardBold: 'Padrão',
    off: 'Desconto',
    finishesIn: 'Termina em',
    ofDiscount: 'de desconto.',
    days: 'Dias',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    salesLink: 'https://meetings.hubspot.com/andres-rivera4',
    activePayment: {
      demoSubscription: 'Assinatura paga',
      demoSubscriptionDescription: 'Seu plano atual inclui 30 usuários.',
      demoSubscriptionDescription1: ' usuário(s).',
      demoSubscriptionDescription2: 'Você pode convidar mais clicando no botão.',
      inviteUsers: 'Convidar usuários',
      demoBannerDescription: 'Você não possui pagamentos pendentes!',
      demoBannerDescription2:
        'Se você tiver alguma dúvida sobre sua assinatura, não hesite em entrar em contato com nossa equipe.',
      moreInfo: 'Mais informações',
      viewBillingDetails: 'Ver detalhes de faturamento',
      changeUsers: 'Alterar o número de usuários',
      modify: 'Modificar',
      monthlyValue: 'Valor mensal',
      annualValue: 'Valor anual',
      total: 'Total',
      valuesMayDiffer: '*Os valores podem variar conforme a sua moeda local.',
      modifyUsersSuccess: 'A assinatura foi atualizada com sucesso!',
      modifyUsersError:
        'Encontramos problemas ao atualizar sua assinatura. Por favor, tente novamente ou entre em contato com nossa equipe de vendas.',
      confirmModifyUsers: 'Tem certeza de que deseja alterar o número de usuários?',
      confirmModifyUsersDescription:
        'Se você alterar o número de usuários, o valor da sua assinatura será alterado de acordo e a diferença será cobrada, se aplicável.',
      numberOfUsers: 'Número de usuários',
      paymentDetails: 'Detalhes de pagamento',
    },
  },
  notifications: {
    title: 'Notificações',
    searchPlaceholder: 'Procurar por nome de formulário...',
    viewFormAnswer: 'Ver Resposta',
    viewExcel: 'Ver Excel',
    viewPdf: 'Ver PDF',
    downloadZip: 'Baixar ZIP',
    tableHeaders: {
      date: 'Data',
      type: 'Tipo',
      form: 'Formulário',
      formCode: 'Código',
      user: 'Usuário',
      location: 'Local',
      actions: 'Ações',
    },
    formExport: 'Exportação do formulário',
    formAnswer: 'Resposta do formulário',
    bulkPdfZip: 'Download em massa de PDF',
    filters: {
      title: 'Filtros',
      filterByType: 'Por tipo',
      filterByLocation: 'Por local',
      filterByUser: 'Por usuário',
      filterByDateRange: 'Por intervalo de datas',
      startDate: 'Início',
      endDate: 'Fim',
      invalidDate: 'Data inválida',
      invalidDateRange: 'Intervalo de datas inválido',
      to: 'até',
      eraseAll: 'Apagar tudo',
      apply: 'Aplicar',
      formAnswers: 'Respostas',
      formExports: 'Exportações',
      clear: 'Limpar',
      locationPlaceholder: 'Selecione um local',
      userPlaceholder: 'Selecione um usuário',
      showingResultsFor: 'Mostrando resultados de pesquisa para',
    },
    noNotifications: 'Você não tem notificações neste momento',
    noResults: 'Nenhuma notificação relacionada aos filtros aplicados foi encontrada',
    limitReached:
      'Sua conta atingiu o limite. Você deve ativar sua conta para habilitar esse recurso.',
    zipDownloadError: 'Não foi possível baixar o ZIP. Tente novamente.',
  },
  sensors: {
    tabs: { map: 'Mapa', list: 'Sensores', inbox: 'Entradas', connection: 'Conexão' },
    enterpriseOnlyMessage: 'O módulo de sensores não está habilitado nesta conta. Fale conosco se quiser mais informações.',
    map: {
      showing: 'São exibidos os {shown} sensores com dados mais recentes, de {total}',
      previousPage: 'Anterior',
      nextPage: 'Próxima',
      pageLabel: 'Página {page} de {pages}',
      empty: 'Nenhum sensor enviou dados de um lugar com coordenadas ainda.',
    },
    inbox: {
      viewFullBody: 'Ver a mensagem completa',
      fullBodyTitle: 'Mensagem recebida',
      fullBodyClose: 'Fechar',
      unmappedTitle: 'Entradas não mapeadas',
      unmappedHint: 'Chegaram à sua conta e ainda não alimentam nenhum sensor',
      unmappedEmpty: 'Não há entradas esperando ser mapeadas.',
      mappedTitle: 'Entradas já atribuídas',
      mappedEmpty: 'Ainda não há entradas que alimentem um sensor.',
      mappedHint: 'Cada uma alimenta o sensor que aparece na sua linha',
      mapAction: 'Mapear',
      viewAction: 'Ver',
      editMappingAction: 'Editar mapeamento',
      columnMapping: 'Mapeada por',
      mappingIdentifierShort: 'ID: {path}',
      mappingDateShort: 'Data: {path}',
      mappingDateNone: 'sem campo de data',
      columnWhen: 'Quando',
      columnOutcome: 'Resultado',
      columnMessage: 'Mensagem',
      columnSensor: 'Sensor',
      outcomeAccepted: 'Aceito',
      outcomeRejected: 'Rejeitado',
      outcomeUnknownDevice: 'Sem identificador',
      unknownDeviceHint:
        'Não foi possível reconhecer nenhum identificador de dispositivo nesta mensagem. Você pode revisá-la e mapeá-la manualmente por aqui.',
      previousPage: 'Anterior',
      nextPage: 'Próxima',
      pageLabel: 'Página {page} de {pages}',
      footnote:
        'São exibidas as últimas 100 entradas. Nada se perde: um dispositivo que envia dados sem estar mapeado mantém seu histórico completo. Mapeá-lo só define o que é copiado para o medidor de um ativo.',
    },
    assetPicker: {
      searchPlaceholder: 'Buscar por nome ou código do ativo',
      noResults: 'Nenhum ativo corresponde a essa busca.',
      noAssets: 'Esta conta ainda não tem ativos. Crie um antes de vincular um sensor.',
      noLocation: 'Sem lugar',
      previous: 'Anterior',
      next: 'Próxima',
      pageLabel: 'Página {page} de {pages}',
      title: 'Escolher ativo',
      clear: 'Deixar sem vincular',
      cancel: 'Cancelar',
    },
    newSensor: {
      action: 'Novo sensor',
      title: 'Novo sensor',
      firstBody:
        'Você precisa integrar seu primeiro sensor. Conecte-o com o endereço que a DataScope te dá e as entradas dele vão aparecer aqui.',
      firstAction: 'Ir para Conexão',
      nextBody:
        'Seus sensores já estão enviando dados. Mapeie seu novo sensor nas entradas recentes, onde esperam todas as que seguem sem mapear.',
      nextAction: 'Ir para Entradas',
      close: 'Fechar',
    },
    mapping: {
      title: 'Mapear dispositivo',
      editTitle: 'Editar este mapeamento',
      editHint:
        'Ao alterar um campo, todas as entradas anteriores da mesma forma são lidas de novo, então um campo de data ou de identificador errado também fica corrigido no que você já recebeu.',
      changeAsset: 'Alterar',
      chooseAsset: 'Escolher ativo',
      attributesTitle: 'Atributos detectados',
      attributesHint:
        'Todos os atributos da mensagem são detectados e armazenados sozinhos, incluindo os aninhados. Atribuir um a um medidor é opcional e só define o que é copiado para o ativo.',
      columnAttribute: 'Atributo',
      columnLastValue: 'Último valor',
      columnRole: 'Papel',
      columnMeter: 'Alimenta um medidor',
      roleIdentifier: 'Identificador',
      roleDate: 'Data da leitura',
      roleLatitude: 'Latitude',
      roleLongitude: 'Longitude',
      roleData: 'Dado',
      meterNone: 'Não atribuído',
      meterRequiresAsset: 'Escolha um ativo para atribuir medidores',
      meterNoneAvailable: 'Este ativo não tem medidores para alimentar. Adicione um ao ativo primeiro.',
      locationNoneAvailable: 'Ainda não há lugares configurados.',
      howReadTitle: 'Como a mensagem é lida',
      identifierFieldLabel: 'Campo do identificador do dispositivo',
      dateFieldLabel: 'Campo da data (opcional)',
      dateFieldNone: 'Não usar nenhum (usa a data de recebimento)',
      dateFormatLabel: 'Formato da data',
      dateFormatIso8601: 'ISO 8601 (2026-07-29T14:32:10Z)',
      dateFormatEpochSeconds: 'Epoch em segundos',
      dateFormatEpochMillis: 'Epoch em milissegundos',
      latFieldLabel: 'Campo de latitude (opcional)',
      lngFieldLabel: 'Campo de longitude (opcional)',
      geoFieldNone: 'Não usar nenhum',
      hint: 'É a única coisa que precisa configurar. Todos os outros atributos são detectados e armazenados sozinhos.',
      sensorNameLabel: 'Nome do sensor',
      assetLabel: 'Ativo',
      assetNone: 'Não atribuído',
      locationLabel: 'Localização',
      locationNone: 'Não atribuído',
      submit: 'Salvar mapeamento',
      cancel: 'Cancelar',
      success: 'Dispositivo mapeado. As mensagens anteriores da mesma forma estão sendo atualizadas.',
      error: 'Não foi possível salvar o mapeamento, tente novamente.',
    },
    landing: {
      eyebrow: 'Módulo não habilitado nesta conta',
      title: 'Conecte seus sensores de campo e pare de anotar leituras manualmente',
      lead: 'Os sensores que você já tem instalados enviam suas leituras para o DataScope e alimentam sozinhos os medidores dos seus ativos.',
      bullets: [
        'Cadastre seus sensores e conecte-os com o endereço que o DataScope fornece',
        'Vincule cada sensor a um ativo e deixe seu medidor em modo automático',
        'Veja onde está cada ativo e quais sensores deixaram de reportar',
      ],
      contactSupport: 'Falar com o suporte',
      contactSupportMessage: 'Olá, quero mais informações sobre o módulo de sensores.',
      enableHint: 'Fale conosco se quiser mais informações sobre o módulo de sensores.',
    },
    list: {
      columnId: 'ID',
      columnSensor: 'Sensor',
      columnStatus: 'Status',
      columnLastReading: 'Última leitura',
      columnAsset: 'Ativo vinculado',
      columnMeter: 'Medidor automático',
      noLocationGroup: 'Sem lugar',
      openAssetHint: 'Abrir ativo em outra aba',
      changeAssetHint: 'Vincular este sensor a um ativo',
      assetSaveSuccess: 'Sensor vinculado ao ativo.',
      assetSaveError: 'Não conseguimos alterar o ativo, tente novamente.',
      renameHint: 'Alterar o nome deste sensor',
      renameSave: 'Salvar',
      renameCancel: 'Cancelar',
      renameSuccess: 'Nome do sensor atualizado.',
      renameError: 'Não conseguimos alterar o nome, tente novamente.',
      unlinked: 'Não vinculado',
      none: '—',
      footnote:
        'Um sensor pode receber dados sem estar vinculado a um ativo. O vínculo decide o que é copiado para o medidor, não o que é armazenado.',
      showing: 'Mostrando {from} a {to} de {total} sensores',
      previousPage: 'Anterior',
      nextPage: 'Próxima',
      pageLabel: 'Página {page} de {pages}',
      empty: 'Ainda não há sensores reportando.',
      // Estado vazio autônomo de Sensores > Sensores (SensorsListTab): sem
      // tabela nem rodapé técnico, só a mensagem e a ação que resolve.
      emptyStateMessage: 'Nenhum sensor está reportando dados ainda.',
      emptyStateAction: 'Integre seu primeiro sensor',
      adminOnly: 'Somente administradores podem ver e gerenciar os sensores de um ativo.',
      linkSensor: 'Vincular sensor',
      linkSensorTitle: 'Vincular sensor a este ativo',
      linkSensorSelectLabel: 'Sensor',
      linkSensorEmpty: 'Não há sensores sem vínculo disponíveis.',
      linkSensorSubmit: 'Vincular',
      linkSensorCancel: 'Cancelar',
      linkSensorSuccess: 'Sensor vinculado a este ativo.',
      linkSensorError: 'Não foi possível vincular o sensor, tente novamente.',
      unlinkSensor: 'Desvincular',
      retireSensor: 'Dar baixa no sensor',
      retireSensorSuccess: 'Sensor dado baixa.',
      retireSensorError: 'Não conseguimos dar baixa no sensor, tente novamente.',
      retireSensorConfirmTitle: 'Dar baixa neste sensor?',
      retireSensorConfirmMessage:
        '{sensor} sai desta lista e suas próximas mensagens serão rejeitadas. Nada é excluído: suas leituras e as medições que alimentou são mantidas, e você pode reativá-lo depois.',
      retireSensorConfirmAction: 'Dar baixa',
      retireSensorCancel: 'Cancelar',
      moveAssetHint: 'Mover este sensor para outro ativo',
      moveAssetConfirmTitle: 'Mover sensor para outro ativo',
      moveAssetConfirmBody: 'Mover {sensor} de {from} para {to}?',
      moveAssetFeedsWarning:
        'Hoje ele alimenta {meters} em {from} em modo automático. Ao mover, isso é desligado, e você configura de novo no ativo novo. As medições já registradas ficam em {from}.',
      moveAssetConfirmAction: 'Mover',
      moveAssetCancel: 'Cancelar',
      unlinkSensorFeedsWarning:
        'Hoje ele alimenta {meters} em modo automático. Ao desvincular, isso também é desligado, e o medidor mantém todas as medições já registradas.',
      unlinkSensorConfirmTitle: 'Desvincular sensor',
      unlinkSensorConfirmBody:
        'Desvincular {sensor} deste ativo? Ele mantém todo o seu histórico, mas para de alimentar seus medidores.',
      unlinkSensorConfirmAction: 'Desvincular',
      unlinkSensorCancel: 'Cancelar',
      unlinkSensorSuccess: 'Sensor desvinculado deste ativo.',
      unlinkSensorError: 'Não foi possível desvincular o sensor, tente novamente.',
    },
    status: { reporting: 'Reportando', silent: 'Sem reportar', rejecting: 'Rejeitando' },
    connection: {
      title: 'Um único endereço para todos os seus sensores',
      endpointLabel: 'Endereço de destino',
      credentialLabel: 'Credencial da conta',
      info: 'Todos os seus dispositivos enviam para o mesmo endereço com a mesma credencial. Cada mensagem é reconhecida pelo identificador do dispositivo que vem dentro dela.',
      regenerate: 'Regenerar credencial',
      regenerateConfirmTitle: 'Regenerar credencial',
      regenerateConfirmBody:
        'A credencial anterior deixa de funcionar imediatamente. Todos os dispositivos que a usavam deixarão de enviar dados até que você a atualize neles também.',
      regenerateConfirmAction: 'Regenerar mesmo assim',
      cancel: 'Cancelar',
      openDocs: 'Ver documentação',
      openDocsMessage: 'Preciso da documentação de integração de sensores.',
      whatToSendTitle: 'O que enviar',
      whatToSendHint: 'Não há formato obrigatório. Envie o JSON que seu sistema já produz, tal como está:',
      whatToSendFootnote: 'O DataScope detecta e armazena todos os atributos sozinho, incluindo os aninhados.',
    },
    catalog: {
      title: 'Outros provedores',
      comingSoon: 'Em breve',
      requestButton: 'Quero integrar outro software',
      requestIntercomMessage: 'Olá, quero integrar outro software com o módulo de sensores.',
    },
  },
  findings: {
    title: 'Não conformidades',
    new: 'Novos',
    all: 'Todos',
    createdBy: 'Criado por',
    assignees: 'Responsáveis',
    expires: 'Expira',
    type: 'Tipo',
    location: 'Lugar',
    description: 'Descrição',
    searchPlaceholder: 'Procurar por nome, descrição, autor ou ID',
    searchPlaceholderStore: 'Procurar por nome, descrição, autor, ID ou conteúdo do formulário',
    noResultsWithFilters: 'Não há não conformidades disponíveis no momento',
    newResultsNotice: 'Há novas não conformidades. Atualizar a lista',
    loadError: 'Não foi possível carregar as não conformidades. Tentar novamente',
    sectionLoadError: 'Não foi possível carregar esta seção. Tentar novamente',
    resultWindowNotice:
      'Não encontra a não conformidade que procura? Use a busca ou os filtros para reduzir a lista.',
    createdIn: 'Criado em',
    originQuestion: 'Pergunta',
    note: 'Nota',
    viewForm: 'Ver formulário',
    createYourFirstFinding: 'Crie sua primeira não conformidade',
    emptyState:
      'Adicione uma pergunta do tipo Checklist a um formulário novo ou existente para começar a criar não conformidades.',
    goToForms: 'Ir para formulários',
    detailEmptyState: 'Selecione uma não conformidade para ver o histórico',
    findingDetail: 'Detalhes da não conformidade',
    idCopied: 'ID copiado!',
    findingCodePending: 'A atribuir…',
    filtersLinkCopy: {
      tooltip: 'Copiar link com filtros',
      success: 'Link copiado para o clipboard',
      error: 'Não foi possível copiar o link. Verifique as permissões do navegador.',
    },
    delete: 'Excluir',
    deletedSuccessfully: 'Não conformidade excluída com sucesso',
    tabs: {
      inProgress: 'Em progresso',
      closed: 'Fechados',
    },
    filters: {
      clearFilters: 'Limpar filtros',
      filterByPriority: 'Filtrar por prioridade',
      filterByStatus: 'Filtrar por estado',
      filterChipAssignee: 'Responsável',
      filterChipCreator: 'Criador',
      filterChipForm: 'Formulário',
      filterByForms: 'Filtrar por formulários',
      filterByAssets: 'Filtrar por ativos',
      filterByLocations: 'Filtrar por locais',
      filterByCreators: 'Filtrar por criador',
      filterByAssignees: 'Filtrar por responsável',
      noSearchResultsForms: 'Nenhum formulário encontrado',
      noSearchResultsAssets: 'Nenhum ativo encontrado',
      noSearchResultsLocations: 'Nenhum local encontrado',
      noSearchResultsCreators: 'Nenhum criador encontrado',
      noSearchResultsAssignees: 'Nenhum responsável encontrado',
      formDeleted: 'Eliminado',
      formInactive: 'Inativo',
      dateFilter: {
        title: 'Data',
        popoverTitle: 'Filtrar por data',
        creationDate: 'Data de criação',
        expirationDate: 'Data de vencimento',
      },
    },
    options: {
      viewDetails: 'Ver detalhes',
      addImage: 'Enviar imagem',
      sendFormAnswers: {
        menu: 'Enviar resposta do formulário',
        title: 'Resposta do formulário',
        button: 'Enviar a ñao conformidade',
        cancel: 'Cancelar',
        description: 'Selecione a resposta que deseja enviar para a descoberta',
        searchPlaceholder: 'Buscar formulário',
        answeredBy: 'Respondido por',
        updatedAt: 'Atualizado em',
        noResults: 'Nenhuma resposta encontrada',
        seeAnswer: 'Ver resposta',
        noAnswers: 'Você não tem respostas no momento',
      },
      sendForms: {
        button: 'Enviar',
        menu: 'Enviar formulário',
        sync: 'Sincronizando',
      },
      share: {
        menu: 'Compartilhar link',
        title: 'Compartilhar link',
        text: 'Qualquer pessoa com o link pode acessar a não conformidade',
        activate: 'Habilitar',
        deactivate: 'Desabilitar',
        loginTitle: 'Bem-vindo ao DataScope!',
        loginDescription: 'Para continuar, por favor insira seu nome e e-mai',
        loginNamePlaceholder: 'Seu nome',
        loginEmailPlaceholder: 'E-mail',
      },
    },
    createFindingType: 'Criar tipo de descoberta',
    createFinding: {
      create: 'Criar',
      title: 'Criar não conformidade',
      requiredInformation: 'Informação necessária',
      optionalInformation: 'Informação opcional',
      cancel: 'Cancelar',
      name: 'Nome',
      titleLabel: 'Título',
      titlePlaceholder: 'Descreva o problema em poucas palavras',
      descriptionPlaceholder: 'Descreva o problema com mais detalhes',
      type: 'Tipo de não conformidade',
      description: 'Descrição',
      assignees: 'Atribuído a',
      dueDate: 'Data de vencimento',
      location: 'Local',
      inviteParticipants: 'Convidar participantes',
      asset: 'Ativo',
      findingSuccess: 'Não conformidade criada com sucesso',
      findingError: 'Erro ao criar não conformidade',
      findingCreated: 'Não conformidade criada',
      editInFindings: "Vá para a seção 'Não conformidades' para fazer alguma alteração.",
      evidence: {
        title: 'Evidência',
        required: 'Evidência obrigatória',
        optional: 'Evidência (opcional)',
        addPhoto: 'Imagem',
        uploadError: 'Erro ao enviar imagem',
        limitReached: 'Só é possível anexar até {{max}} fotos. As demais foram ignoradas.',
        requiredError: 'Você deve adicionar pelo menos uma foto como evidência',
        invalidType: 'Somente arquivos de imagem são permitidos',
        sizeExceeded: 'O arquivo excede o tamanho máximo permitido de 10 MB',
      },
      evidenceImageSelected: 'imagem anexada',
      evidenceImagesSelected: 'imagens anexadas',
    },
    editFinding: {
      title: 'Editar não conformidade',
      update: 'Atualizar',
      findingSuccess: 'Não conformidade atualizada com sucesso',
      findingError: 'Erro ao atualizar não conformidade',
    },
    closeFinding: {
      title: 'Fechar não conformidade',
      instruction: 'Complete as seguintes informações para fechar a não conformidade',
      closingNoteLabel: 'Em que estado fechou a não conformidade?',
      cancel: 'Cancelar',
      confirm: 'Fechar não conformidade',
    },
    status: {
      title: 'Status',
      open: 'Aberto',
      in_progress: 'Em progresso',
      paused: 'Pausado',
      closed: 'Fechado',
    },
    priority: {
      title: 'Prioridade',
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
      critical: 'Crítica',
    },
    asset: {
      label: 'Ativo',
      placeholder: 'Selecionar ativo',
      noAsset: 'Sem ativo',
      searchPlaceholder: 'Buscar',
      clear: 'Nenhum',
      clearSelection: 'Desmarcar ativo',
      assetsCount: '{count} ativos',
      assetCount: '1 ativo',
      selected: '1 selecionado',
      noAssets: 'Nenhum ativo encontrado',
      noType: 'Sem tipo',
      emptyStateMessage: 'Crie ativos e aproveite os benefícios',
      goToCreateAssets: 'Criar ativos',
      noSearchResults: 'Nenhum ativo encontrado',
    },
    deleteWarningConfirm: 'Tem certeza de que deseja excluir esta não conformidade?',
    deleteWarningConfirmDescription: 'Será excluído e você não poderá recuperá-lo depois.',
    chat: {
      events: {
        finding_created: 'Não conformidade criada',
        finding_closed: 'finalizou a não conformidade',
        finding_closed_expired: 'finalizou a não conformidade após a data de vencimento estipulada',
        status: 'atualizou o estado para',
        priority: 'atualizou a prioridade para',
        description: 'atualizou a descrição para',
        expiration_date: 'atualizou a data de vencimento para',
        name: 'atualizou o nome a não conformidade para',
        location: 'atualizou o local para',
        added_assignees: 'adicionou',
        removed_assignees: 'eliminou',
        assignees_singular: 'como responsável',
        assignees_plural: 'como responsáveis',
        added_invitees: 'adicionou',
        removed_invitees: 'eliminou',
        invitees_singular: 'como participante',
        invitees_plural: 'como participantes',
        no_expiration_date: 'sem data de vencimento',
        asset: 'atualizou o ativo da não conformidade para',
        deleted_asset: 'eliminou o ativo da não conformidade',
        evidence_added: 'adicionou {{count}} imagens à evidência',
        evidence_added_singular: 'adicionou 1 imagem à evidência',
        evidence_removed: 'removeu {{count}} imagens da evidência',
        evidence_removed_singular: 'removeu 1 imagem da evidência',
        evidence_modified: 'atualizou a evidência',
      },
      image: {
        error: 'Error',
        sync: 'Imagem Sincronizando',
      },
      evidence: {
        attached: '{{count}} imagens foram anexadas como evidência da descoberta',
        attached_singular: '1 imagem foi anexada como evidência da descoberta',
        viewerTitle: 'Evidência da descoberta',
        altMain: 'Evidência {{n}}',
        altThumb: 'Miniatura {{n}}',
        more: '+{{count}}',
        formPhotosNote:
          'As imagens anexadas da pergunta não poderão ser removidas, mas você pode adicionar mais',
      },
      assignedForms: {
        message: 'Responda o seguinte formulário para fornecer mais informações',
      },
    },
    export: {
      pdf: {
        title: 'Exportar PDF',
        tooltip: 'Exportar PDF',
        info: 'Você exportará todas as informações incluídas na não conformidade. Uma vez exportado, o link de download será enviado para o seu email.',
        exportSuccess: 'PDF de não conformidade exportado com sucesso',
        exportError: 'Erro ao exportar PDF de não conformidade',
        buttonTitle: 'PDF',
      },
      all: {
        title: 'Exportar tudo',
        tooltip: 'Exportar para Excel',
        info: 'Você exportará as seguintes variáveis no formato Excel: Nome, descrição, responsáveis, participantes, vencimento, prioridade e localização. Uma vez exportado, o link de download será enviado para o seu e-mail.',
        exportSuccess: 'Não conformidades exportadas com sucesso',
        exportError: 'Erro ao exportar Não conformidades',
        buttonTitle: 'Excel',
      },
      emailInputLabel: 'Email',
      cancel: 'Cancelar',
      confirm: 'Exportar',
    },
    pricing: {
      landing: {
        tagTrial: 'Experimente Tickets grátis por 30 dias',
        tagPaid: 'Disponível nos planos Professional e Enterprise',
        titleTrial: 'Identifique, relate e resolva problemas em tempo real',
        titleExpired: 'Gerencie incidentes e ações corretivas em um só lugar',
        intro:
          'Registre tickets, atribua responsáveis e acompanhe até a resolução, com toda a evidência e conversa em um só lugar.',
        bullet1: 'Relate problemas com evidência e prioridade.',
        bullet2: 'Atribua responsáveis e coordene a resolução.',
        bullet3: 'Mantenha a rastreabilidade de cada ticket até seu fechamento.',
        startTrial: 'Começar teste gratuito',
        startTrialError: 'Não foi possível iniciar seu teste gratuito. Tente novamente.',
        disclaimer:
          'Ao terminar o teste, seus tickets são mantidos e você pode recuperá-los ao migrar para um plano Professional ou Enterprise.',
        knowPlans: 'Conhecer os planos',
        contactSales: 'Falar com vendas',
        contactSalesIntercomMessage: 'Olá, gostaria de saber mais sobre Tickets e os planos que o incluem.',
        demoTitle: 'Conheça o processo de resolução do início ao fim',
        demo1Title: 'Toda a gestão de cada ticket em um só lugar',
        demo1Description:
          'Revise status, prioridade e responsável de cada ticket. Coordene sua resolução a partir do mesmo registro e mantenha toda a evidência centralizada.',
        demo2Title: 'Relate problemas do campo instantaneamente',
        demo2Description:
          'Sua equipe pode registrar incidentes com fotos, comentários e localização pelo app, para que sejam atribuídos e gerenciados imediatamente.',
        demo3Title: 'Acompanhe até o fechamento',
        demo3Description:
          'Mantenha visibilidade do progresso de cada ticket, converse com os envolvidos e registre a solução aplicada para manter a rastreabilidade completa.',
        previous: 'Anterior',
        next: 'Próximo',
        illustrationAlt: 'Ilustração do módulo Tickets',
        accessLapsed: 'Seu acesso a Tickets terminou. Você pode continuar nesta tela, mas ao recarregar precisará de um plano Professional ou Enterprise.',
        illustrationImage:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/ilustracion-tickets-pt.svg',
        demo1Image:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-1-pt.png',
        demo2Image1:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-2-1-pt.png',
        demo2Image2:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-2-2-pt.png',
        demo3Image:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-3-pt.png',
        remainingDays: '{count} dias restantes do seu teste',
      },
    },
    adminAlert:
      'Você poderá ver todas as não conformidades, mas para receber atualizações, deve se atribuir como responsável ou convidado.',
    configure: 'Configurar',
    config: {
      findingTypes: 'Tipos de não conformidades',
      createType: 'Criar tipo',
      editType: 'Editar',
      deleteType: 'Excluir',
      deleteTypeDisabled: 'Você não pode ficar sem tipos de descobertas',
    },
    integrations: {
      title: 'Integração de não conformidades',
      button: 'Integrações',
      gsheetsMenuName: 'Google Sheets',
      gsheetsIntegrationLabel: 'Ir para o Google Sheets',
      infoTextPart1:
        'Para garantir uma integração adequada, privada e segura, compartilhe seu documento com permissões de',
      infoTextPart2: 'editor',
      infoTextPart3: 'apenas para',
      inputLabel: 'Novo Link',
      inputPlaceholder: 'Insira o link do documento a ser integrado',
      save: 'Salvar',
      cancel: 'Cancelar',
      copyUrl: 'URL copiado!',
      created:
        'Integração configurada com sucesso! Por favor, aguarde alguns segundos para que as mudanças entrem em vigor',
      saved: 'Alterações salvas com sucesso!',
      savingError: 'Erro ao configurar a integração',
      confirmation: 'Você deseja salvar as alterações feitas antes de sair?',
      webhooks: 'Webhooks',
      webhookUrl: 'Webhook URL',
      infoWebhooksTextPart1:
        'Automatize seus fluxos de trabalho permitindo que o DataScope acione processos em plataformas externas.',
      infoWebhooksTextPart2: 'Mantenha tudo sincronizado sem esforço',
      import: 'Importar',
      populateGSheet: 'Povoar GSheet',
      populatingGSheet: 'Povoando GSheet...',
      populateGSheetSuccess: 'Google Sheet povoado com sucesso',
      populateGSheetError: 'Erro ao povoar o Google Sheet',
    },
    findingTypes: {
      noType: 'Outro',
      createTitle: 'Criar Tipo de Descoberta',
      editTitle: 'Editar Tipo de Descoberta',
      name: 'Nome',
      assignees: 'Responsáveis',
      assigneesCaption: 'Se você não atribuir um responsável, poderá fazê-lo no aplicativo',
      assigneesNoSearchResults: 'Nenhum usuário corresponde à sua pesquisa',
      removeChipAriaLabel: 'Remover',
      clearAllSelectionAriaLabel: 'Limpar tudo',
      location: 'Localização',
      locationCaption: 'Se você não atribuir um local, poderá fazê-lo no aplicativo',
      assets: 'Ativos',
      save: 'Salvar',
      update: 'Atualizar',
      cancel: 'Cancelar',
      dueDateAndPriority: 'Data de Vencimento e Prioridade',
      priorityInformationBanner:
        'Você pode selecionar uma prioridade como padrão (opcional). O criador da descoberta não poderá alterá-la, mas verá sua descrição.',
      dueDate: 'Data de Vencimento',
      dueDateCaption: 'Esta configuração começará a contar a partir da criação da descoberta',
      dueDateValueRequired: 'Insira um valor maior que 0',
      dueDatePriorityRequired: 'Você deve configurar o vencimento para esta prioridade',
      dueDatePriorityCompatibility:
        'Em versões anteriores à v4.4.2 do app, será utilizado o vencimento mais próximo disponível ({{shortestValue}}).',
      dueDateTypes: {
        days: 'Dias',
        hours: 'Horas',
      },
      dueDateTypesSingular: {
        days: 'dia',
        hours: 'hora',
      },
      mandatoryRequirements: 'Requisitos obrigatórios',
      mandatoryRequirementsTooltip: 'Selecione quais elementos serão obrigatórios na descoberta',
      mandatoryRequirementsNoMatches: 'Não há opções que correspondam à sua pesquisa',
      evidence: 'Evidência',
      evidenceDescription: 'Requer pelo menos uma imagem ao criar a descoberta',
      closureComment: 'Comentário de encerramento',
      closureCommentDescription: 'Requer um comentário obrigatório ao fechar a descoberta',
      dueDateRequirement: 'Data de vencimento',
      dueDateRequirementDescription:
        'A data será calculada automaticamente a partir dos dias/horas definidos',
      configureDueDate: 'Configurar vencimento',
      priority: 'Prioridade',
      description: 'Descrição',
      descriptionPlaceholder: 'Escreva a descrição ou instrução da prioridade',
      additionalInformation: 'Informações Adicionais (Opcional)',
      additionalInformationBanner:
        'Atribuir formulários predefinidos para que os participantes nesta descoberta completem',
      evidenceBanner:
        'Defina se os criadores da descoberta devem anexar fotos como evidência no momento da criação.',
      evidenceOptions: {
        none: 'Não exigir',
        optional: 'Opcional',
        required: 'Obrigatória',
      },
      typeCreatedSuccess: 'Tipo de descoberta criado com sucesso',
      typeCreatedError: 'Erro ao criar tipo de descoberta',
      typeDeletedSuccess: 'Tipo de descoberta excluído com sucesso',
      typeDeletedError: 'Erro ao excluir tipo de descoberta',
      typeUpdatedSuccess: 'Tipo de descoberta atualizado com sucesso',
      typeUpdatedError: 'Erro ao atualizar tipo de descoberta',
      deleteTypeAlertTitle: 'Você tem certeza de que deseja excluir este tipo de descoberta?',
      deleteTypeAlertMessage:
        'Se você excluí-lo, não poderá recuperá-lo, mas as informações relacionadas a ele permanecerão na plataforma',
    },
  },
  commonComponents: {
    sortByName: {
      unsorted: 'Ordenar por nome',
      ascending: 'Ordenado de A a Z',
      descending: 'Ordenado de Z a A',
    },
    formSelector: {
      title: 'Formulários',
      addForm: 'Adicionar formulário',
      searchPlaceholder: 'Buscar formulário, pasta...',
      forms: 'Formulários',
      folders: 'Pastas',
      save: 'Salvar',
      cancel: 'Cancelar',
      see: 'Ver',
      more: 'mais',
      close: 'Fechar',
      maxFormsSelected: 'Você atingiu o limite de formulários selecionados',
      noFormsFound: 'Nenhum formulário encontrado',
      noFoldersFound: 'Nenhuma pasta encontrada',
    },
    confirmActionAlert: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    formDropdownSelector: {
      loading: 'Carregando...',
      noFormsFound: 'Nenhum formulário encontrado',
    },
    dateRangePicker: {
      last7Days: 'Últimos 7 dias',
      last14Days: 'Últimos 14 dias',
      last30Days: 'Últimos 30 dias',
      last60Days: 'Últimos 60 dias',
      last90Days: 'Últimos 90 dias',
      thisYear: 'Este ano',
      today: 'Hoje',
      thisWeek: 'Esta semana',
      nextWeek: 'Próxima semana',
      next7Days: 'Próximos 7 dias',
      next14Days: 'Próximos 14 dias',
      next30Days: 'Próximos 30 dias',
      next60Days: 'Próximos 60 dias',
      next90Days: 'Próximos 90 dias',
      moreOptions: 'Mais opções',
      pastRanges: 'Faixas Passadas',
      futureRanges: 'Faixas Futuras',
    },
    locationSelector: {
      loading: 'Carregando...',
      noLocationsFound: 'Nenhum local encontrado',
      placeholder: 'Selecionar um local',
      nestableLocations: 'Locais',
      legacyLocations: 'Lista de Locais (Antigo)',
    },
  },
  webHooks: {
    title: 'WebHooks',
    new: {
      title: 'Criar novo WebHook',
      token: 'Token:',
      expires_in: 'Expira em:',
      expires_at: 'Expira às:',
      form: 'Formulário',
      select_form: 'Selecionar um formulário',
      select_all_forms: 'Todos os formulários',
      url: 'Url da conexão',
      example_url: 'http://www.seuservidor.com/servico',
      send_modifications: 'Enviar modificações',
      oauth_checkbox: 'Autenticar com OAuth2',
      save: 'Salvar',
      back: 'Voltar para WebHooks',
      configure_oauth: 'Configurar OAuth 2.0',
      access_token: 'URL do Token de Acesso',
      client_id: 'ID do cliente',
      client_secret: 'Chave secreta do cliente',
      scope: 'Scope',
      save_oauth: 'Salvar Configuração OAuth',
      save_oauth_success: 'Token de OAuth criado com sucesso',
      save_oauth_error: 'Houve um erro ao criar o token de OAuth',
      token_details: 'Detalhes do Token',
      create_webhook: 'Criar WebHook',
      create_webhook_success: 'WebHook criado com sucesso',
      create_webhook_error: 'Houve um erro ao criar o WebHook',
    },
    update: {
      update_webhook: 'Atualizar WebHook',
      update_webhook_success: 'WebHook atualizado com sucesso',
      update_webhook_error: 'Houve um erro ao atualizar o WebHook',
    },
    webhook_not_found: 'WebHook não encontrado',
    load_webhook_error: 'Houve um erro ao carregar o WebHook',
  },
  answerView: {
    correction: {
      correct: 'Corrigir',
      success: 'Formulário corrigido. A solicitação de assinatura foi enviada com sucesso',
      error: 'Não foi possível reenviar a solicitação de assinatura. Ela continua rejeitada, você pode tentar novamente.',
      alreadyCorrected: 'Esta solicitação já foi corrigida e está aguardando assinatura. Não é preciso corrigi-la de novo.',
      alreadySigned: 'Esta resposta tem uma solicitação de assinatura em andamento e não pode ser editada.',
      manualResendNotice: 'Ao corrigir, a solicitação de assinatura não é reenviada sozinha: este formulário não a envia automaticamente. Depois de salvar, envie-a de novo.',
      savedResendByHand: 'Formulário corrigido. Lembre-se de enviar a solicitação de assinatura de novo: este formulário não a envia automaticamente.',
      goToRequest: 'Ver a solicitação',
    },
    alreadyRejectedSignature: 'Você recusou assinar este formulário',
    rejectConfirmationTitle: 'Tem certeza que deseja rejeitar esta solicitação?',
    rejectConfirmationDescription:
      'Uma vez rejeitado, você não poderá assinar este formulário novamente.',
    reject: 'Rejeitar',
    rejectSuccess: 'Solicitação de assinatura rejeitada!',
    rejectError: 'Não foi possível rejeitar a assinatura',
    rejectAlreadyRejected:
      'A solicitação já havia sido rejeitada e por isso não foi possível rejeitar.',
    location: 'Local',
    address: 'Endereço',
    assignee: 'Responsável',
    taskInformation: 'Informações da tarefa atribuída',
    description: 'Descrição',
    tasks: 'Tarefas',
    answeredFromMobile: 'Enviado desde o aplicativo móvel',
    answeredFromWeb: 'Enviado desde a web',
    electronicallySignedBy: 'Assinado eletronicamente por:',
    verifySignatureAlert:
      'Para assinar o formulário, primeiro você deve verificar sua assinatura, isso só será feito uma vez.',
    configureSignatureAlert:
      'Para assinar o formulário, primeiro você deve configurar e verificar sua assinatura, isso só será feito uma vez.',
    configureSignature: 'Configurar assinatura eletrônica',
    lackOfPermissions:
      'Você não tem permissão para editar seu perfil. Solicite ao administrador que complete suas informações para que você possa continuar.',
    verifySignature: 'Verificar assinatura',
    sign: 'Assinar',
    alreadySignedAlert: 'Você já assinou este formulário',
    rejectedAlert: 'Você recusou assinar este formulário',
    goToSignatures: 'Ir para assinaturas',
    signatureConfigAlert: 'Por favor, verifique a configuração da assinatura eletrônica',
    reverifySignatureAlert:
      'A configuração de assinatura da sua conta foi atualizada. Você precisa verificar sua assinatura novamente para assinar.',
    quorumReached: {
      title: 'Pronto! As assinaturas necessárias foram alcançadas.',
      description:
        'Este documento já possui as assinaturas necessárias no seu grupo. Não é necessário assinar, mas você pode verificar se tem outras pendentes.',
      button: 'Ir para assinaturas',
    },
    signSuccess: 'Formulário assinado com sucesso!',
    signError: 'Ocorreu um erro ao assinar o formulário',
    signatureVerifySuccess:
      'Você verificou sua assinatura eletrônica com sucesso! Agora você poderá assinar todos os seus formulários',
    signatureVerifyError: 'Ocorreu um erro ao verificar a assinatura eletrônica',
    checkedCountInfo: 'elementos selecionados',
    checkedCountListInfo: 'Elementos selecionados de uma lista de',
    items: 'elementos',
    total: 'total',
    group: 'Grupo',
    nestableLocationBelongsTo: 'Pertence a',
    attachedFiles: 'Estes são os arquivos anexados a esta pergunta.',
    editAnswer: 'Editar resposta',
    editAnswerDisabled: 'Você não pode editar a resposta porque tem uma solicitação de assinatura',
    editAnswerNoPermission: 'Você não tem permissão para editar esta resposta',
    viewDocumentValidation: 'Ver Validação de Documento',
    qrUniqueDocumentTitle: 'QR único do documento',
    qrUniqueDocumentDescription:
      'Este documento possui assinatura eletrônica; sua autenticidade pode ser verificada ao escanear o código QR.',
    metadataComments: {
      item: 'Item',
      answer: 'Resposta',
      description: 'Comentário',
      images: 'Imagens',
      issues: 'Não conformidades',
      viewIssue: 'Ver não conformidade',
    },
    expiredLink: {
      description: 'Este link expirou. Solicite um novo clicando no botão',
      button: 'Solicitar link',
      newLinkRequestedSuccess: 'O link foi enviado para o seu e-mail',
      newLinkRequestedError: 'Ocorreu um erro ao solicitar o novo link',
    },
    externalUserSign: {
      title: 'Registre sua assinatura',
      registeredDescription:
        'Sua assinatura está registrada, por favor confirme seus dados para continuar',
      unregisteredDescription:
        'Sua assinatura não está registrada, para assinar, complete os dados a seguir',
      name: 'Nome completo',
      company: 'Empresa',
      role: 'Cargo',
      confirm: 'Continuar',
      cancel: 'Cancelar',
      success: 'Formulário assinado com sucesso!',
      error: 'Ocorreu um erro ao assinar o formulário',
    },
    rejectModal: {
      title: 'Rejeitar solicitação',
      subtitle: 'Insira o motivo da rejeição da solicitação de assinatura',
      selectSubtitle: 'Selecione o motivo para rejeitar a solicitação:',
      placeholder: 'Escreva o motivo aqui (Obrigatório)',
      minLength: 'Mínimo 5 caracteres',
      otherOption: 'Outro',
      cancel: 'Cancelar',
      confirm: 'Rejeitar',
    },
    locationInfo: {
      title: 'Informações de locais detectados',
      description: 'A resposta foi detectada em um local da sua lista de locais',
      viewInMap: 'Ver no mapa',
      nameAndDistance: 'Nome e distância',
      distanceHelpIcon:
        'O local foi detectado automaticamente. É mostrada a distância entre o local detectado e o ponto de onde a resposta foi enviada.',
      awayFromLocation: 'km do local',
      detectedByGps: 'Detectado por GPS',
    },
    formatErrors: {
      warningMessage:
        'Houve problemas para exibir certas respostas. Por favor, entre em contato com o suporte.',
      workingWarningMessage:
        'Estamos cientes de um erro no registro de dados. Estamos trabalhando em uma solução.',
      answerListTitle: 'Respostas com problemas de exibição:',
    },
    signature: {
      name: 'Nome',
      idNumber: {
        CL: 'RUT',
        PE: 'DNI',
        MX: 'CURP',
        CO: 'CC',
        AR: 'DNI',
        PY: 'CI',
        ES: 'DNI/NIE',
        BR: 'CPF',
        UY: 'CI',
        BO: 'CI',
        EC: 'Cédula',
        VE: 'Cédula',
        US: 'SSN',
        CA: 'SIN',
        DO: 'Cédula',
        CR: 'Cédula',
        PA: 'Cédula',
        GT: 'DPI',
        SV: 'DUI',
        HN: 'DNI',
        NI: 'Cédula',
        PR: 'SSN',
        CU: 'CI',
        JM: 'TRN',
        PT: 'NIF',
        FR: 'INSEE',
        DE: 'ID Tributário',
        IT: 'Codice Fiscale',
        GB: 'Número de Seguro Nacional',
        IE: 'Número PPS',
        NL: 'BSN',
        BE: 'Número Nacional',
        CH: 'Número AHV',
        AT: 'Número de Segurança Social',
        SE: 'Número Pessoal',
        NO: 'ID Nacional',
        DK: 'Número CPR',
        FI: 'Código de Identidade Pessoal',
        IS: 'Kennitala',
        PL: 'PESEL',
        CZ: 'Número de Nascimento',
        SK: 'Número de Nascimento',
        HU: 'Número Tributário',
        RO: 'CNP',
        BG: 'EGN',
        GR: 'AMKA/AFM',
        HR: 'OIB',
        SI: 'EMSO',
        RS: 'JMBG',
        BA: 'JMBG',
        ME: 'JMBG',
        MK: 'EMBG',
        MT: 'Cartão de ID',
        CY: 'Número de ID',
        LU: 'ID Nacional',
        LT: 'Código Pessoal',
        LV: 'Código Pessoal',
        EE: 'Código Pessoal',
        TR: 'TC Kimlik No',
        IL: 'Número de ID',
        SA: 'ID Nacional',
        AE: 'Emirates ID',
        QA: 'QID',
        KW: 'ID Civil',
        BH: 'CPR',
        OM: 'ID Civil',
        JO: 'ID Nacional',
        LB: 'Número de ID',
        EG: 'ID Nacional',
        MA: 'CIN',
        TN: 'CIN',
        DZ: 'ID Nacional',
        ZA: 'Número de ID',
        NG: 'NIN',
        KE: 'Número de ID',
        GH: 'Ghana Card',
        UG: 'ID Nacional',
        TZ: 'NIDA',
        RW: 'ID Nacional',
        BW: 'Omang',
        NA: 'Número de ID',
        ZM: 'NRC',
        ZW: 'ID Nacional',
        ET: 'ID Nacional',
        CN: 'ID Nacional',
        IN: 'Aadhaar',
        PK: 'CNIC',
        BD: 'NID',
        JP: 'My Number',
        KR: 'RRN',
        SG: 'NRIC/FIN',
        MY: 'MyKad',
        ID: 'KTP',
        PH: 'UMID',
        TH: 'ID Nacional',
        VN: 'CCCD',
        HK: 'HKID',
        TW: 'ID Nacional',
        LK: 'NIC',
        NP: 'ID Nacional',
        AU: 'TFN/Medicare',
        NZ: 'Número IRD',
        RU: 'SNILS',
        UA: 'Número Tributário',
        BY: 'ID Nacional',
        KZ: 'IIN',
        UZ: 'PINFL',
        GE: 'Número Pessoal',
        AM: 'Cartão Social',
        AZ: 'FIN',
      },
      email: 'Email',
      date: 'Data',
      of: 'de',
      rejectedInfoPartial: 'rejeitou este documento em',
      rejectedWithReason:
        '{name} rejeitou este documento em {date} devido a que {reason}. Convidamos você a fazer as correções necessárias no documento atual e gerar uma nova solicitação de assinatura.',
      rejectedWithoutReason:
        '{name} rejeitou este documento em {date}. Convidamos você a fazer as correções necessárias no documento atual e gerar uma nova solicitação de assinatura.',
      rejectedWithReasonStandardized:
        '{name} rejeitou este documento em {date} devido a que {reason}. A solicitação foi interrompida até que o documento seja corrigido e reenviado.',
      rejectedWithoutReasonStandardized:
        '{name} rejeitou este documento em {date}. A solicitação foi interrompida até que o documento seja corrigido e reenviado.',
      rejectedWithReasonStandardizedSelf:
        'Você rejeitou este documento em {date} devido a que {reason}. A solicitação foi interrompida até que o documento seja corrigido e reenviado.',
      rejectedWithoutReasonStandardizedSelf:
        'Você rejeitou este documento em {date}. A solicitação foi interrompida até que o documento seja corrigido e reenviado.',
      weInviteYouTo: 'Invitamos você a',
      makeCorrections:
        'fazer as correções necessárias no documento atual e gerar uma nova solicitação de assinatura.',
    },
    back: 'Voltar',
    paywall: {
      title: 'Você atingiu o limite de respostas. Atualize seu plano para ver mais',
      button: 'Atualizar plano',
      chat_message: 'Olá, preciso ver mais respostas. Como posso atualizar meu plano?',
    },
    downloadPdf: 'Baixar PDF',
    status: 'Status',
    noStatus: 'Sem estado',
    activityPeriodTime: {
      startTime: 'Início da atividade',
      endTime: 'Fim da atividade',
      activity: 'Atividade',
      duration: 'Duração',
    },
  },
  electronic_signature: {
    verifySignature: 'Verificar assinatura',
    annex: 'Anexo',
    sendCode: 'Enviar código',
    errorSendingCode: 'Ocorreu um erro ao enviar o código',
    successSendingCode: 'Código enviado com sucesso',
    code_sent_to_email: 'Enviamos o código de verificação para o seu e-mail:',
    resendCodeLabel: 'Não recebeu o código? ',
    resend: 'Reenviar',
    incorrect_code: 'Código incorreto, você tem {remaining_attempts} tentativas restantes',
    maxAttemptsReached: 'Você atingiu o número máximo de tentativas, um novo código foi reenviado',
    errorVerifyingCode: 'Erro ao verificar o código',
    back: 'Voltar',
    share: 'Compartilhar',
    signatures: {
      title: 'Minhas assinaturas',
      signature_date: 'Data da assinatura',
      noPendingSignatures: 'Parabéns! Você não tem assinaturas pendentes no momento',
      noCompletedSignatures: 'Você não tem assinaturas completadas no momento',
      noRejectedSignatures: 'Você não tem assinaturas rejeitadas no momento',
      noSignaturesAvailable: 'Você não tem assinaturas disponíveis neste momento',
      selected: 'Selecionados',
      sign: 'Assinar',
      downloadSigned: 'Baixar',
      massiveSignError: 'Ocorreu um erro ao assinar os formulários',
      massiveSignSuccess: 'Formulários assinados com sucesso',
      downloadError: 'Ocorreu um erro ao baixar o arquivo',
    },
    documentValidation: {
      validDocumentTitle: 'Documento Válido',
      formSummary:
        'Formulário {form_name} respondido por {user_name}. Data de resposta: {answer_date}.',
      openDetails: 'Acesse aqui os detalhes do documento',
      respondedByLabel: 'Respondido por:',
      answerDateLabel: 'Data de resposta:',
      signedByTitle: 'Assinado por:',
      signerNameLabel: 'Nome',
      signerRutLabel: 'RUT',
      signerEmailLabel: 'Email',
      signerDateLabel: 'Data',
      accessRestrictionNote:
        'Para acessar os detalhes do documento você deve estar logado na DataScope',
      footerLegalText:
        'Este documento cumpre com a normativa chilena vigente e sua assinatura eletrônica é validada pela Direção do Trabalho.',
      footerOrdinanceIntro: 'Consulte a portaria ',
      footerOrdinanceLinkLabel: 'aqui',
      footerCta: 'Digitalize seus documentos com a DataScope',
      noSigners: 'Este documento ainda não possui assinaturas registradas',
      error:
        'Não foi possível validar este documento. Verifique o link ou entre em contato com o suporte.',
    },
    filters: {
      date: 'Data',
      datePopoverTitle: 'Filtrar por data',
      allDates: 'Todas',
      form: 'Formulário',
      formPopoverTitle: 'Filtrar por formulários',
      requester: 'Responsável',
      requesterPopoverTitle: 'Filtrar por responsável',
      location: 'Local',
      locationPopoverTitle: 'Filtrar por local',
      participants: 'Participantes',
      participantsPopoverTitle: 'Filtrar por participante',
      all: 'Todos',
      selected: 'selecionados',
      search: 'Buscar',
      noOptions: 'Nenhum resultado encontrado',
      status: 'Status',
      statusPopoverTitle: 'Filtrar por status',
      formCode: 'Código do formulário',
      formCodePopoverTitle: 'Filtrar por código do formulário',
      formCodePlaceholder: 'Digite o código',
      clearAll: 'Limpar filtros',
      deletedSuffix: 'Excluído',
      inactiveSuffix: 'Inativo',
      allTab: 'Usuários',
      groupTab: 'Grupos',
      noUsers: 'Nenhum usuário encontrado',
      noGroups: 'Nenhum grupo encontrado',
      formsTab: 'Formulários',
      foldersTab: 'Pastas',
      dateFieldRequested: 'Data da solicitação',
      dateFieldSignedMine: 'Data de assinatura (assinaturas concluídas)',
      dateFieldSignedRequest: 'Data de assinatura (assinaturas finalizadas)',
      dateFieldSignedShort: 'Data de assinatura',
      noForms: 'Nenhum formulário encontrado',
    },
    statusFilter: {
      allStatuses: 'Todas',
      rejected: 'Rejeitadas',
      pending: 'Pendentes',
      completed: 'Concluídas',
      ongoing: 'Em andamento',
      finished: 'Finalizadas',
    },
    statusChip: {
      pending: 'Pendente',
      signed: 'Assinada',
      ongoing: 'Em andamento',
      finished: 'Finalizada',
      rejected: 'Rejeitada',
    },
    lastActivity: {
      title: 'Última atividade',
      signed: 'assinou o documento',
      rejected: 'rejeitou a solicitação',
      reason: 'Motivo',
      unknownUser: 'Um usuário',
      rejectedBy: 'Rejeitado por',
      rejectReasonLabel: 'Motivo da rejeição',
      nextSigner: 'Próximo',
      signedShort: 'Assinou',
      rejectedShort: 'Rejeitou',
      correctedShort: 'Solicitação corrigida',
      onDate: 'Em',
      andMore: 'e mais {count}',
      moreSigners: 'signatários a mais',
      sent: 'Solicitação enviada',
    },
    statusCards: {
      pending: 'Pendentes',
      signed: 'Assinadas',
      ongoing: 'Em andamento',
      finished: 'Finalizadas',
      rejected: 'Rejeitadas',
      requiresAction: 'Requerem ação',
      filterHint: 'Clique para filtrar',
      totalSignatures: 'Total de assinaturas',
      totalRequests: 'Total de solicitações',
    },
    requests: {
      notifyByEmail: 'Notificar por e-mail',
      title: 'Solicitações enviadas',
      mandatory: 'Assinatura obrigatória',
      optional: 'Assinatura opcional',
      ongoing: 'Em andamento',
      completed: 'Finalizadas',
      searchPlaceholder: 'Buscar por usuário ou formulário...',
      form: 'Formulário',
      requestDate: 'Data da solicitação',
      requestDateLong: 'Data da solicitação',
      requestedBy: 'Solicitado por',
      goToSign: 'Ir para assinar',
      signatureDate: 'Data da assinatura',
      signatures: 'Assinaturas',
      signed: 'Já assinaram',
      pending: 'Pendentes',
      actions: 'Ações',
      deleteRequest: 'Excluir solicitação',
      viewRequestDetail: 'Ver detalhe da solicitação',
      correct: 'Corrigir',
      correctNoPermission: 'Você não tem permissão para editar esta solicitação de assinatura rejeitada',
      deleteSuccess: 'Solicitação excluída com sucesso',
      deleteError: 'Erro ao excluir solicitação',
      notifyByEmailSuccess: 'Usuários notificados com sucesso',
      notifyByEmailError: 'Erro ao notificar usuários',
      loadError: 'Não foi possível carregar a lista. Tente novamente.',
      noOngoingRequests: 'Tudo em ordem! Você não tem solicitações em andamento no momento.',
      noCompletedRequests: 'Você ainda não tem solicitações finalizadas.',
      noRejectedRequests: 'Você ainda não tem solicitações rejeitadas.',
      noRequestsAvailable: 'Você não tem solicitações disponíveis neste momento',
      noFilterResults: 'Nenhuma assinatura disponível no momento',
      clearFilters: 'Limpar filtros',
      shareModal: {
        title: 'Compartilhar solicitação de assinatura finalizada',
        share: 'Compartilhar',
        infoAlert:
          'Um arquivo será enviado por e-mail. Os destinatários poderão acessar e revisar os detalhes facilmente.',
        emailInstruction: 'Insira o endereço para o qual deseja enviar o arquivo.',
        inputInstruction: 'Você pode adicionar tarefas rapidamente separando-as com vírgulas “,”.',
        cancel: 'Cancelar',
      },
      shareSuccess: 'Solicitação compartilhada com sucesso',
      shareError: 'Ocorreu um erro ao compartilhar a solicitação',
      deleteWarningTitle: 'Tem certeza de que deseja excluir esta solicitação?',
      deleteWarningMessage:
        'As assinaturas já realizadas continuarão válidas e ficarão guardadas no histórico.',
      timeline: {
        title: 'Detalhe da solicitação',
        close: 'Cerrar',
        correctRequest: 'Corrigir solicitação',
        createdRequired: '{user} enviou uma solicitação de assinatura obrigatória',
        createdOptional: '{user} enviou uma solicitação de assinatura opcional',
        createdRequiredSimultaneous:
          '{user} enviou uma solicitação de assinatura obrigatória para:',
        createdOptionalSimultaneous: '{user} enviou uma solicitação de assinatura opcional para:',
        createdQuorumSimultaneous: '{user} enviou uma solicitação de assinatura',
        createdRequiredSequential:
          '{user} enviou uma solicitação de assinatura obrigatória com esta ordem:',
        createdOptionalSequential:
          '{user} enviou uma solicitação de assinatura opcional com esta ordem:',
        createdQuorumSequential: '{user} enviou uma solicitação de assinatura com esta ordem:',
        signed: '{user} assinou o documento',
        rejected: '{user} recusou a solicitação',
        rejectReason: 'Motivo',
        signatureRequested: 'Solicitação enviada para {user} ({number} assinantes)',
        signatureRequestedGroupSingular:
          'Solicitação enviada para {users} (Assinante grupo {group})',
        signatureRequestedGroupPlural:
          'Solicitação enviada para {users} (Assinantes grupo {group})',
        completed: 'Todas as assinaturas requeridas foram completadas. O documento já está pronto',
        corrected: 'Solicitação corrigida por {user}',
        signer: 'Assinante',
        signerSingular: 'assinante',
        signerPlural: 'assinantes',
        group: 'Grupo',
        quorumRequiredSingular: 'é necessária pelo menos {min} assinatura',
        quorumRequiredPlural: 'são necessárias pelo menos {min} assinaturas',
      },
      tooltip: {
        signed: 'Solicitação concluída',
        rejected: 'Solicitação rejeitada',
      },
    },
    promo: {
      title: 'Assine relatórios digitalmente e garanta os processos',
      description:
        'Com o módulo de Assinaturas, você pode solicitar e assinar processos de forma simples e segura.',
      actionButton: 'Quero implementar Assinaturas!',
      moreInfoTitle: 'Garanta a rastreabilidade e reduza a margem de erro!',
      infoPoint1: 'Solicite assinaturas da sua equipe de campo e envie notificações automáticas',
      infoPoint2: 'Garante o cumprimento dos seus processos',
      infoPoint3: 'Aprovado pela Direção do Trabalho (válido somente no Chile)',
      infoPoint4: 'Acesse seus dados de forma segura a partir de qualquer dispositivo',
      moreInfoButton: 'Quero mais informações!',
      moreInfoLink:
        'https://help.mydatascope.com/pt-BR/articles/8728763-assinatura-eletronica-verificada',
    },
    emptyState: {
      mainBanner: {
        title: 'Assine relatórios digitalmente e garanta processos seguros',
        description:
          'Com o módulo "Assinaturas", você pode solicitar e assinar processos de forma simples e segura.',
        actionButton: 'Quero implementar Assinaturas!',
        actionButtonError:
          'Ocorreu um erro ao solicitar a implementação. Contate o suporte para mais informações.',
        actionButtonSuccess: 'Solicitação de implementação enviada com sucesso',
        actionButtonTooltipAdminUnrequested: 'Solicitar implementação',
        actionButtonTooltipAdminRequested: 'A implementação já foi solicitada',
        actionButtonTooltipUser: 'Apenas o administrador da conta pode realizar esta ação',
      },
      gallery: {
        title: 'Gerencie assinaturas com validade legal',
        verifySignatures: 'Verifique e salve as assinaturas da equipe',
        verifySignaturesAlt: 'Smartphone exibindo a verificação de assinatura no app',
        requestSignatures: 'Solicite assinaturas em formulários específicos',
        requestSignaturesAlt:
          'Smartphone exibindo uma resposta e o botão de solicitar assinatura no app',
        acceptSignatures: 'Aceite ou rejeite assinaturas',
        acceptSignaturesAlt:
          'Smartphone exibindo uma resposta com assinatura solicitada e os botões de aceitar e rejeitar',
        trackSignatures: 'Acompanhe o status de cada assinatura',
        trackSignaturesAlt:
          'Smartphone exibindo a lista de solicitações de assinatura incompletas e seus detalhes no app',
        pdfSignatures: 'Obtenha relatórios em PDF com assinaturas digitais',
        pdfSignaturesAlt:
          'Smartphone exibindo o relatório em PDF com as assinaturas digitais incluídas e destacadas',
      },
      requestMoreInfo: {
        title: 'Adicione ao seu plano hoje mesmo!',
        description:
          'Converse com um especialista e descubra como implementar o módulo na sua organização',
        button: 'Solicitar mais informações',
        link: 'https://datascope.io/pt/nueva_firma/#',
      },
      newFeatures: {
        title: 'A partir de hoje, você pode usar estas novas funcionalidades!',
        preConfigTitle: 'Pré-configuração de assinantes',
        preConfigDescription:
          'Defina previamente quem deve assinar seus documentos, automatizando fluxos recorrentes e economizando tempo.',
        externalSignatureTitle: 'Assinatura de usuários externos',
        externalSignatureDescription:
          'Convide colaboradores de fora da organização para assinar com segurança, sem precisar de uma conta no DataScope.',
        sequentialSignatureTitle: 'Configure a sequência de assinaturas',
        sequentialSignatureDescription:
          'Defina uma ordem preestabelecida de assinaturas para documentos com vários assinantes de diferentes hierarquias.',
      },
    },
    activation: {
      processTitle: 'Sua solicitação de ativação do módulo de Assinaturas já está em processo!',
      processMessage:
        'Um representante do nosso time entrará em contato com você para explicar os detalhes do processo de ativação da Assinaturas.',
      stepsTitle: 'Próximos passos',
      step1Title: 'Solicitação de ativação do módulo de Assinaturas inserida com sucesso.',
      step2Title: 'Um especialista da DataScope entrará em contato com você.',
      step2Description: 'Máximo 1 dia útil',
      step3Title: 'Apresentação do módulo de Assinaturas.',
      step3Description: 'Data para coordenar com o especialista',
      step4Title: 'Ativação do módulo de Assinaturas.',
      step4Description: 'Você poderá acessar a partir da mesma aba!',
    },
  },
  resume: {
    stats: {
      assignedTasks: 'Tarefas Atribuídas',
      completedTasks: 'Tarefas finalizadas',
      forms: 'Formulários',
      totalForms: 'Total respondidos',
      locations: 'Locais Visitados',
      totalLocations: 'Total de locais',
      signatures: 'Assinaturas',
      completedSignatures: 'Assinaturas finalizadas',
      findings: 'Não conformidades',
      closedFindings: 'Não conformidades fechadas',
      previousDays: 'dias anteriores',
    },
    emptyState: {
      description:
        'Você ainda não respondeu a nenhum formulário! Comece a otimizar seus processos criando o primeiro',
      createFirstForm: 'Criar um formulário agora',
    },
    statuses: {
      pending: 'Pendente',
      accepted: 'Aceito',
      rejected: 'Rejeitado',
      noStatus: 'Sem estado',
    },
    table: {
      configure: 'Configurar',
      viewAnswer: 'Ver Resposta',
      form: 'Formulário',
      code: 'Código',
      user: 'Usuário',
      date: 'Data',
      status: 'Estado',
      actions: 'Ações',
      changeLog: 'Registro de mudanças',
      modifyAnswer: 'Modificar resposta',
      chat: 'Chat',
      sendToGoogleSheets: 'Enviar para Google Sheets',
      sendBackupToEmail: 'Enviar respaldo para o e-mail',
      downloadPdf: 'Baixar PDF',
      duplicateAnswer: 'Duplicar resposta',
      statusUpdateError: 'Ocorreu um erro ao atualizar o estado da resposta',
      noResults: 'Nenhuma resposta de formulário encontrada que corresponda aos filtros aplicados',
      deleteAnswer: 'Excluir',
      recoverAnswer: 'Recuperar',
    },
    bulkActions: {
      delete: 'Excluir',
      changeStatus: 'Alterar estado',
      selected: 'selecionados',
      confirmDelete: 'Tem certeza de que deseja excluir {count} respostas de formulários?',
      confirmDeleteDescription: 'Uma vez excluídos, não poderão ser recuperados',
      cancel: 'Cancelar',
      selectStatus: 'Selecionar estado',
      select: 'Selecionar',
      statuses: 'Estados',
      selectStatusPlaceholder: 'Selecione um estado',
      statusesUpdated: 'Estados atualizados com sucesso!',
      errorUpdatingStatuses: 'Erro ao atualizar estados',
      deleteSuccess: 'Respostas excluídas com sucesso!',
      deleteError: 'Erro ao excluir respostas',
      recover: 'Recuperar',
      recoverSuccess: 'Respostas recuperadas com sucesso!',
      recoverError: 'Erro ao recuperar respostas',
    },
    filters: {
      addFilter: 'Adicionar filtro',
      clearFilters: 'Limpar filtros',
      dateRange: {
        title: 'Data',
        popoverTitle: 'Filtrar por data',
      },
      location: {
        title: 'Local',
        popoverTitle: 'Filtrar por local',
        noLocations: 'Nenhum local encontrado',
      },
      form: {
        title: 'Formulário',
        popoverTitle: 'Filtrar por formulário',
        inactive: 'Inativo',
        deleted: 'Excluído',
        folders: 'Pastas',
        forms: 'Formulários',
        noForms: 'Nenhum formulário encontrado',
      },
      status: {
        title: 'Estado',
        popoverTitle: 'Filtrar por estado',
      },
      user: {
        title: 'Usuário',
        popoverTitle: 'Filtrar por usuário',
        allTab: 'Usuários',
        groupTab: 'Grupos',
        noUsers: 'Nenhum usuário encontrado',
        noGroups: 'Nenhum grupo encontrado',
      },
      formCode: {
        title: 'Código do formulário',
        popoverTitle: 'Filtrar por código do formulário',
        placeholder: 'Digite o código',
      },
      questionAndAnswer: {
        title: 'Pergunta e resposta',
        popoverTitle: 'Filtrar por pergunta e resposta',
        questionLabel: 'Pergunta',
        questionPlaceholder: 'Selecione uma pergunta',
        questionTextInputPlaceholder: 'Digite o nome da pergunta',
        answerLabel: 'Resposta',
        answerDisabledPlaceholder: 'Selecione uma pergunta para ativar o filtro',
        answerTextInputPlaceholder: 'Digite o nome de uma pergunta para ativar o filtro',
        answerPlaceholder: 'Digite a resposta',
        info: 'O filtro só se aplicará se houver uma pergunta e uma resposta',
        disabledTooltip:
          'Para usar este filtro, primeiro você deve adicionar um filtro de formulário',
      },
      finding: {
        title: 'Não conformidade',
        popoverTitle: 'Filtrar por não conformidade',
        includesFinding: 'Inclui não conformidade',
        withoutFindings: 'Sem não conformidades',
      },
      signature: {
        title: 'Assinatura',
        popoverTitle: 'Filtrar por assinatura',
      },
      answeredFrom: {
        title: 'Meio de envio',
        popoverTitle: 'Filtrar por meio de envio',
        mobile: 'Móvel',
        web: 'Web',
      },
      assets: {
        title: 'Ativos',
        popoverTitle: 'Filtrar por ativos',
        noAssets: 'Nenhum ativo encontrado',
      },
    },
    signature: {
      mandatoryIncomplete: 'Assinatura obrigatória - Pendente',
      mandatoryComplete: 'Assinatura obrigatória - Completa',
      optionalIncomplete: 'Assinatura opcional - Pendente',
      optionalComplete: 'Assinatura opcional - Completa',
      rejected: 'Assinatura rejeitada',
      quorumPending: 'Assinatura pendente',
      quorumComplete: 'Assinatura completa',
    },
    recentTitle: 'Formulários Recentes',
    deletedTitle: 'Formulários Eliminados',
    searchBarPlaceholder: 'Buscar por nome do formulário',
    dateRange: 'Mostrando resultados para',
    changeLog: {
      title: 'Registro de mudanças',
      details: 'Ver detalhes',
      userChangedAnswer: '{user} modificou a resposta',
      userChangedState: '{user} alterou o estado da resposta para {state}',
      userRecoveredAnswer: '{user} recuperou a resposta',
      userDeletedAnswer: '{user} eliminou a resposta',
      userDuplicatedAnswer: '{user} duplicou a resposta',
      userStartedAnswer: '{user} começou a responder',
      userResetState: '{user} reestabeleceu o estado da resposta',
      googleSheets: 'Google Sheets',
      webhookSyncErrors: '{count} erros ao sincronizar com',
      webhookSyncError: '1 erro ao sincronizar com',
      webhookSyncRestored: 'Sincronização restaurada com',
      webhookSyncOk: 'Sincronização bem-sucedida com',
      viewErrorDetails: 'Ver detalhes dos erros',
      hideErrorDetails: 'Ocultar erros',
    },
    close: 'Fechar',
    export: {
      title: 'Exportar',
      taskForm: 'Formulário',
      dateRange: 'Intervalo de data',
      downloadFormat: 'Formato de download',
      email: 'Email',
      downloadFormats: {
        answers: 'Excel agrupado por resposta',
        forms: 'Excel agrupado por formulário',
        subforms: 'Excel agrupado por perguntas repetíveis',
        pdfs: 'Excel com documentos PDF',
        pdfsZip: 'Documentos PDF em ZIP',
      },
      exportInfo: 'As respostas serão exportadas conforme os filtros da tabela',
      exportFormFilterRequired:
        'Para exportar as respostas, você deve primeiro filtrar por formulário',
      exportDateRangeLimit:
        'Limite de exportação: 180 dias (6 meses). Selecione um intervalo de data menor',
      cancel: 'Cancelar',
      success: 'Exportação enviada com sucesso',
      error: 'Ocorreu um erro ao exportar as respostas',
      disabledForFreeUser: 'Atualize seu plano para habilitar a exportação de dados',
      selectOrFilterToExport: 'Filtre por formulário ou selecione respostas para exportar.',
      clearSelectionForExcel: 'Remova a seleção para exportar para o Excel.',
      formatPlaceholder: 'Selecionar formato',
      documentsGroup: 'Documentos',
      excelGroup: 'Excel',
      excelUnavailableReason:
        'O Excel exporta o filtro completo, não uma seleção. Remova a seleção para exportar para o Excel.',
      zipSelectionNotice: 'Serão exportadas {count} respostas selecionadas em um arquivo ZIP',
      filterNotice: 'Serão exportadas {count} respostas',
      zipFilterNotice: 'Serão exportadas {count} respostas em um arquivo ZIP',
      zip: {
        countNotice: '{count} respostas serão baixadas em um ZIP com seus documentos PDF.',
        emptyNotice: 'Não há respostas para baixar com os filtros atuais.',
        generating:
          'Estamos preparando seu arquivo ZIP. Isso pode levar alguns minutos, mantenha esta janela aberta.',
        done: 'Seu ZIP está pronto. O download começará automaticamente. Se não começar, use o link abaixo.',
        doneWithWarnings:
          'Seu ZIP está pronto, mas {count} documentos não puderam ser incluídos. Verifique o arquivo errores.csv dentro do ZIP.',
        error: 'Ocorreu um erro ao gerar o ZIP. Tente novamente.',
        errorConflict:
          'Você já tem uma exportação em andamento. Aguarde ela terminar e tente novamente.',
        errorTimeout: 'A exportação está demorando muito. Tente novamente mais tarde.',
        action: 'Baixar ZIP',
        progressPill: 'Gerando arquivos PDF',
        downloadPart: 'Baixar parte {n}',
      },
    },
    sendToGoogleSheets: {
      success: 'Resposta enviada para Google Sheets com sucesso',
      error: 'Ocorreu um erro ao enviar a resposta para Google Sheets',
      gsheetBusy:
        'O Google Sheets está ocupado no momento. Aguarde alguns minutos e tente novamente.',
      integrationError:
        'Não foi possível enviar para o Google Sheets. Verifique sua integração (permissões, fórmulas e link da planilha).',
      unknownError:
        'Ocorreu um erro desconhecido ao enviar para o Google Sheets. Tente novamente mais tarde.',
      sendModifyConfirmTitle: 'Esta resposta já foi enviada para o Google Sheets',
      sendModifyConfirmMessage:
        'Esta integração não tem a funcionalidade de sincronização de edições ativada. Reenviar manualmente pode criar linhas duplicadas na planilha. Deseja continuar mesmo assim?',
      sendModifyConfirmButton: 'Sim, enviar mesmo assim',
    },
    duplicateAnswer: {
      success: 'Resposta duplicada com sucesso',
      error: 'Erro ao duplicar resposta',
    },
    sendBackupModal: {
      title: 'Enviar respaldo para o e-mail',
      description:
        'Escreva o e-mail onde você deseja receber o arquivo de respaldo deste formulário',
      send: 'Enviar',
      cancel: 'Cancelar',
    },
    deleteAnswer: {
      title: 'Tem certeza de que deseja excluir esta resposta?',
      description:
        'Uma vez excluída, não poderá ser recuperada. Você poderá recuperar a resposta filtrando por formulários excluídos e restaurando-a a partir de sua configuração.',
      confirm: 'Excluir',
      cancel: 'Cancelar',
      success: 'Resposta excluída com sucesso',
      error: 'Erro ao excluir resposta',
    },
    recoverAnswer: {
      success: 'Resposta recuperada com sucesso',
      error: 'Erro ao recuperar resposta',
    },
    statusSelector: {
      newStatus: 'Selecione ou crie um estado',
      newStatusPlaceholder: 'Escreva aqui o novo estado',
      newStatusError: 'O estado já existe',
      delete: 'Excluir',
      color: 'Cor',
      colors: {
        white: 'Branco',
        blue: 'Azul',
        yellow: 'Amarelo',
        red: 'Vermelho',
        green: 'Verde',
        gray: 'Cinza',
      },
      editStatusError: 'Erro ao atualizar estado',
      deleteStatusError: 'Erro ao excluir estado',
      createStatusError: 'Erro ao criar estado',
      deleteConfirmationTitle: 'Tem certeza de que deseja excluir este estado?',
      deleteConfirmationMessage:
        'Uma vez excluído, não poderá ser recuperado. Mas as respostas que o usam não serão afetadas',
    },
    chat: {
      notifyUsersError: 'Erro ao notificar os usuários',
    },
    filtersLinkCopy: {
      tooltip: 'Copiar link com filtros',
      success: 'Link copiado para o clipboard',
      error: 'Não foi possível copiar o link. Verifique as permissões do navegador.',
    },
    answerView: {
      previous: 'Anterior',
      next: 'Próximo',
    },
  },
  assets: {
    title: 'Ativos',
    assetsSearchPlaceholder: 'Buscar por nome ou identificador',
    historySearchPlaceholder: 'Buscar por nome, identificador ou usuário',
    noAssets: 'Nenhum ativo encontrado.',
    noAssetMeters: 'Não há medidores configurados para este ativo',
    noHistory: 'Nenhum histórico encontrado.',
    create: 'Criar',
    update: 'Atualizar',
    createAsset: 'Criar ativo',
    name: 'Nome',
    configuration: 'Configuração',
    addUsers: 'Adicionar usuários',
    showAll: 'Mostrar todos ({count})',
    showLess: 'Mostrar menos',
    usersAssignedSuccess: 'Usuários atribuídos com sucesso',
    usersAssignedError: 'Erro ao atribuir usuários',
    history: 'Histórico',
    code: 'Identificador',
    dateAndTime: 'Data e hora',
    asset: 'Ativo',
    modifiedField: 'Campo modificado',
    modification: 'Modificação',
    modifiedBy: 'Modificado por',
    createNewAsset: 'Criar novo ativo',
    editAsset: 'Editar ativo',
    assetInformation: 'Informações do ativo',
    metersDescription:
      'Associe e gerencie os medidores de cada ativo para registrar leituras com precisão',
    namePlaceholder: 'Nome do ativo',
    codePlaceholder: 'Número de série, placa ou ID único',
    location: 'Local',
    locationPlaceholder: 'Selecione um local',
    restrictAccess: 'Restringir o acesso a este ativo a usuários específicos',
    usersAndGroups: 'Usuários e grupos responsáveis',
    description: 'Descrição',
    descriptionPlaceholder: 'Escreva uma descrição para o ativo',
    meterType: 'Tipo de medidor',
    meterTypePlaceholder: 'Selecione um tipo de medidor',
    meter: 'Medidor',
    lastMeasurement: 'Última medição',
    lastSyncedMeasurement: 'Última medição sincronizada: ',
    lastMeasurements: 'Última(s) Medição(es)',
    listFilters: {
      location: 'Local',
      lastMeasurementDate: 'Data da Última Medição',
      filterByLocation: 'Filtrar por local',
      customField: 'Campo personalizado',
      selectField: 'Selecione um campo',
      selectOption: 'Selecione uma opção',
      option: 'Opção',
      dateRange: 'Intervalo de datas',
      value: 'Valor',
      selectDateRange: 'Selecionar intervalo',
      enterValue: 'Insira um valor',
      clearOption: 'Limpar opção',
      filterByCustomField: 'Filtrar por campo personalizado',
      field: 'Campo',
      noOptions: 'Nenhuma opção disponível',
      search: 'Buscar',
    },
    actions: 'Ações',
    viewDetails: 'Ver detalhes',
    edit: 'Editar',
    delete: 'Excluir',
    edited: 'Editado',
    editedBy: 'Editado por',
    previousValue: 'Valor anterior',
    confirmDeleteTitle: 'Tem certeza de que deseja excluir este ativo?',
    deactivateTitle: 'Desativar ativo',
    deactivateWithPlanningsDescription:
      'Este ativo tem {count} planejamentos ativos que serão pausados automaticamente até que seja reativado. Além disso, deixará de aparecer nas listas de ativos.',
    deactivateDescription: 'Este ativo deixará de aparecer nas listas de ativos.',
    pausedMaintenanceCount: '{count} manutenção pausada',
    pausedMeterTooltipInactivity: 'Medidor pausado por inatividade',
    pausedMeterTooltipDeactivated: 'Manutenção pausada por ativo desativado',
    confirmDeleteDescription:
      'O ativo {assetName} será excluído, mas os dados registrados anteriormente serão preservados.',
    cancel: 'Cancelar',
    assetCreated: 'Ativo criado com sucesso',
    assetRestored: 'Ativo restaurado',
    assetUpdated: 'Ativo atualizado com sucesso',
    assetDeleted: 'Ativo excluído com sucesso',
    assetDeletedError: 'Erro ao excluir ativo',
    activate: 'Ativar',
    deactivate: 'Desativar',
    assetDeactivated: 'Ativo desativado com sucesso',
    assetDeactivatedError: 'Erro ao desativar ativo',
    assetReactivated: 'Ativo reativado com sucesso',
    assetReactivatedError: 'Erro ao reativar ativo',
    confirmDeactivateTitle: 'Tem certeza de que deseja desativar este ativo?',
    confirmDeactivateDescription:
      'O ativo {assetName} será desativado. Ele continuará aparecendo na tabela, mas com acesso limitado.',
    assetUpdatedError: 'Erro ao atualizar ativo',
    noAssetPermissions: 'Você não tem permissões para visualizar ativos',
    assetCreatedError: 'Erro ao criar ativo',
    meterCreated: 'Medidor criado com sucesso',
    meterUpdated: 'Medidor atualizado com sucesso',
    meterDeleted: 'Medidor excluído com sucesso',
    meterDeactivated: 'Medidor desativado com sucesso',
    meterDuplicated: 'Medidor duplicado com sucesso',
    assetLimitReachedError:
      'Limite de ativos atingido. Você não pode criar mais ativos com seu plano atual.',
    assetCodeAlreadyExists: 'O código do ativo já existe',
    assetInfo: 'Informações do ativo',
    export: 'Exportar',
    import: 'Importar',
    editTableColumns: 'Personalizar colunas',
    selectedCount: '{count} selecionados',
    changeTypeButton: 'Alterar tipo de ativo',
    changeTypeTitle: 'Alterar tipo de ativo',
    changeTypeInfo: 'Irá substituir o tipo atual dos ativos selecionados',
    changeTypeApply: 'Adicionar',
    changeTypeSearchPlaceholder: 'Buscar um tipo de ativo',
    confirmChangeTypeTitle: 'Tem certeza de que deseja alterar o tipo dos ativos selecionados?',
    confirmChangeTypeMessage:
      'Os campos personalizados nos ativos selecionados não ficarão visíveis, mas as informações continuarão registradas.',
    usersAndGroupsTooltip:
      'Estes usuários e grupos são os responsáveis por este ativo. Se você também marcar "Restringir o acesso", eles serão os únicos que poderão vê-lo e gerenciá-lo.',
    v1MetersDescription: 'Atualmente, apenas suportamos medidores de tipo horómetro.',
    addUsersDescription:
      'Os usuários selecionados ficam como responsáveis por este ativo. O acesso para vê-lo e gerenciá-lo depende de suas permissões e de você ativar "Restringir o acesso".',
    addUsersExpirationNotice:
      'Estes usuários receberão os avisos de vencimento dos documentos deste ativo.',
    findOutMore: 'Saiba mais',
    findOutMoreLink: '',
    betaBannerTitle: 'Ativos estão em beta',
    betaBannerDescription:
      'Estamos trabalhando na versão completa, que incluirá propriedades, medidores e locais. Em breve disponível em planos pagos.',
    moreInfo: 'Mais informações',
    viewMeasurements: 'Ver medições',
    noMeasurements: 'Nenhuma medição',
    noData: 'Nenhum dado',
    initialMeasurementPlaceholder: 'Digite o valor inicial',
    initialMeasurementsTitle: 'Leituras iniciais de medidores',
    initialMeasurementsDescription: 'Defina o valor inicial de cada medidor para este ativo',
    initialMeasurementTooltip:
      'Este é o valor inicial definido ao criar o ativo. Para atualizá-lo, registre uma nova medição.',
    summaryTitle: 'Resumo',
    noAssetTypeSelected: 'Ainda não selecionado',
    noMeters: 'Nenhum medidor',
    fieldRequired: 'Este campo é obrigatório',
    inactive: 'Inativo',
    inactiveMeterTooltip:
      'Este medidor está inativo para o tipo de ativo atual. Você pode ver as leituras anteriores. Para ativá-lo, adicione-o ao tipo de ativo ou altere o tipo de ativo.',
    automatic: 'Automático',
    automaticMeterTooltip: 'Este medidor recebe suas medições automaticamente de um sensor.',
    blockedAssetTooltip:
      'Este ativo está bloqueado por limite de plano. Atualize seu plano para acessar o detalhe.',
    blockedAssetHistoryTooltip:
      'Este ativo está limitado por seu plano atual. Atualize seu plano para ver os detalhes do histórico.',
    assetStatus: 'Estado do ativo',
    changeTypes: {
      asset_created: 'Ativo criado',
      asset_deleted: 'Ativo excluído',
      asset_deactivated: 'Ativo desativado',
      asset_reactivated: 'Ativo reativado',
      asset_revived: 'Ativo restaurado',
      asset_updated_by_import: 'Ativo atualizado por importação',
      added_user: 'Usuário(s) adicionado(s)',
      removed_user: 'Usuário(s) removido(s)',
      added_group: 'Grupo(s) adicionado(s)',
      removed_group: 'Grupo(s) removido(s)',
      added_meter: 'Medidor(es) adicionado(s)',
      removed_meter: 'Medidor(es) removido(s)',
      name: 'Nome alterado',
      code: 'Código alterado',
      description: 'Descrição alterada',
      asset_type: 'Tipo de ativo alterado',
      nestable_location: 'Local alterado',
    },
    importDrawer: {
      title: 'Importar Ativos',
      step1Title: 'Passo 1: Baixar arquivo',
      step1Description:
        'Baixe o exemplo do Excel. Cada planilha corresponde a um tipo de ativo. Certifique-se de preencher os campos marcados com * para importar seu arquivo corretamente.',
      step1DescriptionPart1:
        'Baixe o exemplo do Excel. Cada planilha corresponde a um tipo de ativo. Certifique-se de preencher os campos marcados com',
      step1DescriptionPart2: 'para importar seu arquivo corretamente.',
      downloadExample: 'Baixar exemplo',
      step2Title: 'Passo 2: Editar o arquivo',
      step3Title: 'Passo 3: Carregar seu arquivo',
      step3Description: 'Arraste e solte seu arquivo aqui ou selecione-o do seu computador.',
      dragDropText: 'Arraste e solte seu Excel aqui',
      browseText: 'ou procure em seu computador',
      replaceText: 'Substituir',
      fileUploadedText: 'Seu arquivo foi carregado',
      invalidFileType: 'Por favor, selecione um arquivo Excel válido (.xlsx)',
      importSuccess: 'Ativos importados com sucesso',
      importError: 'Erro ao importar ativos',
      importButton: 'Importar',
      cancel: 'Cancelar',
      importing: 'Importando...',
      importingDescription: 'Apenas um momento, estamos organizando tudo...',
      errorTitle: 'Detectamos um erro.',
      errorMessage: 'Por favor, verifique se seus dados têm o formato correto.',
      sheetsWithErrorsMessage: 'O arquivo contém erros nas planilhas: ',
      sheetsWithErrorsRecommendation:
        'Revise as planilhas indicadas e corrija os dados para continuar.',
      andMore: 'e {remainingCount} mais',
      nameErrorMessage: '{errorCount} linhas foram enviadas sem nome de ativo.',
      templateDownloadError: 'Erro ao baixar o arquivo de exemplo',
      downloadingTemplate: 'Baixando...',
      showMore: 'Mostrar mais {count}',
      showLess: 'Mostrar menos',
      errorsListTitle: 'Erros encontrados',
      rowLabel: 'Linha',
      formatLabel: 'Formato',
      summary: {
        created: '{count} ativo(s) criado(s)',
        restored: '{count} ativo(s) restaurado(s)',
        updated: '{count} ativo(s) atualizado(s)',
      },
    },
    googleSheets: {
      button: 'Google Sheets',
      modalTitle: 'Integrar Ativos',
      infoMessage: 'Para uma integração segura, compartilhe seu documento com permissões de',
      editorPermission: 'editor',
      infoMessageTo: 'para',
      linkLabel: 'Novo link',
      linkPlaceholder: 'Insira o link do documento a integrar',
      goToSheets: 'Ir para Google Sheets',
      copied: 'Link copiado',
      copyError: 'Não foi possível copiar o link. Tente copiar manualmente.',
      deleted: 'Integração com Google Sheets removida com sucesso',
      deleteError: 'Erro ao remover integração com Google Sheets',
      deleteConfirmTitle: 'Remover integração com Google Sheets?',
      deleteConfirmMessage:
        'A planilha deixará de receber atualizações de ativos do DataScope. O documento no Google Drive não é excluído.',
      deleteConfirmAction: 'Remover',
      cancel: 'Cancelar',
      save: 'Salvar',
      success: 'Integração com Google Sheets criada com sucesso',
      error: 'Erro ao criar integração com Google Sheets',
    },
    exportSuccess: 'Ativos exportados com sucesso',
    exportError: 'Erro ao exportar ativos',
    exporting: 'Exportando...',
    exportModal: {
      title: 'Exportar ativos',
      assetTypesLabel: 'Selecione os tipos de ativo a exportar',
      assetTypesPlaceholder: 'Selecione os tipos de ativo',
      selectAll: 'Selecionar todos os tipos de ativo',
      confirm: 'Exportar',
      cancel: 'Cancelar',
      infoBanner: 'A exportação incluirá apenas os tipos de ativos que tiverem ativos associados.',
    },
    origin: 'Origem',
    meters: {
      title: 'Medidores',
      subtitle: 'Gerencie os medidores disponíveis para seus ativos',
      create: 'Criar',
      createMeter: 'Criar medidor',
      automaticHintTitle: 'Este medidor pode ser alimentado por um sensor',
      automaticHintBody:
        'Depois de criado e adicionado a um ativo, coloque-o em modo automático pelo ativo e escolha qual campo do sensor o alimenta.',
      automaticHintDisabled:
        'O módulo de sensores não está habilitado nesta conta, então os medidores só são preenchidos à mão. Fale conosco se quiser mais informações.',
      editMeter: 'Editar medidor',
      deactivateMeter: 'Desativar medidor',
      backToAssets: 'Voltar para Ativos',
      cancel: 'Cancelar',
      update: 'Atualizar',
      metersSearchPlaceholder: 'Buscar por nome de medidor',
      noResults: 'Nenhum resultado encontrado',
      feedDialogTitle: 'Alimentar {meter} com um sensor',
      feedSensorLabel: 'Sensor',
      feedAttributeLabel: 'Atributo que alimenta o medidor',
      feedAlreadyAutomatic: 'Este medidor já está em modo automático. Remova-o para escolher outro sensor.',
      feedNoSensorsLinked: 'Este ativo ainda não tem sensores vinculados.',
      feedAdminOnly: 'Somente administradores podem colocar um medidor em modo automático.',
      feedNoSensorsTitle: 'Este ativo ainda não tem sensores vinculados',
      feedNoSensorsBody:
        'Um medidor só pode ser alimentado por um sensor vinculado a este ativo. Vincule um na aba Sensores e volte aqui.',
      feedNoSensorsAction: 'Ir para Sensores',
      feedNoAttributesTitle: 'Este sensor ainda não enviou dados',
      feedNoAttributesBody:
        'Não há campos para escolher até chegar a primeira mensagem. Veja a tela de Entradas para saber o que ele está enviando.',
      feedNoAttributes: 'Este sensor ainda não enviou dados.',
      feedCancel: 'Cancelar',
      feedSubmit: 'Ativar modo automático',
      feedRemove: 'Desativar modo automático',
      feedConfigureSuccess: 'Medidor em modo automático.',
      feedConfigureError: 'Não foi possível ativar o modo automático, tente novamente.',
      feedRemoveSuccess: 'Modo automático desativado.',
      feedRemoveError: 'Não foi possível desativar o modo automático, tente novamente.',
      table: {
        name: 'Nome',
        unit: 'Unidade de medida',
        usage: 'Uso',
        actions: 'Ações',
        usedInAssetTypes: 'Usado em {count} tipo(s)',
        notUsed: 'Não usado',
        edit: 'Editar',
        duplicate: 'Duplicar',
        deactivate: 'Desativar',
        activate: 'Ativar',
      },
      pagination: {
        results: 'Resultados: {start}-{end} de {total}',
      },
      noMeters: 'Nenhum medidor encontrado',
      confirmDeactivateDescription:
        'O medidor {meterName} será desativado. Al desativar este medidor deixará de estar disponível para novos ativos. Se desejar, poderá reativá-lo posteriormente.',
      meterInUseError:
        'Não é possível desativar o medidor pois está em uso em tipos de ativos. Remova-o dos tipos de ativos primeiro.',
      deactivationDisabled:
        'Este medidor não pode ser desativado pois está em uso por um ou mais tipos de ativo. Remova-o dos tipos de ativos primeiro.',
      units: {
        hour: 'Hora',
        minute: 'Minuto',
        seconds: 'Segundo',
        day: 'Dia',
        mile: 'Milha',
        kilometer: 'Quilômetro',
        meter: 'Metro',
        foot: 'Pé',
        yard: 'Jarda',
        inch: 'Polegada',
        centimeter: 'Centímetro',
        millimeter: 'Milímetro',
        nautical_mile: 'Milha Náutica',
        celsius: 'Celsius',
        fahrenheit: 'Fahrenheit',
        kelvin: 'Kelvin',
        volt: 'Volt',
        megavolt: 'Megavolt',
        megavolts: 'Megavolt',
        kilovolt: 'Quilovolt',
        kilovolts: 'Quilovolt',
        millivolt: 'Milivolt',
        millivolts: 'Milivolt',
        microvolt: 'Microvolt',
        microvolts: 'Microvolt',
        bar: 'Bar',
        pascal: 'Pascal',
        psi: 'PSI',
        kilogram: 'Quilograma',
        ton: 'Tonelada',
        pound: 'Libra',
        kilometer_per_hour: 'Quilômetro por Hora',
        mile_per_hour: 'Milha por Hora',
        meter_per_second: 'Metro por Segundo',
        newton_meter: 'Newton Metro',
        pound_foot: 'Libra Pé',
        liter: 'Litro',
        gallon: 'Galão',
        cubic_meter: 'Metro Cúbico',
        cubic_foot: 'Pé Cúbico',
        rpm: 'RPM',
        hertz: 'Hertz',
        watt: 'Watt',
        kilowatt: 'Quilowatt',
        ampere: 'Ampere',
        square_meter: 'Metro Quadrado',
        square_foot: 'Pé Quadrado',
        hectare: 'Hectare',
        farad: 'Farad',
        ohm: 'Ohm',
        siemens: 'Siemens',
        lux: 'Lux',
        radian_per_second: 'Radiano por Segundo',
        coulomb: 'Coulomb',
        unit: 'Unidade',
      },
      assetTypeModal: {
        title: 'Tipos de ativo associados a ',
        description: 'Este medidor está associado aos seguintes tipos de ativo:',
        close: 'Fechar',
      },
    },
    value: 'Valor',
    assetsCreated: 'ativos criados',
    duplicatesSkipped: 'duplicados omitidos',
    errorsCount: 'errores',
    readings: 'Leituras',
    meterHistory: {
      containsEditedReading: 'Contém uma leitura editada',
      containsEditedReadings: 'Contém {count} leituras editadas',
      clickGoesToEdited: 'O clique leva à do {reading}',
      dayDetail: 'Detalhe do dia',
      // Plural and lowercase, for inline use after a value and as the chart's
      // axis label. assets.meters.units holds the SINGULAR Title Case names the
      // meters table and drawer need, which would read as "2179 Hora" here.
      unitNames: {
        hour: 'horas',
        minute: 'minutos',
        day: 'dias',
        mile: 'milhas',
        kilometer: 'quilômetros',
        meter: 'metros',
        foot: 'pés',
        yard: 'jardas',
        nautical_mile: 'milhas náuticas',
        celsius: 'graus Celsius',
        fahrenheit: 'graus Fahrenheit',
        kelvin: 'kelvin',
        volt: 'volts',
        megavolt: 'megavolts',
        megavolts: 'megavolts',
        kilovolt: 'quilovolts',
        kilovolts: 'quilovolts',
        millivolt: 'milivolts',
        millivolts: 'milivolts',
        microvolt: 'microvolts',
        microvolts: 'microvolts',
        bar: 'bar',
        pascal: 'pascals',
        psi: 'psi',
        kilogram: 'quilogramas',
        ton: 'toneladas',
        pound: 'libras',
        kilometer_per_hour: 'quilômetros por hora',
        mile_per_hour: 'milhas por hora',
        meter_per_second: 'metros por segundo',
        newton_meter: 'newton metro',
        pound_foot: 'libras pé',
        liter: 'litros',
        gallon: 'galões',
        cubic_meter: 'metros cúbicos',
        cubic_foot: 'pés cúbicos',
        rpm: 'rpm',
        hertz: 'hertz',
        watt: 'watts',
        kilowatt: 'quilowatts',
        ampere: 'amperes',
        square_meter: 'metros quadrados',
        square_foot: 'pés quadrados',
        hectare: 'hectares',
        farad: 'farads',
        ohm: 'ohms',
        siemens: 'siemens',
        lux: 'lux',
        radian_per_second: 'radianos por segundo',
        coulomb: 'coulombs',
        unit: 'unidades',
      },
      readingsHistoryTitle: 'Histórico de leituras',
      chartTitle: 'Visualização de leituras',
      viewLabel: 'Visualização',
      emptyNoHistoryTitle: 'Ainda não há leituras registradas',
      emptyNoHistoryBody:
        'Registre uma medição a partir de um formulário ou manualmente para visualizar as leituras do medidor.',
      emptyNoResultsTitle: 'Não há leituras no período selecionado',
      emptyNoResultsBody: 'Ajuste ou remova o filtro de data para visualizar outras leituras.',
      errorTitle: 'Não foi possível carregar o histórico',
      retry: 'Tentar novamente',
      accumulatedView: 'Acumulado',
      usageView: 'Uso',
      groupedByDay: 'Agrupado por dia',
      groupedByWeek: 'Agrupado por semana',
      groupedByMonth: 'Agrupado por mês',
      readingsCountOne: '1 leitura',
      readingsCountOther: '{count} leituras',
      noReadingInBucket: 'Sem leitura neste período',
      nearestReading: 'Leitura mais próxima',
      editedReading: 'Leitura editada',
      usageNeedsPreviousReading: 'É necessária pelo menos uma leitura anterior para calcular o uso.',
      dateFilterTitle: 'Data',
      dateFilterPopoverTitle: 'Filtrar por data',
    },
    configure: 'Configurar',
    initialMeasurement: 'Medição inicial',
    measurementUpdated: 'Editado com sucesso',
    measurementUpdatedError: 'Erro ao editar',
    measurementDeleted: 'Excluído com sucesso',
    measurementDeletedError: 'Erro ao excluir',
    confirmDeleteMeasurementTitle: 'Tem certeza de que deseja excluir esta medição?',
    confirmDeleteMeasurementDescription:
      'Esta ação é permanente e a medição não aparecerá mais na tabela.',
    mustEnterNumber: 'Você deve inserir um número',
    action: 'Ação realizada',
    newValue: 'Novo valor',
    measurements: 'Medições',
    historyTitle: 'Histórico de modificações',
    deleted: 'Excluído',
    measurementsHistoryEmptyState: 'As medições deste medidor ainda não foram modificadas',
    formCustomFieldsLabel: 'Detalhes do ativo',
    imageDragDropText: 'Arraste e solte uma imagem aqui',
    filesDragDropText: 'Arraste e solente arquivos aqui',
    uploadFileError: 'Erro ao subir o arquivo',
    uploadErrorDismiss: 'Erro ao subir. Descarte e adicione o arquivo novamente.',
    removeFileLabel: 'Remover arquivo',
    discardFileLabel: 'Descartar arquivo',
    maxWeightError: 'Você atingiu o limite de 100 MB por ativo. Ajuste a seleção.',
    maxFilesReached: 'Você atingiu o número máximo de arquivos para este campo.',
    savingDisabledUploadsTooltip: 'Aguarde os arquivos terminarem de subir antes de salvar.',
    cancelWithUploadsConfirm: 'Há arquivos sendo enviados. Tem certeza de que deseja sair?',
    filesQuotaUsed: '{used} de {total} MB usados',
    filesQuotaUnknownWarning:
      'Alguns arquivos não puderam ser medidos; o total real pode ser maior.',
    filesQuotaExceededError: 'Os arquivos excedem o limite de 100 MB por ativo.',
    filesItemFallbackName: 'Arquivo {number}',
    documents: {
      addExpirationDate: 'Adicionar data de vencimento',
      singleFileNotice: 'Ao ativar o vencimento, o campo aceita um único arquivo.',
      remindersTitle: 'Avisar antes do vencimento',
      reminderDays: '{days} dias',
      reminderOnDueDate: 'No dia do vencimento',
      noRemindersSelected: 'Sem antecedências selecionadas, nenhum e-mail será enviado.',
      expirationDateLabel: 'Data de vencimento',
      replaceLabel: 'Substituir',
      replaceDocumentLabel: 'Substituir documento',
      editDocumentLabel: 'Editar documento',
      removeLabel: 'Excluir',
      clearDateLabel: 'Limpar data',
      openCalendarLabel: 'Abrir calendário',
      documentRequired: 'Você deve anexar um documento.',
      singleFileDropzone: 'Este campo aceita um único arquivo porque tem data de vencimento.',
      dateBlockedByMultipleFiles:
        'Este campo tem mais de um arquivo. Deixe apenas um para poder definir sua data de vencimento.',
      noRecipientsFieldNotice:
        'Ninguém receberá os avisos deste vencimento: o ativo não tem ninguém atribuído.',
      expiresOn: 'Vence:',
      expiredOn: 'Venceu:',
      withoutExpirationDate: 'Data de vencimento não configurada',
      status: {
        valid: 'Vigente',
        expiring: 'A vencer',
        expired: 'Vencido',
        noDate: 'Sem data',
      },
      countOne: '{count} documento',
      countMany: '{count} documentos',
      banner: {
        attentionOne: 'Este ativo tem {documents} que requer atenção.',
        attentionMany: 'Este ativo tem {documents} que requerem atenção.',
        attentionAction: 'Gerenciar documentos',
        expiringOne: 'Este ativo tem {documents} próximo do vencimento.',
        expiringMany: 'Este ativo tem {documents} próximos do vencimento.',
        expiringAction: 'Revisar documentos',
        noDate: 'Este ativo tem {documents} sem sua data de vencimento.',
        noDateAction: 'Preencher datas',
      },
      noRecipientsWarning:
        'Ninguém receberá os avisos de vencimento dos documentos deste ativo até que você atribua um usuário ou um grupo.',
      noRecipientsAction: 'Atribuir responsável',
      listTooltip: {
        attentionOne: '{documents} requer atenção:',
        attentionMany: '{documents} requerem atenção:',
        expiringOne: '{documents} próximo do vencimento:',
        expiringMany: '{documents} próximos do vencimento:',
        noDateOne: '{documents} requer data de vencimento:',
        noDateMany: '{documents} requerem data de vencimento:',
      },
    },
    assetLimitReachedTitle: 'Limite de ativos atingido',
    assetLimitReachedDescription:
      'Você atingiu o limite de ativos do seu plano. Para adicionar ou gerenciar mais ativos, atualize seu plano e obtenha acesso a mais recursos:',
    assetLimitFeature1: 'Maior quantidade de ativos disponíveis',
    assetLimitFeature2: 'Histórico completo de ativos',
    assetLimitFeature3: 'Informações completas dos ativos',
    assetLimitUpgradeButton: 'Desbloquear mais ativos agora',
    assetLimitContinueButton: 'Continuar com meu plano atual',
    limitedFeaturesAlert:
      'Algumas funcionalidades não estão disponíveis em seu plano atual. Atualize seu plano para ver todos os ativos e suas medições.',
    changePlan: 'Alterar plano',
    landing: {
      headerTitle: 'Comece a gerenciar seus ativos em um só lugar',
      headerSubtitle: 'Para que servem os ativos?',
      headerBullet1Bold: 'Personalize os campos por tipo de ativo: ',
      headerBullet1: 'defina quais dados você precisa e crie campos para cada tipo de ativo.',
      headerBullet2Bold: 'Vincule facilmente vários medidores: ',
      headerBullet2:
        'atribua um ou mais medidores a cada tipo de ativo conforme suas necessidades.',
      headerBullet3Bold: 'Gestão centralizada dos seus recursos: ',
      headerBullet3:
        'crie e organize seus ativos em uma única plataforma, visualizando informações-chave como status, localização e leituras de medidores.',
      headerButton: 'Usar ativos',
      carouselTitle: 'Crie seu primeiro ativo',
      carouselStep1Title: 'Crie tipo de ativo',
      carouselStep1Description:
        'Crie um tipo de ativo e defina uma categoria para seus ativos, como Equipamento ou Veículos. Depois, você poderá ',
      carouselStep1DescriptionBold: 'personalizar os campos que cada ativo deve ter.',
      carouselStep2Title: 'Selecione medidores',
      carouselStep2Description:
        'Escolha os medidores que deseja usar para este tipo de ativo, como ',
      carouselStep2DescriptionBold:
        'horímetro, quilometragem, temperatura ou crie novos se precisar.',
      carouselStep3Title: 'Crie seu primeiro ativo',
      carouselStep3Description: 'Depois de configurar o tipo de ativo, pressione ',
      carouselStep3DescriptionBold: 'Criar ativo',
      carouselStep3DescriptionEnd: ' e preencha as informações correspondentes.',
      carouselStep4Title: 'Não encontrou o medidor que precisa?',
      carouselStep4Description:
        'Se o medidor que você precisa não está disponível, você pode criá-lo na aba ',
      carouselStep4DescriptionBold: 'Medidores.',
      carouselNext: 'Próximo',
      carouselPrevious: 'Anterior',
      footerTitle: 'Organize, meça e gerencie',
      footerDescription:
        'Agora que você sabe como os ativos funcionam, crie um tipo de ativo, personalize suas informações e comece a vinculá-los aos seus formulários e leituras.',
      footerButton: 'Criar tipo de ativo',
    },
    assetTypes: {
      title: 'Tipos de ativos',
      noAssetType: 'Nenhum tipo de ativo selecionado',
      noAssetTypes: 'Nenhum tipo de ativo encontrado',
      create: 'Criar',
      createAssetType: 'Criar tipo de ativo',
      createAssetTypeSuccess: 'Tipo de ativo criado com sucesso',
      createAssetTypeError: 'Erro ao criar o tipo de ativo',
      createAssetTypeErrorDuplicateName: 'O nome do tipo de ativo já existe',
      type: 'Tipo de ativo',
      description: 'Descrição',
      createdAssets: 'Ativos criados',
      actions: 'Ações',
      confirmDeleteTitle: 'Tem certeza de que deseja excluir este tipo de ativo?',
      confirmDeleteDescription:
        'O tipo de ativo {assetTypeName} será excluído. Esta ação não pode ser desfeita.',
      assetTypeDeleted: 'Tipo de ativo excluído com sucesso',
      assetTypeDeletedError: 'Erro ao excluir o tipo de ativo',
      searchPlaceholder: 'Buscar tipo de ativo',
      viewAssets: 'Ver ativos',
      assetTypeDeleteSuccess: 'Tipo de ativo excluído com sucesso',
      assetTypeDeleteError: 'Erro ao excluir o tipo de ativo',
      assetTypeUpdateSuccess: 'Tipo de ativo atualizado com sucesso',
      assetTypeUpdateError: 'Erro ao atualizar o tipo de ativo',
      formTitleEdit: 'Editar tipo de ativo',
      formSubtitleCreate: 'Informe os dados para cada atributo do tipo de ativo.',
      formSubtitleEdit: 'Atualize os atributos do tipo de ativo e salve as alterações.',
      formNameLabel: 'Nome',
      formDescriptionLabel: 'Descrição',
      formCustomIdLabel: 'Nome de ID personalizado',
      formIconLabel: 'Ícone',
      formLoadError: 'Não foi possível carregar este tipo de ativo.',
      formBackToList: 'Voltar para tipos de ativo',
      formReset: 'Redefinir',
      formSave: 'Salvar',
      formCancel: 'Cancelar',
      formMeterSelectLabel: 'Selecione um medidor',
      formCustomIdTooltip:
        'Para uma melhor experiência, seus ativos devem ter um identificador único. Chame-o como quiser: ID, Placa, Serial, etc',
      iconSelectorColors: 'Cores',
      iconSelectorIcons: 'Ícones',
      addMeterTitle: 'Adicionar medidor',
      addMeterDescription:
        'Adicione medidores de acordo com o uso do seu ativo. Você poderá editá-los quando precisar',
      addMeterPlaceholder: 'Selecione um medidor para seu tipo de ativo',
      addFieldsTitle: 'Adicionar campos personalizados',
      addFieldsDescription: 'Defina os campos que aparecerão no formulário de criação de ativos',
      addFieldButton: 'Adicionar campo',
      requiredField: 'Campo obrigatório',
      dragFieldLabel: 'Arrastar campo {name}',
      backToAssets: 'Voltar para ativos',
      fieldNameAlreadyExists: 'O nome do campo personalizado já existe',
      reachedAssetTypeFieldsLimit: 'Você atingiu o limite máximo de campos para um tipo de ativo',
      selectType: 'Selecione um tipo de ativo',
      search: 'Procurar tipos de ativos...',
      fieldTypes: {
        text: 'Texto',
        number: 'Número',
        date: 'Data',
        image: 'Imagem',
        files: 'Arquivos',
      },
      fileTypeSelector: {
        label: 'Tipo de arquivo',
        allFormats: 'Todos os formatos',
        audio: 'Áudio',
        video: 'Vídeo',
      },
    },
  },
  mainMenu: {
    home: 'Início',
    forms: 'Formulários',
    integrations: 'Integrações',
    taskAssigner: 'Tarefas',
    plannings: 'Planejamentos',
    findings: 'Não conformidades',
    signatures: 'Assinaturas',
    lists: 'Listas',
    locations: 'Locais',
    assets: 'Ativos',
    charts: 'Gráficos',
    map: 'Mapa',
    sensors: 'Sensores',
    training: 'Treinamento',
    settings: {
      main: 'Ajustes e ajuda',
      changelog: 'Alertas',
      account: 'Ajustes conta',
      users: 'Usuários',
      billing: 'Pagamentos',
      invite: 'Convidar',
      helpCenter: 'Centro de ajuda',
      news: 'Novidades',
      upgrade: 'Atualizar',
    },
    new: 'Novo',
    askDataScope: 'Pergunte ao DataScope',
    whatsapp: 'WhatsApp',
    myDashboards: 'Meus Dashboards',
  },
  dashboards: {
    title: 'Meus Dashboards',
    empty: 'Ainda não há dashboards salvos.',
    emptyHint: 'Peça um gráfico no Ask DataScope e salve-o aqui.',
    delete: 'Excluir dashboard',
    refresh: 'Atualizar',
    loading: 'Carregando...',
    loadError: 'Não foi possível carregar os dashboards.',
    addTo: 'Adicionar a Meus Dashboards',
    viewIn: 'Ver em Meus Dashboards',
    saving: 'Salvando...',
    saveError: 'Erro ao salvar',
    noDataToSave: 'Sem dados para salvar',
    updatedAt: 'Atualizado',
    back: 'Voltar',
  },
  whatsappModule: {
    title: 'Módulo WhatsApp',
    subtitle: 'Preencha formulários e receba respostas direto pelo WhatsApp.',
    loadError: 'Não foi possível carregar o estado do módulo. Tente de novo.',
    onboarding: {
      title: 'Experimente o Módulo WhatsApp',
      intro: 'Seus usuários preenchem formulários conversando no WhatsApp: texto, áudio e fotos.',
      trialOffer: 'Comece com um teste grátis de {limit} formulários por {days} dias.',
      startTrial: 'Começar teste grátis',
      phoneTitle: 'Confirme seu número de WhatsApp',
      phoneHint: 'Com código do país. Vamos ativá-lo para você falar com o bot.',
      confirm: 'Confirmar e ativar',
      confirming: 'Ativando...',
      readyTitle: 'Pronto! Mande uma mensagem para o bot',
      readyDetail: 'Escaneie o QR ou abra o WhatsApp com o botão e envie "{greeting}".',
      openWhatsapp: 'Abrir WhatsApp',
      noBotNumber: 'Seu número foi ativado. O número do bot será configurado em breve.',
      done: 'Ir para o painel',
      invalidPhone: 'Esse número não parece válido. Verifique o código do país.',
      enrolledElsewhere: 'Esse número já está ativado em outra conta.',
      genericError: 'Não foi possível ativar o número. Tente de novo.',
    },
    usage: {
      title: 'Uso do período',
      responses: 'Respostas',
      messagesSent: 'Mensagens enviadas',
      messagesReceived: 'Mensagens recebidas',
      quota: 'Cota',
    },
    trial: {
      title: 'Teste grátis',
      usedOfLimit: '{used} de {limit} formulários usados',
      daysRemaining: 'Restam {days} dias de teste.',
      active: 'Vigente',
      exhausted: 'Encerrado',
      exhaustedHint: 'Você usou os formulários do teste. Ative o módulo para continuar.',
      expiredHint: 'O período de teste terminou. Ative o módulo para continuar.',
    },
    price: {
      title: 'Preço',
      activationTitle: 'Ativação',
      pitch: 'Gostou do módulo? Escreva para nós e o ativamos para sua operação.',
      contactCta: 'Fale conosco',
      activate: 'Fale conosco',
      activeBadge: 'Módulo ativo',
      trialBadge: 'Em teste',
      inactiveBadge: 'Inativo',
      contactHint: 'Você está no teste. Quando quiser ativá-lo, fale conosco.',
      trialEndedPitch: 'Seu teste terminou. Fale conosco para ativar o módulo na sua operação.',
      contactMessage: 'Olá, quero ativar o Módulo WhatsApp na minha conta.',
    },
    start: {
      title: 'Comece a usar',
    },
    users: {
      title: 'Usuários',
      enabledSection: 'Ativados',
      readySection: 'Prontos para ativar',
      noPhoneSection: 'Sem número',
      enable: 'Ativar',
      disable: 'Desativar',
      noPhoneHint: 'Adicione um telefone a este usuário para poder ativá-lo.',
      cutoverWarning: 'Ao ativar o primeiro usuário, somente os usuários ativados poderão usar o bot.',
      empty: 'Não há usuários neste grupo.',
    },
    responses: {
      title: 'Respostas pelo WhatsApp',
      form: 'Formulário',
      code: 'Código',
      user: 'Usuário',
      date: 'Data',
      empty: 'Ainda não há respostas pelo WhatsApp.',
    },
  },
  askDataScope: {
    title: 'Pergunte ao DataScope',
    placeholder: 'Pergunte qualquer coisa sobre seus dados...',
    placeholderWithActions: 'Pergunte sobre seus dados, ou peça para criar contas...',
    newChat: 'Nova conversa',
    modules: {
      all: 'Todos',
      forms: 'Formulários',
      tasks: 'Tarefas',
      locations: 'Locais',
      assets: 'Ativos',
      signatures: 'Assinaturas',
      tickets: 'Tickets',
    },
    mentions: {
      categories: {
        forms: 'Formulários',
        users: 'Usuários',
        locations: 'Locais',
        assets: 'Ativos',
        groups: 'Grupos',
      },
      noResults: 'Sem resultados',
      back: 'Voltar',
      loading: 'Buscando...',
      loadError: 'Não foi possível carregar. Tente novamente.',
    },
    chartTypePrompt: {
      question: 'Que tipo de gráfico você quer?',
      types: {
        bar: 'Barras',
        line: 'Linha',
        pie: 'Pizza',
        donut: 'Rosca',
        stat: 'Número',
        heatmap: 'Mapa de calor',
      },
    },
    export: {
      chooseFormat: 'Em qual formato você quer?',
      chooseRecord: 'As assinaturas são baixadas um documento por vez. Há {count}; escolha qual:',
      exportObject: 'Exportar {object}',
      periodPrompt: 'Esta exportação precisa de um intervalo de datas. Escolha o período que quer no arquivo.',
      working: 'Exportando…',
      success: 'Os dados foram exportados com sucesso',
      objects: {
        tasks: 'tarefas',
        form_answers: 'respostas',
        plannings: 'planejamentos',
        assets: 'ativos',
        locations: 'locais',
        lists: 'listas',
        tickets: 'tickets',
        signatures: 'assinaturas',
      },
      download: 'Baixar {module}',
      preparing: 'Preparando o arquivo…',
      stillPreparing: 'O arquivo ainda está sendo gerado. Avisaremos por e-mail quando estiver pronto.',
      expired: 'O link de download expirou. Solicite a exportação novamente.',
      expiredOrFailed: 'O download não está mais disponível.',
      retry: 'Tentar novamente',
      limitWarning:
        'A exportação aceita até {max} dias e você está pedindo {requested}, então o arquivo vai cobrir apenas os últimos {max} dias do intervalo.',
      droppedFilters: 'O arquivo não aplica estes filtros: {fields}.',
      droppedFiltersGeneric: 'O arquivo não aplica todos os filtros da consulta.',
      // Nomes de campo do backend -> etiqueta legível. O aviso os imprimia crus
      // ("form_state_id"). Os campos de pessoa não estão e não devem estar: o
      // backend os remove de toda declaração, então não podem chegar aqui.
      filterFields: {
        form_id: 'formulário',
        form_ids: 'formulário',
        task_form_id: 'formulário',
        form_name: 'nome do formulário',
        form_state_id: 'estado',
        form_state_ids: 'estado',
        status: 'estado',
        acceptance_status: 'estado de aceitação',
        priority: 'prioridade',
        asset_id: 'ativo',
        asset_ids: 'ativo',
        asset_type_id: 'tipo de ativo',
        location_id: 'lugar',
        location_ids: 'lugar',
        location: 'lugar',
        nestable_location_id: 'lugar',
        location_type: 'tipo de lugar',
        place_type_id: 'tipo de lugar',
        planning_type_id: 'tipo de planejamento',
        signer_type: 'tipo de signatário',
        active: 'ativo ou inativo',
        name: 'nome',
        code: 'código',
        city: 'cidade',
        region: 'região',
        country: 'país',
      },
      droppedPeriod: 'O arquivo não aplica o intervalo de datas da consulta.',
      caveats: {
        search_not_ids:
          'A exportação busca por texto, portanto pode incluir registros diferentes dos contados.',
        whole_account_only: 'A exportação inclui toda a conta, sem os filtros da consulta.',
        nestable_only: 'A exportação inclui apenas os locais do módulo atual.',
        pdf_index_not_files:
          'Você vai receber uma planilha com um link para o PDF de cada resposta, não os PDFs juntos.',
      },
      formats: {
        excel: 'Excel',
        excel_by_question: 'Excel por pergunta',
        excel_by_form: 'Excel por formulário',
        excel_by_repeatable: 'Excel por tabela repetível',
        excel_all: 'Excel completo',
        pdf_single: 'PDF',
        pdf_documents: 'PDF dos documentos',
      },
      reasons: {
        export_failed: 'Não conseguimos gerar o arquivo. Tente novamente em alguns minutos.',
        export_not_in_plan: 'Seu plano não inclui exportações.',
        export_module_has_none: 'Este módulo não tem exportação.',
        export_module_unknown: 'Não posso exportar este módulo.',
        export_not_available_yet: 'Ainda não consigo entregar este arquivo pelo chat.',
        export_no_data_yet: 'Primeiro preciso consultar os dados que você quer baixar.',
        export_needs_form_scope:
          'Não consigo exportar todos os formulários ao mesmo tempo. Mencione-os com @ ou me diga quais dados você precisa.',
        export_form_scope_ambiguous:
          'Esse nome corresponde a mais de um formulário. Diga qual ou quais você quer exportar.',
        export_format_unknown: 'Esse formato não está disponível para este módulo.',
        export_needs_single_record:
          'Este formato é de um único registro. Diga qual você quer baixar.',
        export_period_required: 'Preciso de um intervalo de datas para exportar.',
        export_requires_places_admin: 'Você precisa de permissões de administração de locais para exportar.',
        export_already_in_progress: 'Você já tem uma exportação em andamento. Aguarde o término.',
        export_not_permitted: 'Você não tem permissão para exportar este módulo.',
        export_upload_failed: 'O arquivo foi gerado, mas não conseguimos enviá-lo. Tente novamente.',
        empty_export: 'Não há registros para exportar.',
      },
    },
    chartRefine: {
      personalize: 'Personalizar',
      states: { na: 'Não se aplica', fixed: 'Fixo', recomputing: 'Recalculando…' },
      value: { title: 'Valor', count: 'Quantidade', percent: 'Porcentagem' },
      period: { title: 'Período', day: 'Dia', week: 'Semana', month: 'Mês' },
      order: {
        title: 'Ordem',
        none: 'Cronológico',
        desc: 'Maior a menor',
        asc: 'Menor a maior',
      },
      breakdown: {
        title: 'Desmembrar por',
        none: 'Sem desmembramento',
        user: 'Por usuário',
        status: 'Por estado',
        location: 'Por Local',
      },
    },
    chartDetail: {
      record: 'resposta',
      records: 'respostas',
      close: 'Fechar',
      loading: 'Carregando…',
      empty: 'Sem respostas neste ponto.',
      viewIn: 'Ver em {module} →',
      viewCountIn: 'Ver os {count} registros em {module} →',
      goToRecord: 'Ir para a resposta →',
      modules: {
        form_answers: 'Respostas',
        tasks: 'Tarefas',
        tickets: 'Tickets',
        assets: 'Ativos',
        locations: 'Locais',
        signatures: 'Assinaturas',
      },
    },
    // It.3 "Fonte do dado": a linha que declara sobre o que a resposta foi
    // calculada. `dateFormat` é o padrão (date-fns) com que o período é exibido
    // neste idioma.
    sourceLine: {
      prefix: 'Base:',
      separator: '·',
      dateFormat: 'dd/MM/yyyy',
      allTime: 'todo o histórico',
      periodRange: '{start} a {end}',
      periodFrom: 'desde {start}',
      periodTo: 'até {end}',
      viewIn: 'Ver em {module} →',
      viewFilteredIn: 'Ver em {module} com estes filtros →',
      summaryOrigins: '{count} origens',
      summaryTotal: '{count} registros no total',
      expand: 'Ver o detalhe por origem',
      collapse: 'Ocultar o detalhe por origem',
      modules: {
        form_answers: 'Respostas',
        tasks: 'Tarefas',
        tickets: 'Tickets',
        assets: 'Ativos',
        locations: 'Locais',
        lists: 'Listas',
        plannings: 'Planejamentos',
        signatures: 'Assinaturas',
      },
      records: {
        form_answers: { one: 'resposta', other: 'respostas' },
        tasks: { one: 'tarefa', other: 'tarefas' },
        tickets: { one: 'ticket', other: 'tickets' },
        assets: { one: 'ativo', other: 'ativos' },
        locations: { one: 'local', other: 'locais' },
        lists: { one: 'lista', other: 'listas' },
        plannings: { one: 'planejamento', other: 'planejamentos' },
        signatures: { one: 'assinatura', other: 'assinaturas' },
      },
    },
    errors: {
      timeout: 'A solicitação expirou. Tente novamente.',
      rateLimit: 'Limite diário de mensagens atingido.',
      generic: 'Algo deu errado. Tente novamente.',
    },
    typing: 'Pensando...',
    readOnly: 'Só posso ajudá-lo a consultar dados. Não posso fazer alterações.',
    greeting: 'Olá',
    howCanIHelp: 'Como posso te ajudar hoje?',
    suggestions: 'Sugestões',
    recentChats: 'Conversas recentes',
    noRecentChats: 'Sem conversas recentes.',
    conversationKind: {
      action: 'Criação de contas',
      query: 'Consulta',
    },
    moduleLockedNote:
      'O filtro de módulo está fixo para esta conversa. Inicie um novo chat para alterá-lo.',
    dateFilter: {
      from: 'De',
      to: 'Até',
      clear: 'Limpar',
      selectRange: 'Selecionar intervalo de datas',
    },
    prompts: [
      'Resuma as respostas de [nome do formulário]',
      'Crie um gráfico com as respostas de cada mês',
      'Quantas assinaturas ainda estão pendentes?',
      'Mostre-me todas as tarefas concluídas este mês',
      'Dê-me uma visão geral das estatísticas da minha conta',
    ],
    report: {
      buttonInline: 'Reportar este problema',
      title: 'Reportar um problema',
      description: 'Conte-nos o que deu errado ou o que você gostaria de ver.',
      defaultText: 'Gostaria de solicitar uma funcionalidade',
      yourQuestion: 'Sua pergunta:',
      cancel: 'Cancelar',
      send: 'Enviar relatório',
      sending: 'Enviando...',
      successDescription: 'Obrigado pelo seu feedback. Vamos analisá-lo.',
      close: 'Fechar',
    },
    trial: {
      title: 'Período de teste gratuito',
      description:
        'Explore Pergunte ao DataScope sem custo. Faça perguntas sobre seus dados em linguagem natural e obtenha respostas em segundos.',
      expired: 'O período gratuito terminou.',
      feedback:
        'Sua opinião nos ajuda a melhorar. Use o ícone {icon} ao lado de qualquer resposta para nos contar o que mudaria.',
      timeRemaining: 'Tempo restante:',
      days: 'Dias',
      hours: 'Horas',
      minutes: 'Min',
      seconds: 'Seg',
      gotIt: 'Começar a explorar',
      expiredDismiss: 'Entendido',
    },
    supportHandoff: {
      openChat: 'Abrir chat de suporte',
      connectWithPerson: 'Sim, falar com uma pessoa',
      fromLabel: 'Enviado do Pergunte ao DataScope IA',
    },
    feedback: {
      helpful: 'Resposta útil',
      notHelpful: 'Resposta não útil',
    },
    aiDisclaimer: 'Esta função usa IA. Verifique os dados antes de tomar decisões.',
    actions: {
      folders: {
        title: 'Pastas que você pode replicar (nesta conta)',
        forms: 'formulários',
      },
      result: {
        successTitle: 'Pronto, tudo carregado',
        partialTitle: 'Lote concluído em parte',
        successBody: 'Cada formulário ficou associado ao seu formulário mestre de origem.',
        partialBody: 'O que já foi carregado não foi alterado. Você pode tentar novamente o que está pendente.',
        failedTitle: 'Pendentes por erro',
        credentialsTitleOne: 'Informações da conta criada',
        credentialsTitleMany: 'Informações das contas criadas',
        emailLabel: 'E-mail',
        passwordLabel: 'Senha',
        copyAll: 'Copiar todas',
        copied: 'Copiadas',
        emailNote: 'Um e-mail com a senha de uso único foi enviado ao administrador; ela deverá ser alterada no primeiro acesso.',
        retry: 'Tentar novamente o pendente',
      },
      progress: {
        title: 'Carregando na fila',
        of: 'de',
        sequentialNote:
          'Processamento sequencial: uma empresa por vez.',
        status: {
          queued: 'Na fila',
          processing: 'Processando…',
          done: 'Pronto',
          failed: 'Falhou · ainda pendente',
        },
      },
      excel: {
        attach: 'Anexar Excel',
        title: 'Anexar Excel',
        description:
          'Envie sua planilha com as empresas, o e-mail do administrador e as pastas a replicar. A IA lê o arquivo e mostra um resumo antes de executar.',
        dropzone: 'Arraste seu Excel aqui ou clique para procurar',
        formats: 'Arquivos .xlsx ou .xls',
        ready: 'Pronto para interpretar',
        invalidType: 'Formato inválido. Anexe um arquivo .xlsx ou .xls',
        cancel: 'Cancelar',
        use: 'Usar este arquivo',
      },
      summary: {
        title: 'Resumo da solicitação',
        awaitingConfirm: 'Falta a sua confirmação',
        statNew: 'contas novas',
        statExisting: 'já existem',
        statFolders: 'pastas no total',
        statForms: 'formulários',
        colCompany: 'Empresa',
        colAccount: 'Conta',
        colFolders: 'Pastas',
        colForms: 'Formulários',
        badgeExisting: 'Já tem conta',
        badgeNew: 'Nova',
        inferred: 'inferido',
        moreCompanies: 'Ver mais {n} empresas',
        showLess: 'Ver menos',
        existingNote:
          'As empresas que já têm conta não são criadas de novo: apenas suas pastas são replicadas na conta atual.',
        queueNote:
          'A carga é processada em fila, uma por uma. Cada formulário fica associado ao seu formulário mestre de origem.',
        adjust: 'Ajustar',
        confirm: 'Confirmar e executar',
        confirmed: 'Confirmado',
        adjustNote: 'Solicitação em ajuste. Escreva as alterações no chat.',
        errorNote: 'Não foi possível processar a ação. Recarregue a conversa e tente novamente.',
        excludedTitle: 'Estas contas não foram incluídas',
        excludedItem: '{company}: não será criada porque não existem na sua conta: {items}',
      },
      manage: {
        title: 'Criar e gerenciar contas',
        createAccounts: 'Criar contas para várias empresas',
        replicableFolders: 'Quais pastas posso replicar?',
        exampleFolder: 'Inspeções de campo',
        createExample:
          'Habilitem estas empresas com {folder}: Constructora del Valle (constructoradelvalle@example.cl), Minera San Rafael (minerasanrafael@example.cl), Transportes Andes (transportesandes@example.cl).',
      },
    },
  },
  mainTopBar: {
    accountSwitcher: {
      switchingTitle: 'Trocando para {{account}}...',
      switchingSubtitle: 'Estamos redirecionando você, isso pode levar alguns segundos',
      title: 'Trocar de conta',
      error: 'Não foi possível trocar de conta. Você continua na conta atual.',
      unnamedAccount: 'Conta {{id}}',
      currentAccount: 'Conta atual',
      searchPlaceholder: 'Buscar por nome',
      searchAction: 'Buscar',
      seeAllAccounts: 'Ver todas as contas ({{count}})',
      noResults: 'Não encontramos contas com esse nome.',
      back: 'Voltar',
      close: 'Fechar',
    },
    createIssue: 'Criar não conformidade',
    featureRequest: 'Envie sua ideia!',
    featureRequestText: 'Você precisa de uma ferramenta que ainda não temos?',
    logout: 'Sair',
    languageOptions: {
      es: 'Espanhol',
      en: 'Inglês',
      pt: 'Português',
    },
    newNotifications: 'Nova mensagem em {formName}',
    companySettings: 'Configurações da empresa',
    myAccount: 'Minha conta',
  },
  notFound: {
    title: '404',
    description:
      'Desculpe, mas a página que você está procurando não foi encontrada. Tente verificar a URL para um erro, depois clique no botão de atualização em seu navegador ou tente encontrar algo mais em nossa aplicação.',
    button: 'Ir para o início',
  },
  actionsOverview: {
    title: 'Ações mensais disponíveis',
    explanation: 'O que são ações?',
    actionsUsed: 'Ações usadas',
    exceedActionsInfo:
      'Se você exceder o número de ações incluídas em seu plano, um adicional será aplicado para cada uma.',
    moreInfo: 'Mais informações',
    error: 'Erro ao carregar informações de ações',
    explanationLink:
      'https://help.mydatascope.com/pt-BR/articles/11321884-planos-da-datascope-como-funcionam-e-o-que-incluem#h_89f8fc358a',
    moreInfoLink:
      'https://help.mydatascope.com/pt-BR/articles/11321884-planos-da-datascope-como-funcionam-e-o-que-incluem#h_384fe4efa1',
  },
  billing: {
    externalIframe: {
      tokenAuthorizeError: 'Não conseguimos autorizar sua sessão. Atualize a página.',
    },
  },
  maps: {
    title: 'Encontre suas respostas no mapa',
    emptyState: {
      title: 'Mapa de respostas facilmente',
      subtitle: 'Para que usar a função de mapas?',
      description: 'Com esta funcionalidade é possível:',
      feature1:
        'Visualizar em tempo real onde são completados formulários, são executadas tarefas ou são reportados não conformidades.',
      feature2:
        'Detectar áreas com baixa ou alta cobertura para tomar decisões operativas estratégicas.',
      feature3: 'Obter trazabilidade e controle geográfico das operações diárias.',
      demo: {
        title: 'Visualiza a localização de suas respostas',
        mobile: {
          title: 'Responde desde terreno com a app',
          description:
            'Responde desde a app com localização GPS ativada e valida que as respostas foram enviadas do local designado.',
          description2:
            'Importante! Certifique-se que seu time registre respostas usando a app com a localização habilitada.',
        },
        web: {
          title: 'Visualiza suas respostas no mapa',
          description:
            'Uma vez responda seus formulários desde a App poderá visualizar suas respostas em um mapa interativo.',
        },
      },
    },
  },
  lists: {
    banner: {
      message:
        'Novos Locais já estão disponíveis! Agora você pode organizar, atribuir usuários e visualizar a atividade em um só lugar.',
      action: 'Experimente agora',
    },
  },
  mfa: {
    title: 'Habilitar 2FA',
    next: 'Próximo',
    finish: 'Finalizar',
    close: 'Fechar',
    scanQr: 'Escanear código QR',
    scanQrDescription: 'Escaneie o código QR com sua app de autenticação preferida',
    manualEntry: 'Ou digite o código manualmente',
    verifying: 'Verificando...',
    verifyCode: 'Digite o código de autenticação',
    verifyCodeDescription: 'Escreva o código de 6 dígitos que aparece em sua app de autenticação',
    verifyCodeInvalid: 'Código inválido. Tente novamente.',
    verifyCodeError: 'Erro ao verificar o código',
    verifyCodeCognitoError:
      'Ocorreu um erro interno. Por favor, contate-nos pelo chat para resolver.',
    successTitle: 'Autenticação configurada com sucesso',
    successDescription:
      'A partir de agora, cada vez que você fizer login, será solicitado um código temporário da sua app de autenticação para maior segurança',
    successDescriptionMobile:
      'Para continuar, por favor feche a app de DataScope e abra-a novamente.',
    maybeLater: 'Talvez depois',
    activateNow: 'Ativar agora',
    protectAccount: 'Proteja sua conta com uma camada extra de segurança',
    protectAccountDescription:
      'Com a autenticação em dois passos, você precisará de um código temporário da sua app autenticadora para fazer login. Você poderá gerenciar esta configuração mais tarde em seu perfil de usuário.',
    organizationRequires: 'Sua organização requer ativar a autenticação em dois passos (2FA)',
    organizationRequiresDescription:
      'Use uma app autenticadora para gerar o código temporário que será solicitado ao fazer login',
    userSettings: {
      title: 'Segurança da conta (2FA)',
      descriptionActive:
        'Adicione uma camada extra de segurança à sua conta.\n Quando você ativar a autenticação em dois passos (2FA), será solicitado um código da sua app autenticadora ao fazer login.',
      descriptionDisable:
        'Você tem autenticação em dois passos ativada. Para fazer login, você precisa de um código temporário da sua app de autenticação.\n Você pode desativá-la, mas sua conta será menos segura.',
      activate: 'Habilitar 2FA',
      disableConfig: 'Desativar 2FA',
      disableDialogTitle: 'Tem certeza de que deseja desativar a autenticação em dois passos?',
      disableDialogDescription:
        'Se você desativá-la, sua conta será menos segura. Você pode ativá-la novamente quando quiser.',
      disableDialogConfirm: 'Desativar',
      disableDialogCancel: 'Cancelar',
      justSameUserCanActivate: 'Só o mesmo usuário pode ativar a autenticação em dois passos (2FA)',
    },
  },
  scheduledSend: {
    sendNow: 'Enviar agora',
    sameDay: 'No início da tarefa',
    dayBefore: 'dia antes',
    daysBefore: 'dias antes',
    weekBefore: '1 semana antes',
    monthBefore: '1 mês antes',
    blockTitle: 'Programar envio da tarefa',
    blockDescription: 'Define quantos dias antes do início da tarefa será enviada ao responsável',
    statsLabel: 'Programadas',
    scheduled: 'Programada',
    onboardingModal: {
      title: 'Agora você pode programar o envio das suas tarefas',
      description:
        'Agora você pode decidir quando o operador receberá a tarefa: no mesmo dia ou com antecedência, para melhorar o planejamento e a execução.',
      primaryButton: 'Entendido',
      secondaryButton: 'Descubra como funciona',
      helpCenterUrl:
        'https://help.mydatascope.com/pt-BR/articles/14536340-programacao-de-tarefas-atribuidas',
    },
    tooltip: {
      sendNow: 'A tarefa será enviada hoje',
      sameDay: 'A tarefa será enviada no início da tarefa',
      nDaysBefore: 'A tarefa será enviada em {{dates}}',
      sentOn: 'A tarefa foi enviada em {{dates}}',
      disabledSingular: '{{count}} data selecionada não permite programar este envio: {{dates}}',
      disabledPlural: '{{count}} datas selecionadas não permitem programar este envio: {{dates}}',
      noStartDate: 'Selecione ao menos uma data e hora de início',
    },
  },
};
